import type { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
export type AccountKeySpecifier = ('accountNumber' | 'consignmentId' | 'customerName' | 'elabelTokenGeneratedOn' | 'elabelTokenNumber' | 'elableReferenceNumber' | 'elableReferenceNumberUpdatedOn' | 'emailId' | 'fromAddress' | 'fromDpid' | 'houseNumber' | 'phoneNumber' | 'recycle' | 'return' | 'returnBoxesCount' | 'siteCode' | 'toAddress' | 'toAddressId' | 'toContactName' | 'toContactNumber' | 'toDpid' | 'trackingID' | 'trackingIDUpdatedOn' | 'workOrderNumber' | AccountKeySpecifier)[];
export type AccountFieldPolicy = {
	accountNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	consignmentId?: FieldPolicy<any> | FieldReadFunction<any>,
	customerName?: FieldPolicy<any> | FieldReadFunction<any>,
	elabelTokenGeneratedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	elabelTokenNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	elableReferenceNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	elableReferenceNumberUpdatedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	emailId?: FieldPolicy<any> | FieldReadFunction<any>,
	fromAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	fromDpid?: FieldPolicy<any> | FieldReadFunction<any>,
	houseNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	recycle?: FieldPolicy<any> | FieldReadFunction<any>,
	return?: FieldPolicy<any> | FieldReadFunction<any>,
	returnBoxesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	siteCode?: FieldPolicy<any> | FieldReadFunction<any>,
	toAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	toAddressId?: FieldPolicy<any> | FieldReadFunction<any>,
	toContactName?: FieldPolicy<any> | FieldReadFunction<any>,
	toContactNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	toDpid?: FieldPolicy<any> | FieldReadFunction<any>,
	trackingID?: FieldPolicy<any> | FieldReadFunction<any>,
	trackingIDUpdatedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	workOrderNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdMenuKeySpecifier = ('footerCopyRight' | 'internalName' | 'menuItems' | 'menuSections' | 'tags' | AdMenuKeySpecifier)[];
export type AdMenuFieldPolicy = {
	footerCopyRight?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItems?: FieldPolicy<any> | FieldReadFunction<any>,
	menuSections?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdMenuItemListItemKeySpecifier = ('internalName' | 'itemIcon' | 'itemUrl' | 'publicName' | 'sectionName' | AdMenuItemListItemKeySpecifier)[];
export type AdMenuItemListItemFieldPolicy = {
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	itemIcon?: FieldPolicy<any> | FieldReadFunction<any>,
	itemUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	publicName?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdMenuItemListsKeySpecifier = ('internalName' | 'itemIcon' | 'itemUrl' | 'name' | 'publicName' | AdMenuItemListsKeySpecifier)[];
export type AdMenuItemListsFieldPolicy = {
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	itemIcon?: FieldPolicy<any> | FieldReadFunction<any>,
	itemUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	publicName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdMenuListKeySpecifier = ('footerCopyright' | 'internalName' | 'menuSections' | 'slug' | AdMenuListKeySpecifier)[];
export type AdMenuListFieldPolicy = {
	footerCopyright?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	menuSections?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdcombinedMenuKeySpecifier = ('itemUrl' | 'publicName' | 'sectionLinks' | 'sectionName' | 'slug' | AdcombinedMenuKeySpecifier)[];
export type AdcombinedMenuFieldPolicy = {
	itemUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	publicName?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionName?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdvResourceSetKeySpecifier = ('formSubTitle' | 'formTitle' | 'internalName' | 'resources' | AdvResourceSetKeySpecifier)[];
export type AdvResourceSetFieldPolicy = {
	formSubTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	formTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	resources?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdvResourcesKeySpecifier = ('key' | 'required' | 'value' | AdvResourcesKeySpecifier)[];
export type AdvResourcesFieldPolicy = {
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	required?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdvertisingComponentCardCollectionsKeySpecifier = ('componentCards' | 'internalName' | AdvertisingComponentCardCollectionsKeySpecifier)[];
export type AdvertisingComponentCardCollectionsFieldPolicy = {
	componentCards?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdvertisingComponentCardSectionsKeySpecifier = ('brightCoveVideoExperienceId' | 'brightCoveVideoId' | 'cardDescription' | 'cardDescriptionTextAlignment' | 'cardDetailedDescription' | 'cardDetailedDescriptionAlignment' | 'cardImageLinkUrl' | 'cardImagePosition' | 'cardImageUrl' | 'cardSubTitle' | 'cardTitle' | 'cardTitlePosition' | 'heading' | 'imageLinkFile' | 'linkDocument' | 'linkText' | 'linkUrl' | 'links' | AdvertisingComponentCardSectionsKeySpecifier)[];
export type AdvertisingComponentCardSectionsFieldPolicy = {
	brightCoveVideoExperienceId?: FieldPolicy<any> | FieldReadFunction<any>,
	brightCoveVideoId?: FieldPolicy<any> | FieldReadFunction<any>,
	cardDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	cardDescriptionTextAlignment?: FieldPolicy<any> | FieldReadFunction<any>,
	cardDetailedDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	cardDetailedDescriptionAlignment?: FieldPolicy<any> | FieldReadFunction<any>,
	cardImageLinkUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	cardImagePosition?: FieldPolicy<any> | FieldReadFunction<any>,
	cardImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	cardSubTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	cardTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	cardTitlePosition?: FieldPolicy<any> | FieldReadFunction<any>,
	heading?: FieldPolicy<any> | FieldReadFunction<any>,
	imageLinkFile?: FieldPolicy<any> | FieldReadFunction<any>,
	linkDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	linkText?: FieldPolicy<any> | FieldReadFunction<any>,
	linkUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	links?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdvertisingComponentCardsKeySpecifier = ('cardDescription' | 'cardImageLinkUrl' | 'cardImagePosition' | 'cardImageUrl' | 'cardSubTitle' | 'cardTitle' | 'cardTitlePosition' | 'componentCardCollection' | 'contentType' | 'galleryImages' | 'iframeSrc' | 'imageLinkFile' | 'imgaeName' | 'internalName' | 'isSlider' | 'linkText' | 'linkUrl' | 'links' | 'popupcards' | AdvertisingComponentCardsKeySpecifier)[];
export type AdvertisingComponentCardsFieldPolicy = {
	cardDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	cardImageLinkUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	cardImagePosition?: FieldPolicy<any> | FieldReadFunction<any>,
	cardImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	cardSubTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	cardTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	cardTitlePosition?: FieldPolicy<any> | FieldReadFunction<any>,
	componentCardCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentType?: FieldPolicy<any> | FieldReadFunction<any>,
	galleryImages?: FieldPolicy<any> | FieldReadFunction<any>,
	iframeSrc?: FieldPolicy<any> | FieldReadFunction<any>,
	imageLinkFile?: FieldPolicy<any> | FieldReadFunction<any>,
	imgaeName?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	isSlider?: FieldPolicy<any> | FieldReadFunction<any>,
	linkText?: FieldPolicy<any> | FieldReadFunction<any>,
	linkUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	links?: FieldPolicy<any> | FieldReadFunction<any>,
	popupcards?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdvertisingComposePageKeySpecifier = ('content' | 'heading' | 'internalName' | 'pageTitle' | 'seo' | 'slug' | 'subMenu' | AdvertisingComposePageKeySpecifier)[];
export type AdvertisingComposePageFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	heading?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	pageTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	seo?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	subMenu?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdvertisingContentsKeySpecifier = ('bannerContent' | 'componentCardDisplayTile' | 'componentCardSectionTitle' | 'componentCards' | 'contentType' | 'freeFormContent' | 'internalName' | 'isSlider' | 'menu' | 'popupcards' | 'railContent' | 'resourceSet' | AdvertisingContentsKeySpecifier)[];
export type AdvertisingContentsFieldPolicy = {
	bannerContent?: FieldPolicy<any> | FieldReadFunction<any>,
	componentCardDisplayTile?: FieldPolicy<any> | FieldReadFunction<any>,
	componentCardSectionTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	componentCards?: FieldPolicy<any> | FieldReadFunction<any>,
	contentType?: FieldPolicy<any> | FieldReadFunction<any>,
	freeFormContent?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	isSlider?: FieldPolicy<any> | FieldReadFunction<any>,
	menu?: FieldPolicy<any> | FieldReadFunction<any>,
	popupcards?: FieldPolicy<any> | FieldReadFunction<any>,
	railContent?: FieldPolicy<any> | FieldReadFunction<any>,
	resourceSet?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdvertisingFreeFormContentsKeySpecifier = ('backgroundImage' | 'content' | 'heading' | 'headingBackgroundGradientColor' | 'headingTextPosition' | 'internalName' | 'logoImage' | 'subHeading' | 'videoUrl' | AdvertisingFreeFormContentsKeySpecifier)[];
export type AdvertisingFreeFormContentsFieldPolicy = {
	backgroundImage?: FieldPolicy<any> | FieldReadFunction<any>,
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	heading?: FieldPolicy<any> | FieldReadFunction<any>,
	headingBackgroundGradientColor?: FieldPolicy<any> | FieldReadFunction<any>,
	headingTextPosition?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	logoImage?: FieldPolicy<any> | FieldReadFunction<any>,
	subHeading?: FieldPolicy<any> | FieldReadFunction<any>,
	videoUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdvertisingHeroBannerContentsKeySpecifier = ('bannerDescription' | 'bannerImage' | 'bannerTitle' | 'internalName' | 'linkText' | 'linkUrl' | AdvertisingHeroBannerContentsKeySpecifier)[];
export type AdvertisingHeroBannerContentsFieldPolicy = {
	bannerDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	bannerImage?: FieldPolicy<any> | FieldReadFunction<any>,
	bannerTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkText?: FieldPolicy<any> | FieldReadFunction<any>,
	linkUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdvertisingImageClassKeySpecifier = ('contentType' | 'file' | 'height' | 'text' | 'title' | 'url' | 'width' | AdvertisingImageClassKeySpecifier)[];
export type AdvertisingImageClassFieldPolicy = {
	contentType?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	height?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdvertisingLinksKeySpecifier = ('internalName' | 'linkDocument' | 'linkText' | 'linkUrl' | AdvertisingLinksKeySpecifier)[];
export type AdvertisingLinksFieldPolicy = {
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	linkText?: FieldPolicy<any> | FieldReadFunction<any>,
	linkUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdvertisingPopupCardSectionKeySpecifier = ('backgroundGradient' | 'internalName' | 'linkText' | 'linkUrl' | 'popupCard' | 'popupCardDescription' | 'popupCardIconURL' | 'popupCardImageLinkURL' | 'popupCardImageURL' | 'popupCardSubTitle' | 'popupCardTitle' | AdvertisingPopupCardSectionKeySpecifier)[];
export type AdvertisingPopupCardSectionFieldPolicy = {
	backgroundGradient?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkText?: FieldPolicy<any> | FieldReadFunction<any>,
	linkUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	popupCard?: FieldPolicy<any> | FieldReadFunction<any>,
	popupCardDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	popupCardIconURL?: FieldPolicy<any> | FieldReadFunction<any>,
	popupCardImageLinkURL?: FieldPolicy<any> | FieldReadFunction<any>,
	popupCardImageURL?: FieldPolicy<any> | FieldReadFunction<any>,
	popupCardSubTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	popupCardTitle?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdvertisingRailContentSetClassKeySpecifier = ('componentTitle' | 'images' | AdvertisingRailContentSetClassKeySpecifier)[];
export type AdvertisingRailContentSetClassFieldPolicy = {
	componentTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdvertisingSeosKeySpecifier = ('Image' | 'description' | 'excludeLinks' | 'hidePageFromSE' | 'internalName' | 'seoTitle' | 'urlSlug' | AdvertisingSeosKeySpecifier)[];
export type AdvertisingSeosFieldPolicy = {
	Image?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	excludeLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	hidePageFromSE?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	seoTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	urlSlug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdvertisingWebContentsKeySpecifier = ('content' | 'internalName' | AdvertisingWebContentsKeySpecifier)[];
export type AdvertisingWebContentsFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdvertisingbaseImageUrlKeySpecifier = ('description' | 'file' | 'text' | 'title' | 'url' | AdvertisingbaseImageUrlKeySpecifier)[];
export type AdvertisingbaseImageUrlFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ArticalComposeKeySpecifier = ('articleType' | 'date' | 'heading' | 'internalName' | 'linkDocument' | 'linkText' | 'linkUrl' | 'selectCategories' | ArticalComposeKeySpecifier)[];
export type ArticalComposeFieldPolicy = {
	articleType?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	heading?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	linkText?: FieldPolicy<any> | FieldReadFunction<any>,
	linkUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	selectCategories?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ArticleCollectionsKeySpecifier = ('articleType' | 'articlesPerPage' | 'description' | 'headingBackgroundColor' | 'internalName' | 'searchText' | 'sectionTitle' | ArticleCollectionsKeySpecifier)[];
export type ArticleCollectionsFieldPolicy = {
	articleType?: FieldPolicy<any> | FieldReadFunction<any>,
	articlesPerPage?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	headingBackgroundColor?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	searchText?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionTitle?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BMenuItemListsKeySpecifier = ('itemIcon' | 'itemUrl' | 'publicName' | BMenuItemListsKeySpecifier)[];
export type BMenuItemListsFieldPolicy = {
	itemIcon?: FieldPolicy<any> | FieldReadFunction<any>,
	itemUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	publicName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BMenuListKeySpecifier = ('footerCopyright' | 'internalName' | 'menuSections' | BMenuListKeySpecifier)[];
export type BMenuListFieldPolicy = {
	footerCopyright?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	menuSections?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BannerContentsKeySpecifier = ('bannerName' | 'bannerTitle' | 'brightCoveVideoExperienceId' | 'brightCoveVideoId' | 'brightCoveVideoIdMobile' | 'callToActionLink' | 'callToActionLinkSecondary' | 'callToActionSecondaryText' | 'callToActionText' | 'channelOrSponsorLogos' | 'copyrightParagraph' | 'detailParagraph' | 'detailParagraphColumn2' | 'heading' | 'heroBrandBackground' | 'heroImage' | 'heroImageMobile' | 'iframeTitle' | 'iframeUrl' | 'layoutOptions' | 'lozengeText' | BannerContentsKeySpecifier)[];
export type BannerContentsFieldPolicy = {
	bannerName?: FieldPolicy<any> | FieldReadFunction<any>,
	bannerTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	brightCoveVideoExperienceId?: FieldPolicy<any> | FieldReadFunction<any>,
	brightCoveVideoId?: FieldPolicy<any> | FieldReadFunction<any>,
	brightCoveVideoIdMobile?: FieldPolicy<any> | FieldReadFunction<any>,
	callToActionLink?: FieldPolicy<any> | FieldReadFunction<any>,
	callToActionLinkSecondary?: FieldPolicy<any> | FieldReadFunction<any>,
	callToActionSecondaryText?: FieldPolicy<any> | FieldReadFunction<any>,
	callToActionText?: FieldPolicy<any> | FieldReadFunction<any>,
	channelOrSponsorLogos?: FieldPolicy<any> | FieldReadFunction<any>,
	copyrightParagraph?: FieldPolicy<any> | FieldReadFunction<any>,
	detailParagraph?: FieldPolicy<any> | FieldReadFunction<any>,
	detailParagraphColumn2?: FieldPolicy<any> | FieldReadFunction<any>,
	heading?: FieldPolicy<any> | FieldReadFunction<any>,
	heroBrandBackground?: FieldPolicy<any> | FieldReadFunction<any>,
	heroImage?: FieldPolicy<any> | FieldReadFunction<any>,
	heroImageMobile?: FieldPolicy<any> | FieldReadFunction<any>,
	iframeTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	iframeUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	layoutOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	lozengeText?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BillingKeySpecifier = ('accountNumber' | 'activeBroadband' | 'broadbandOnlyAccount' | 'campaigns' | 'currentTotalAmountDueCents' | 'digitalRental' | 'isCustomerInArrears' | 'isCustomerInArrearsThirtyDays' | 'monthlyCharge' | 'occurrenceNotFound' | 'paperLessBilling' | 'pendingArrowUpgrade' | 'pendingBroadband' | 'productSet' | 'products' | 'statementDueDate' | 'summerset' | BillingKeySpecifier)[];
export type BillingFieldPolicy = {
	accountNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	activeBroadband?: FieldPolicy<any> | FieldReadFunction<any>,
	broadbandOnlyAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	campaigns?: FieldPolicy<any> | FieldReadFunction<any>,
	currentTotalAmountDueCents?: FieldPolicy<any> | FieldReadFunction<any>,
	digitalRental?: FieldPolicy<any> | FieldReadFunction<any>,
	isCustomerInArrears?: FieldPolicy<any> | FieldReadFunction<any>,
	isCustomerInArrearsThirtyDays?: FieldPolicy<any> | FieldReadFunction<any>,
	monthlyCharge?: FieldPolicy<any> | FieldReadFunction<any>,
	occurrenceNotFound?: FieldPolicy<any> | FieldReadFunction<any>,
	paperLessBilling?: FieldPolicy<any> | FieldReadFunction<any>,
	pendingArrowUpgrade?: FieldPolicy<any> | FieldReadFunction<any>,
	pendingBroadband?: FieldPolicy<any> | FieldReadFunction<any>,
	productSet?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>,
	statementDueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	summerset?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessCardFileKeySpecifier = ('contentType' | 'fileName' | 'url' | BusinessCardFileKeySpecifier)[];
export type BusinessCardFileFieldPolicy = {
	contentType?: FieldPolicy<any> | FieldReadFunction<any>,
	fileName?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessCardImageKeySpecifier = ('description' | 'file' | 'title' | BusinessCardImageKeySpecifier)[];
export type BusinessCardImageFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessCardsKeySpecifier = ('description' | 'gradientColor' | 'imageUrl' | 'internalName' | 'linkText' | 'linkUrl' | 'title' | BusinessCardsKeySpecifier)[];
export type BusinessCardsFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	gradientColor?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkText?: FieldPolicy<any> | FieldReadFunction<any>,
	linkUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessCombinedMenuKeySpecifier = ('itemIcon' | 'itemUrl' | 'publicName' | 'sectionLinks' | 'sectionName' | 'slug' | BusinessCombinedMenuKeySpecifier)[];
export type BusinessCombinedMenuFieldPolicy = {
	itemIcon?: FieldPolicy<any> | FieldReadFunction<any>,
	itemUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	publicName?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionName?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessComposeContentKeySpecifier = ('businessContent' | 'internalName' | 'sitemap' | BusinessComposeContentKeySpecifier)[];
export type BusinessComposeContentFieldPolicy = {
	businessContent?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	sitemap?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessComposePageKeySpecifier = ('contactUsSectionRequired' | 'content' | 'internalName' | 'pageTitle' | 'requestACallBackFormRequired' | 'seo' | 'slug' | 'subMenu' | BusinessComposePageKeySpecifier)[];
export type BusinessComposePageFieldPolicy = {
	contactUsSectionRequired?: FieldPolicy<any> | FieldReadFunction<any>,
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	pageTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	requestACallBackFormRequired?: FieldPolicy<any> | FieldReadFunction<any>,
	seo?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	subMenu?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessContentKeySpecifier = ('accordionTitle' | 'backgroundVideoId' | 'bannerImage' | 'bannerPhoneNumber' | 'bannerSubTitle' | 'bannerTitle' | 'componentSectionTitle' | 'components' | 'content' | 'contentType' | 'description' | 'displayTile' | 'exploreLinkText' | 'exploreLinkUrl' | 'exploreScrollContent' | 'exploreScrollHeading' | 'formSubTitle' | 'formTitle' | 'heading' | 'headingPosition' | 'iframeUrl' | 'internalName' | 'isAccordion' | 'isCarousel' | 'isProductBanner' | 'isProductSection' | 'isRelatedContentSection' | 'primaryLinkText' | 'primaryLinkUrl' | 'resources' | 'secondaryLinkText' | 'secondaryLinkVideoId' | 'sectionSubTitle' | BusinessContentKeySpecifier)[];
export type BusinessContentFieldPolicy = {
	accordionTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundVideoId?: FieldPolicy<any> | FieldReadFunction<any>,
	bannerImage?: FieldPolicy<any> | FieldReadFunction<any>,
	bannerPhoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	bannerSubTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	bannerTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	componentSectionTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	components?: FieldPolicy<any> | FieldReadFunction<any>,
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	contentType?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	displayTile?: FieldPolicy<any> | FieldReadFunction<any>,
	exploreLinkText?: FieldPolicy<any> | FieldReadFunction<any>,
	exploreLinkUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	exploreScrollContent?: FieldPolicy<any> | FieldReadFunction<any>,
	exploreScrollHeading?: FieldPolicy<any> | FieldReadFunction<any>,
	formSubTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	formTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	heading?: FieldPolicy<any> | FieldReadFunction<any>,
	headingPosition?: FieldPolicy<any> | FieldReadFunction<any>,
	iframeUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	isAccordion?: FieldPolicy<any> | FieldReadFunction<any>,
	isCarousel?: FieldPolicy<any> | FieldReadFunction<any>,
	isProductBanner?: FieldPolicy<any> | FieldReadFunction<any>,
	isProductSection?: FieldPolicy<any> | FieldReadFunction<any>,
	isRelatedContentSection?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryLinkText?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryLinkUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	resources?: FieldPolicy<any> | FieldReadFunction<any>,
	secondaryLinkText?: FieldPolicy<any> | FieldReadFunction<any>,
	secondaryLinkVideoId?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionSubTitle?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessLinksKeySpecifier = ('linkDocument' | 'linkText' | 'linkUrl' | BusinessLinksKeySpecifier)[];
export type BusinessLinksFieldPolicy = {
	linkDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	linkText?: FieldPolicy<any> | FieldReadFunction<any>,
	linkUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessResourceSetKeySpecifier = ('formSubTitle' | 'formTitle' | 'internalName' | 'resources' | BusinessResourceSetKeySpecifier)[];
export type BusinessResourceSetFieldPolicy = {
	formSubTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	formTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	resources?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessResourcesKeySpecifier = ('key' | 'required' | 'value' | BusinessResourcesKeySpecifier)[];
export type BusinessResourcesFieldPolicy = {
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	required?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CampaignKeySpecifier = ('active' | 'beginDate' | 'endDate' | 'groupCode' | 'isPromotionDescriptionDynamic' | 'promotionCode' | 'promotionDescription' | CampaignKeySpecifier)[];
export type CampaignFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	beginDate?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	groupCode?: FieldPolicy<any> | FieldReadFunction<any>,
	isPromotionDescriptionDynamic?: FieldPolicy<any> | FieldReadFunction<any>,
	promotionCode?: FieldPolicy<any> | FieldReadFunction<any>,
	promotionDescription?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CardContainerKeySpecifier = ('contractDescription' | 'description' | 'detailDescription' | 'explorePopupCopy' | 'horizontalImageUrl' | 'horizontalVideoUrl' | 'iconImageUrl' | 'internalName' | 'linkLabel' | 'linkUrl' | 'logoImageUrl' | 'mainImageUrl' | 'name' | 'popupCards' | 'price' | 'showExplorePopup' | 'sku' | 'videoUrl' | CardContainerKeySpecifier)[];
export type CardContainerFieldPolicy = {
	contractDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	detailDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	explorePopupCopy?: FieldPolicy<any> | FieldReadFunction<any>,
	horizontalImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	horizontalVideoUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	iconImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	linkUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	logoImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	mainImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	popupCards?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	showExplorePopup?: FieldPolicy<any> | FieldReadFunction<any>,
	sku?: FieldPolicy<any> | FieldReadFunction<any>,
	videoUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChannelSetDetailsKeySpecifier = ('fields' | 'sys' | ChannelSetDetailsKeySpecifier)[];
export type ChannelSetDetailsFieldPolicy = {
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChannelSetItemKeySpecifier = ('detailInformation' | 'images' | 'title' | ChannelSetItemKeySpecifier)[];
export type ChannelSetItemFieldPolicy = {
	detailInformation?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComponentCardClassKeySpecifier = ('cardDescription' | 'cardDescriptionTextAlignment' | 'cardDetailedDescription' | 'cardDetailedDescriptionAlignment' | 'cardImageLinkUrl' | 'cardImagePosition' | 'cardImageUrl' | 'cardSubTitle' | 'cardTitle' | 'contentType' | 'heading' | 'internalName' | 'isSlider' | 'linkText' | 'linkUrl' | 'links' | ComponentCardClassKeySpecifier)[];
export type ComponentCardClassFieldPolicy = {
	cardDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	cardDescriptionTextAlignment?: FieldPolicy<any> | FieldReadFunction<any>,
	cardDetailedDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	cardDetailedDescriptionAlignment?: FieldPolicy<any> | FieldReadFunction<any>,
	cardImageLinkUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	cardImagePosition?: FieldPolicy<any> | FieldReadFunction<any>,
	cardImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	cardSubTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	cardTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	contentType?: FieldPolicy<any> | FieldReadFunction<any>,
	heading?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	isSlider?: FieldPolicy<any> | FieldReadFunction<any>,
	linkText?: FieldPolicy<any> | FieldReadFunction<any>,
	linkUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	links?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComponentCardCollectionsKeySpecifier = ('componentCards' | 'internalName' | ComponentCardCollectionsKeySpecifier)[];
export type ComponentCardCollectionsFieldPolicy = {
	componentCards?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComponentCardSectionKeySpecifier = ('componentCardDisplayTile' | 'componentCardSectionTitle' | 'componentCards' | 'contentType' | 'internalName' | 'isCarousel' | ComponentCardSectionKeySpecifier)[];
export type ComponentCardSectionFieldPolicy = {
	componentCardDisplayTile?: FieldPolicy<any> | FieldReadFunction<any>,
	componentCardSectionTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	componentCards?: FieldPolicy<any> | FieldReadFunction<any>,
	contentType?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	isCarousel?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComponentCardSectionsKeySpecifier = ('LinksCollection' | 'backgroundGradientColor' | 'brightCoveVideoExperienceId' | 'brightCoveVideoId' | 'cardDescription' | 'cardDescriptionTextAlignment' | 'cardDetailedDescription' | 'cardDetailedDescriptionAlignment' | 'cardImageLinkUrl' | 'cardImagePosition' | 'cardImageUrl' | 'cardSubTitle' | 'cardTitle' | 'footnoteText' | 'heading' | 'iframeSourceUrl' | 'iframeTitle' | 'imageType' | 'linkAlignmentPosition' | 'linkDocument' | 'linkText' | 'linkUrl' | 'links' | 'subTitleAlignmentPosition' | 'titleAlignmentPosition' | ComponentCardSectionsKeySpecifier)[];
export type ComponentCardSectionsFieldPolicy = {
	LinksCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundGradientColor?: FieldPolicy<any> | FieldReadFunction<any>,
	brightCoveVideoExperienceId?: FieldPolicy<any> | FieldReadFunction<any>,
	brightCoveVideoId?: FieldPolicy<any> | FieldReadFunction<any>,
	cardDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	cardDescriptionTextAlignment?: FieldPolicy<any> | FieldReadFunction<any>,
	cardDetailedDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	cardDetailedDescriptionAlignment?: FieldPolicy<any> | FieldReadFunction<any>,
	cardImageLinkUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	cardImagePosition?: FieldPolicy<any> | FieldReadFunction<any>,
	cardImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	cardSubTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	cardTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	footnoteText?: FieldPolicy<any> | FieldReadFunction<any>,
	heading?: FieldPolicy<any> | FieldReadFunction<any>,
	iframeSourceUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	iframeTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	imageType?: FieldPolicy<any> | FieldReadFunction<any>,
	linkAlignmentPosition?: FieldPolicy<any> | FieldReadFunction<any>,
	linkDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	linkText?: FieldPolicy<any> | FieldReadFunction<any>,
	linkUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	links?: FieldPolicy<any> | FieldReadFunction<any>,
	subTitleAlignmentPosition?: FieldPolicy<any> | FieldReadFunction<any>,
	titleAlignmentPosition?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComponentCardsKeySpecifier = ('LinksCollection' | 'backgroundGradientColor' | 'brightCoveVideoExperienceId' | 'brightCoveVideoId' | 'cardDescription' | 'cardDescriptionTextAlignment' | 'cardDetailedDescription' | 'cardDetailedDescriptionAlignment' | 'cardImageLinkUrl' | 'cardImagePosition' | 'cardImageUrl' | 'cardSubTitle' | 'cardTitle' | 'componentCardCollection' | 'contentType' | 'footnoteText' | 'heading' | 'imageType' | 'internalName' | 'isSlider' | 'linkAlignmentPosition' | 'linkDocument' | 'linkText' | 'linkUrl' | 'links' | 'popupcards' | 'subTitleAlignmentPosition' | 'titleAlignmentPosition' | ComponentCardsKeySpecifier)[];
export type ComponentCardsFieldPolicy = {
	LinksCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundGradientColor?: FieldPolicy<any> | FieldReadFunction<any>,
	brightCoveVideoExperienceId?: FieldPolicy<any> | FieldReadFunction<any>,
	brightCoveVideoId?: FieldPolicy<any> | FieldReadFunction<any>,
	cardDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	cardDescriptionTextAlignment?: FieldPolicy<any> | FieldReadFunction<any>,
	cardDetailedDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	cardDetailedDescriptionAlignment?: FieldPolicy<any> | FieldReadFunction<any>,
	cardImageLinkUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	cardImagePosition?: FieldPolicy<any> | FieldReadFunction<any>,
	cardImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	cardSubTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	cardTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	componentCardCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	contentType?: FieldPolicy<any> | FieldReadFunction<any>,
	footnoteText?: FieldPolicy<any> | FieldReadFunction<any>,
	heading?: FieldPolicy<any> | FieldReadFunction<any>,
	imageType?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	isSlider?: FieldPolicy<any> | FieldReadFunction<any>,
	linkAlignmentPosition?: FieldPolicy<any> | FieldReadFunction<any>,
	linkDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	linkText?: FieldPolicy<any> | FieldReadFunction<any>,
	linkUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	links?: FieldPolicy<any> | FieldReadFunction<any>,
	popupcards?: FieldPolicy<any> | FieldReadFunction<any>,
	subTitleAlignmentPosition?: FieldPolicy<any> | FieldReadFunction<any>,
	titleAlignmentPosition?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComponentsKeySpecifier = ('autoplay' | 'backgroundGradientColor' | 'brightcoveVideoId' | 'cardDescription' | 'cardTitle' | 'cards' | 'contentOverImage' | 'contentType' | 'footNoteText' | 'imageLinkDocument' | 'imageLinkUrl' | 'imagePosition' | 'imageType' | 'imageUrl' | 'images' | 'internalName' | 'isSlider' | 'linkText' | 'links' | 'logoImage' | ComponentsKeySpecifier)[];
export type ComponentsFieldPolicy = {
	autoplay?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundGradientColor?: FieldPolicy<any> | FieldReadFunction<any>,
	brightcoveVideoId?: FieldPolicy<any> | FieldReadFunction<any>,
	cardDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	cardTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	cards?: FieldPolicy<any> | FieldReadFunction<any>,
	contentOverImage?: FieldPolicy<any> | FieldReadFunction<any>,
	contentType?: FieldPolicy<any> | FieldReadFunction<any>,
	footNoteText?: FieldPolicy<any> | FieldReadFunction<any>,
	imageLinkDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	imageLinkUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	imagePosition?: FieldPolicy<any> | FieldReadFunction<any>,
	imageType?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	isSlider?: FieldPolicy<any> | FieldReadFunction<any>,
	linkText?: FieldPolicy<any> | FieldReadFunction<any>,
	links?: FieldPolicy<any> | FieldReadFunction<any>,
	logoImage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComposePageKeySpecifier = ('content' | 'heading' | 'name' | 'seo' | 'slug' | 'subMenu' | 'title' | ComposePageKeySpecifier)[];
export type ComposePageFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	heading?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	seo?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	subMenu?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactInfoKeySpecifier = ('content' | 'heading' | 'internalName' | 'subHeading' | ContactInfoKeySpecifier)[];
export type ContactInfoFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	heading?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	subHeading?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContentInfoKeySpecifier = ('type' | 'value' | ContentInfoKeySpecifier)[];
export type ContentInfoFieldPolicy = {
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContentModelsFieldsKeySpecifier = ('fields' | 'sys' | ContentModelsFieldsKeySpecifier)[];
export type ContentModelsFieldsFieldPolicy = {
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContentModelsListKeySpecifier = ('alignmentOfInfoContent' | 'alignmentOfVideoImage' | 'brightCoverVideoIdDesktop' | 'brightCoverVideoIdMobile' | 'catalogMembers' | 'classNameReference' | 'contentModelType' | 'contentRails' | 'ctaButtonOneColorVariant' | 'ctaButtonOneLink' | 'ctaButtonOneText' | 'ctaButtonTwoColorVariant' | 'ctaButtonTwoLink' | 'ctaButtonTwoText' | 'ctaMoreInfoColorVariant' | 'ctaMoreInfoImage' | 'ctaMoreInfoLink' | 'ctaMoreInfoText' | 'description' | 'disableGradientOverlay' | 'firstName' | 'headingH' | 'image' | 'imageDesktop' | 'imageMobile' | 'imagePosition' | 'imageTablet' | 'images' | 'internalName' | 'landscapeImage' | 'lastName' | 'layoutOption' | 'link' | 'moreInfo' | 'productCards' | 'profileImage' | 'railType' | 'rating' | 'shortDetails' | 'shortOfInformation' | 'synopsesImages' | 'termsAndConditionsCaption' | 'testHeaders' | 'tileImages' | 'title' | 'titleH' | 'titleImage' | ContentModelsListKeySpecifier)[];
export type ContentModelsListFieldPolicy = {
	alignmentOfInfoContent?: FieldPolicy<any> | FieldReadFunction<any>,
	alignmentOfVideoImage?: FieldPolicy<any> | FieldReadFunction<any>,
	brightCoverVideoIdDesktop?: FieldPolicy<any> | FieldReadFunction<any>,
	brightCoverVideoIdMobile?: FieldPolicy<any> | FieldReadFunction<any>,
	catalogMembers?: FieldPolicy<any> | FieldReadFunction<any>,
	classNameReference?: FieldPolicy<any> | FieldReadFunction<any>,
	contentModelType?: FieldPolicy<any> | FieldReadFunction<any>,
	contentRails?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaButtonOneColorVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaButtonOneLink?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaButtonOneText?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaButtonTwoColorVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaButtonTwoLink?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaButtonTwoText?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaMoreInfoColorVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaMoreInfoImage?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaMoreInfoLink?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaMoreInfoText?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	disableGradientOverlay?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	headingH?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	imageDesktop?: FieldPolicy<any> | FieldReadFunction<any>,
	imageMobile?: FieldPolicy<any> | FieldReadFunction<any>,
	imagePosition?: FieldPolicy<any> | FieldReadFunction<any>,
	imageTablet?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	landscapeImage?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	layoutOption?: FieldPolicy<any> | FieldReadFunction<any>,
	link?: FieldPolicy<any> | FieldReadFunction<any>,
	moreInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	productCards?: FieldPolicy<any> | FieldReadFunction<any>,
	profileImage?: FieldPolicy<any> | FieldReadFunction<any>,
	railType?: FieldPolicy<any> | FieldReadFunction<any>,
	rating?: FieldPolicy<any> | FieldReadFunction<any>,
	shortDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	shortOfInformation?: FieldPolicy<any> | FieldReadFunction<any>,
	synopsesImages?: FieldPolicy<any> | FieldReadFunction<any>,
	termsAndConditionsCaption?: FieldPolicy<any> | FieldReadFunction<any>,
	testHeaders?: FieldPolicy<any> | FieldReadFunction<any>,
	tileImages?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	titleH?: FieldPolicy<any> | FieldReadFunction<any>,
	titleImage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContentsKeySpecifier = ('articleCollection' | 'bannerContent' | 'bannerName' | 'bgTitle' | 'cardPanel' | 'componentCardDisplayTile' | 'componentCardSectionTitle' | 'componentCards' | 'contentType' | 'freeformContent' | 'isCarousel' | 'isExpandable' | 'leadsContent' | 'logoContentAccordion' | 'referenceId' | 'rollingBanner' | 'sitemap' | 'slug' | 'subTitle' | 'subTitleTextAlignment' | 'terms' | 'title' | 'titleBackgroundGradientColor' | 'titleTextAlignment' | 'visibility' | ContentsKeySpecifier)[];
export type ContentsFieldPolicy = {
	articleCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	bannerContent?: FieldPolicy<any> | FieldReadFunction<any>,
	bannerName?: FieldPolicy<any> | FieldReadFunction<any>,
	bgTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	cardPanel?: FieldPolicy<any> | FieldReadFunction<any>,
	componentCardDisplayTile?: FieldPolicy<any> | FieldReadFunction<any>,
	componentCardSectionTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	componentCards?: FieldPolicy<any> | FieldReadFunction<any>,
	contentType?: FieldPolicy<any> | FieldReadFunction<any>,
	freeformContent?: FieldPolicy<any> | FieldReadFunction<any>,
	isCarousel?: FieldPolicy<any> | FieldReadFunction<any>,
	isExpandable?: FieldPolicy<any> | FieldReadFunction<any>,
	leadsContent?: FieldPolicy<any> | FieldReadFunction<any>,
	logoContentAccordion?: FieldPolicy<any> | FieldReadFunction<any>,
	referenceId?: FieldPolicy<any> | FieldReadFunction<any>,
	rollingBanner?: FieldPolicy<any> | FieldReadFunction<any>,
	sitemap?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	subTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	subTitleTextAlignment?: FieldPolicy<any> | FieldReadFunction<any>,
	terms?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	titleBackgroundGradientColor?: FieldPolicy<any> | FieldReadFunction<any>,
	titleTextAlignment?: FieldPolicy<any> | FieldReadFunction<any>,
	visibility?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CouponKeySpecifier = ('couponCode' | 'custom1' | 'custom2' | 'custom3' | 'custom4' | 'custom5' | 'description' | 'id' | 'name' | CouponKeySpecifier)[];
export type CouponFieldPolicy = {
	couponCode?: FieldPolicy<any> | FieldReadFunction<any>,
	custom1?: FieldPolicy<any> | FieldReadFunction<any>,
	custom2?: FieldPolicy<any> | FieldReadFunction<any>,
	custom3?: FieldPolicy<any> | FieldReadFunction<any>,
	custom4?: FieldPolicy<any> | FieldReadFunction<any>,
	custom5?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateLabelResponseKeySpecifier = ('consignment_id' | 'consignment_status' | 'fromAddress' | 'message_id' | 'success' | 'toAddress' | 'tracking_id' | CreateLabelResponseKeySpecifier)[];
export type CreateLabelResponseFieldPolicy = {
	consignment_id?: FieldPolicy<any> | FieldReadFunction<any>,
	consignment_status?: FieldPolicy<any> | FieldReadFunction<any>,
	fromAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	message_id?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>,
	toAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	tracking_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerKeySpecifier = ('accountNumber' | 'category' | 'deliveryDetails' | 'externalAccountId' | 'fusionRegion' | 'houseNumber' | 'paperLessBilling' | 'parties' | 'privacyList' | 'secondaryLocatorCode' | 'serviceAddress' | 'serviceContactEmail' | 'tuiAddressCode' | 'type' | CustomerKeySpecifier)[];
export type CustomerFieldPolicy = {
	accountNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	externalAccountId?: FieldPolicy<any> | FieldReadFunction<any>,
	fusionRegion?: FieldPolicy<any> | FieldReadFunction<any>,
	houseNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	paperLessBilling?: FieldPolicy<any> | FieldReadFunction<any>,
	parties?: FieldPolicy<any> | FieldReadFunction<any>,
	privacyList?: FieldPolicy<any> | FieldReadFunction<any>,
	secondaryLocatorCode?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceContactEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	tuiAddressCode?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeviceInfoKeySpecifier = ('fields' | DeviceInfoKeySpecifier)[];
export type DeviceInfoFieldPolicy = {
	fields?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeviceInfoFieldsKeySpecifier = ('bottomTitle' | 'infoTitle' | 'members' | 'title' | 'titleImage' | DeviceInfoFieldsKeySpecifier)[];
export type DeviceInfoFieldsFieldPolicy = {
	bottomTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	infoTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	members?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	titleImage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EligibilityOfferKeySpecifier = ('additionalPackages' | 'applies' | 'campaign' | 'campaignDescription' | 'category' | 'client' | 'discountServiceCode' | 'displayPromptOffer' | 'eligibilityExcludeCampaign' | 'eligibilityExcludeServiceCode' | 'eligibilityID' | 'eligibilityIncludeCampaign' | 'eligibilityIncludeServiceCode' | 'eligibleFor' | 'offerPackages' | 'overrideCurrentOffer' | 'priority' | 'production' | 'promotion' | 'qualifies' | 'recordType' | 'subscriberKey' | 'validToDate' | EligibilityOfferKeySpecifier)[];
export type EligibilityOfferFieldPolicy = {
	additionalPackages?: FieldPolicy<any> | FieldReadFunction<any>,
	applies?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	campaignDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	client?: FieldPolicy<any> | FieldReadFunction<any>,
	discountServiceCode?: FieldPolicy<any> | FieldReadFunction<any>,
	displayPromptOffer?: FieldPolicy<any> | FieldReadFunction<any>,
	eligibilityExcludeCampaign?: FieldPolicy<any> | FieldReadFunction<any>,
	eligibilityExcludeServiceCode?: FieldPolicy<any> | FieldReadFunction<any>,
	eligibilityID?: FieldPolicy<any> | FieldReadFunction<any>,
	eligibilityIncludeCampaign?: FieldPolicy<any> | FieldReadFunction<any>,
	eligibilityIncludeServiceCode?: FieldPolicy<any> | FieldReadFunction<any>,
	eligibleFor?: FieldPolicy<any> | FieldReadFunction<any>,
	offerPackages?: FieldPolicy<any> | FieldReadFunction<any>,
	overrideCurrentOffer?: FieldPolicy<any> | FieldReadFunction<any>,
	priority?: FieldPolicy<any> | FieldReadFunction<any>,
	production?: FieldPolicy<any> | FieldReadFunction<any>,
	promotion?: FieldPolicy<any> | FieldReadFunction<any>,
	qualifies?: FieldPolicy<any> | FieldReadFunction<any>,
	recordType?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriberKey?: FieldPolicy<any> | FieldReadFunction<any>,
	validToDate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FaqsListDetailsKeySpecifier = ('fields' | 'sys' | FaqsListDetailsKeySpecifier)[];
export type FaqsListDetailsFieldPolicy = {
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FaqsListItemsKeySpecifier = ('answer' | 'question' | FaqsListItemsKeySpecifier)[];
export type FaqsListItemsFieldPolicy = {
	answer?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FreeFormContentKeySpecifier = ('alignmentPosition' | 'backgroundGradientColor' | 'content' | 'heading' | 'iframeTitle' | 'iframeUrl' | 'imageUrl' | 'subHeading' | 'visibility' | FreeFormContentKeySpecifier)[];
export type FreeFormContentFieldPolicy = {
	alignmentPosition?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundGradientColor?: FieldPolicy<any> | FieldReadFunction<any>,
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	heading?: FieldPolicy<any> | FieldReadFunction<any>,
	iframeTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	iframeUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	subHeading?: FieldPolicy<any> | FieldReadFunction<any>,
	visibility?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GlobalFooterKeySpecifier = ('footerCopyright' | 'internalName' | 'menuSections' | GlobalFooterKeySpecifier)[];
export type GlobalFooterFieldPolicy = {
	footerCopyright?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	menuSections?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GlobalMenuItemListsKeySpecifier = ('internalName' | 'itemIcon' | 'itemUrl' | 'name' | 'publicName' | GlobalMenuItemListsKeySpecifier)[];
export type GlobalMenuItemListsFieldPolicy = {
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	itemIcon?: FieldPolicy<any> | FieldReadFunction<any>,
	itemUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	publicName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GlobalMenuListKeySpecifier = ('footerCopyright' | 'internalName' | 'menuSections' | 'slug' | GlobalMenuListKeySpecifier)[];
export type GlobalMenuListFieldPolicy = {
	footerCopyright?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	menuSections?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IconDetailsKeySpecifier = ('text' | 'url' | IconDetailsKeySpecifier)[];
export type IconDetailsFieldPolicy = {
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IconImageKeySpecifier = ('description' | 'iconImageUrl' | 'title' | IconImageKeySpecifier)[];
export type IconImageFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	iconImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IconTempleteDetailsKeySpecifier = ('fields' | 'sys' | IconTempleteDetailsKeySpecifier)[];
export type IconTempleteDetailsFieldPolicy = {
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IconTempleteItemKeySpecifier = ('icon' | 'sys' | 'title' | IconTempleteItemKeySpecifier)[];
export type IconTempleteItemFieldPolicy = {
	icon?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImageDetailsKeySpecifier = ('text' | 'url' | ImageDetailsKeySpecifier)[];
export type ImageDetailsFieldPolicy = {
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImageUrlKeySpecifier = ('text' | 'url' | ImageUrlKeySpecifier)[];
export type ImageUrlFieldPolicy = {
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LabelKeySpecifier = ('label_generation_status' | 'label_id' | 'tracking_reference' | LabelKeySpecifier)[];
export type LabelFieldPolicy = {
	label_generation_status?: FieldPolicy<any> | FieldReadFunction<any>,
	label_id?: FieldPolicy<any> | FieldReadFunction<any>,
	tracking_reference?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LeadsContentKeySpecifier = ('alignment' | 'htmlInput' | 'internalName' | 'pageTarget' | 'scope' | 'sessionExpireDays' | 'timeInSecond' | LeadsContentKeySpecifier)[];
export type LeadsContentFieldPolicy = {
	alignment?: FieldPolicy<any> | FieldReadFunction<any>,
	htmlInput?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	pageTarget?: FieldPolicy<any> | FieldReadFunction<any>,
	scope?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionExpireDays?: FieldPolicy<any> | FieldReadFunction<any>,
	timeInSecond?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LinkClassKeySpecifier = ('internalName' | 'linkDocument' | 'linkText' | 'linkUrl' | LinkClassKeySpecifier)[];
export type LinkClassFieldPolicy = {
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	linkText?: FieldPolicy<any> | FieldReadFunction<any>,
	linkUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LinksKeySpecifier = ('alignmentPosition' | 'backgroundGradientColor' | 'internalName' | 'linkDocument' | 'linkImage' | 'linkImageForLogin' | 'linkText' | 'linkTextForLogin' | 'linkUrl' | 'linkUrlForLogin' | LinksKeySpecifier)[];
export type LinksFieldPolicy = {
	alignmentPosition?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundGradientColor?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	linkImage?: FieldPolicy<any> | FieldReadFunction<any>,
	linkImageForLogin?: FieldPolicy<any> | FieldReadFunction<any>,
	linkText?: FieldPolicy<any> | FieldReadFunction<any>,
	linkTextForLogin?: FieldPolicy<any> | FieldReadFunction<any>,
	linkUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	linkUrlForLogin?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LinksCollectionsKeySpecifier = ('internalName' | 'links' | LinksCollectionsKeySpecifier)[];
export type LinksCollectionsFieldPolicy = {
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	links?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LogoContentAccordionsKeySpecifier = ('content' | 'heading' | 'headingBackgroundColor' | 'internalName' | 'logos' | 'subHeading' | LogoContentAccordionsKeySpecifier)[];
export type LogoContentAccordionsFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	heading?: FieldPolicy<any> | FieldReadFunction<any>,
	headingBackgroundColor?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	logos?: FieldPolicy<any> | FieldReadFunction<any>,
	subHeading?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MediaContentDetailsKeySpecifier = ('fields' | 'sys' | MediaContentDetailsKeySpecifier)[];
export type MediaContentDetailsFieldPolicy = {
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MediaContentItemKeySpecifier = ('description' | 'file' | 'title' | MediaContentItemKeySpecifier)[];
export type MediaContentItemFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MediaItemsKeySpecifier = ('internalName' | 'itemIcon' | 'itemUrl' | 'publicName' | MediaItemsKeySpecifier)[];
export type MediaItemsFieldPolicy = {
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	itemIcon?: FieldPolicy<any> | FieldReadFunction<any>,
	itemUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	publicName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MediaSectionsKeySpecifier = ('internalName' | 'sectionLinks' | 'sectionName' | 'tags' | MediaSectionsKeySpecifier)[];
export type MediaSectionsFieldPolicy = {
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionName?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuKeySpecifier = ('internalName' | 'menuSections' | 'tags' | MenuKeySpecifier)[];
export type MenuFieldPolicy = {
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	menuSections?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemListKeySpecifier = ('internalName' | 'itemIcon' | 'itemUrl' | 'name' | MenuItemListKeySpecifier)[];
export type MenuItemListFieldPolicy = {
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	itemIcon?: FieldPolicy<any> | FieldReadFunction<any>,
	itemUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemListItemKeySpecifier = ('internalName' | 'itemIcon' | 'itemUrl' | 'name' | MenuItemListItemKeySpecifier)[];
export type MenuItemListItemFieldPolicy = {
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	itemIcon?: FieldPolicy<any> | FieldReadFunction<any>,
	itemUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemListsKeySpecifier = ('internalName' | 'itemIcon' | 'itemUrl' | 'name' | MenuItemListsKeySpecifier)[];
export type MenuItemListsFieldPolicy = {
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	itemIcon?: FieldPolicy<any> | FieldReadFunction<any>,
	itemUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemSectionListsKeySpecifier = ('sectionLinks' | 'sectionName' | 'slug' | MenuItemSectionListsKeySpecifier)[];
export type MenuItemSectionListsFieldPolicy = {
	sectionLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionName?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuListKeySpecifier = ('internalName' | 'menuSections' | 'tags' | MenuListKeySpecifier)[];
export type MenuListFieldPolicy = {
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	menuSections?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuSectionListKeySpecifier = ('sectionLinks' | 'sectionName' | 'slug' | MenuSectionListKeySpecifier)[];
export type MenuSectionListFieldPolicy = {
	sectionLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionName?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuSectionListFieldsKeySpecifier = ('fields' | MenuSectionListFieldsKeySpecifier)[];
export type MenuSectionListFieldsFieldPolicy = {
	fields?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuSectionListsKeySpecifier = ('parentMenu' | 'sectionLinks' | 'sectionName' | 'slug' | MenuSectionListsKeySpecifier)[];
export type MenuSectionListsFieldPolicy = {
	parentMenu?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionName?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('createLabel' | 'updateElabel' | 'validateVoucher' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	createLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	updateElabel?: FieldPolicy<any> | FieldReadFunction<any>,
	validateVoucher?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NBJCombinedMenuKeySpecifier = ('itemIcon' | 'itemUrl' | 'name' | 'sectionLinks' | 'sectionName' | 'slug' | 'tooltip' | NBJCombinedMenuKeySpecifier)[];
export type NBJCombinedMenuFieldPolicy = {
	itemIcon?: FieldPolicy<any> | FieldReadFunction<any>,
	itemUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionName?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	tooltip?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NBJComposeComponentItemsKeySpecifier = ('fields' | 'sys' | NBJComposeComponentItemsKeySpecifier)[];
export type NBJComposeComponentItemsFieldPolicy = {
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NBJComposeComponentModelIdKeySpecifier = ('contentType' | 'id' | NBJComposeComponentModelIdKeySpecifier)[];
export type NBJComposeComponentModelIdFieldPolicy = {
	contentType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NBJComposeEntityKeySpecifier = ('sys' | NBJComposeEntityKeySpecifier)[];
export type NBJComposeEntityFieldPolicy = {
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NBJComposeEntityIdKeySpecifier = ('id' | NBJComposeEntityIdKeySpecifier)[];
export type NBJComposeEntityIdFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NBJComposePagesKeySpecifier = ('cartUrl' | 'contentList' | 'internalName' | 'seoMetadata' | 'slug' | 'subMenu' | 'title' | NBJComposePagesKeySpecifier)[];
export type NBJComposePagesFieldPolicy = {
	cartUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	contentList?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	seoMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	subMenu?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NBJComposeTypeDetailsKeySpecifier = ('classNameReference' | 'contentModelType' | NBJComposeTypeDetailsKeySpecifier)[];
export type NBJComposeTypeDetailsFieldPolicy = {
	classNameReference?: FieldPolicy<any> | FieldReadFunction<any>,
	contentModelType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NBJEntityDetailsKeySpecifier = ('contentModelType' | 'fields' | 'internalName' | 'sys' | 'title' | NBJEntityDetailsKeySpecifier)[];
export type NBJEntityDetailsFieldPolicy = {
	contentModelType?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NBJFieldMenuListsKeySpecifier = ('fields' | NBJFieldMenuListsKeySpecifier)[];
export type NBJFieldMenuListsFieldPolicy = {
	fields?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NBJMenuItemListsKeySpecifier = ('itemIcon' | 'itemUrl' | 'name' | 'tooltip' | NBJMenuItemListsKeySpecifier)[];
export type NBJMenuItemListsFieldPolicy = {
	itemIcon?: FieldPolicy<any> | FieldReadFunction<any>,
	itemUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	tooltip?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NBJMenuListKeySpecifier = ('footerCopyright' | 'internalName' | 'menuSections' | 'segmentSnippet' | NBJMenuListKeySpecifier)[];
export type NBJMenuListFieldPolicy = {
	footerCopyright?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	menuSections?: FieldPolicy<any> | FieldReadFunction<any>,
	segmentSnippet?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NBJMenuSectionListsKeySpecifier = ('sectionLinks' | 'sectionName' | 'slug' | NBJMenuSectionListsKeySpecifier)[];
export type NBJMenuSectionListsFieldPolicy = {
	sectionLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionName?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NBJModelsKeySpecifier = ('alignmentOfVideoImage' | 'autoPlay' | 'classNameReference' | 'contentModelType' | 'contentModels' | 'ctaButtonOneColorVariant' | 'ctaButtonOneLink' | 'ctaButtonOneText' | 'ctaButtonTwoColorVariant' | 'ctaButtonTwoLink' | 'ctaButtonTwoText' | 'ctaMoreInfoColorVariant' | 'ctaMoreInfoImage' | 'ctaMoreInfoText' | 'description' | 'faqsList' | 'headingH' | 'imageDesktop' | 'imageMobile' | 'internalName' | 'isScrollBtnEnabled' | 'layoutOption' | 'legalLine' | 'members' | 'playBackLoop' | 'sectionBottomPadding' | 'sectionTopPadding' | 'shortOfInformation' | 'showCarouselView' | 'showCollapseView' | 'showLandscapeView' | 'synopsesImages' | 'tabsColorVariant' | 'termsAndConditionsCaption' | 'titleH' | NBJModelsKeySpecifier)[];
export type NBJModelsFieldPolicy = {
	alignmentOfVideoImage?: FieldPolicy<any> | FieldReadFunction<any>,
	autoPlay?: FieldPolicy<any> | FieldReadFunction<any>,
	classNameReference?: FieldPolicy<any> | FieldReadFunction<any>,
	contentModelType?: FieldPolicy<any> | FieldReadFunction<any>,
	contentModels?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaButtonOneColorVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaButtonOneLink?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaButtonOneText?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaButtonTwoColorVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaButtonTwoLink?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaButtonTwoText?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaMoreInfoColorVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaMoreInfoImage?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaMoreInfoText?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	faqsList?: FieldPolicy<any> | FieldReadFunction<any>,
	headingH?: FieldPolicy<any> | FieldReadFunction<any>,
	imageDesktop?: FieldPolicy<any> | FieldReadFunction<any>,
	imageMobile?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	isScrollBtnEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	layoutOption?: FieldPolicy<any> | FieldReadFunction<any>,
	legalLine?: FieldPolicy<any> | FieldReadFunction<any>,
	members?: FieldPolicy<any> | FieldReadFunction<any>,
	playBackLoop?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionBottomPadding?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionTopPadding?: FieldPolicy<any> | FieldReadFunction<any>,
	shortOfInformation?: FieldPolicy<any> | FieldReadFunction<any>,
	showCarouselView?: FieldPolicy<any> | FieldReadFunction<any>,
	showCollapseView?: FieldPolicy<any> | FieldReadFunction<any>,
	showLandscapeView?: FieldPolicy<any> | FieldReadFunction<any>,
	synopsesImages?: FieldPolicy<any> | FieldReadFunction<any>,
	tabsColorVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	termsAndConditionsCaption?: FieldPolicy<any> | FieldReadFunction<any>,
	titleH?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NBJNestedMenuSectionListsKeySpecifier = ('itemIcon' | 'itemUrl' | 'name' | 'sectionLinks' | 'sectionName' | 'slug' | 'tooltip' | NBJNestedMenuSectionListsKeySpecifier)[];
export type NBJNestedMenuSectionListsFieldPolicy = {
	itemIcon?: FieldPolicy<any> | FieldReadFunction<any>,
	itemUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionName?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	tooltip?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NBJProductAndTabFieldsKeySpecifier = ('fields' | 'sys' | NBJProductAndTabFieldsKeySpecifier)[];
export type NBJProductAndTabFieldsFieldPolicy = {
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NBJProductCardFieldsKeySpecifier = ('catalogMembers' | 'contentRails' | 'internalName' | 'members' | 'moreInfo' | 'name' | 'railType' | NBJProductCardFieldsKeySpecifier)[];
export type NBJProductCardFieldsFieldPolicy = {
	catalogMembers?: FieldPolicy<any> | FieldReadFunction<any>,
	contentRails?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	members?: FieldPolicy<any> | FieldReadFunction<any>,
	moreInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	railType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NBJSampleComposePagesKeySpecifier = ('contentList' | 'internalName' | 'seoMetadata' | 'slug' | 'title' | NBJSampleComposePagesKeySpecifier)[];
export type NBJSampleComposePagesFieldPolicy = {
	contentList?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	seoMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NBJTermsAndConditionsKeySpecifier = ('fields' | NBJTermsAndConditionsKeySpecifier)[];
export type NBJTermsAndConditionsFieldPolicy = {
	fields?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NBJTermsAndConditionsFieldsKeySpecifier = ('bgTitle' | 'isExpandable' | 'terms' | NBJTermsAndConditionsFieldsKeySpecifier)[];
export type NBJTermsAndConditionsFieldsFieldPolicy = {
	bgTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	isExpandable?: FieldPolicy<any> | FieldReadFunction<any>,
	terms?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NavigationFieldKeySpecifier = ('fields' | NavigationFieldKeySpecifier)[];
export type NavigationFieldFieldPolicy = {
	fields?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NavigationFieldItemsKeySpecifier = ('internalName' | 'itemUrl' | 'name' | NavigationFieldItemsKeySpecifier)[];
export type NavigationFieldItemsFieldPolicy = {
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	itemUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NavigationItemsKeySpecifier = ('itemUrl' | 'name' | NavigationItemsKeySpecifier)[];
export type NavigationItemsFieldPolicy = {
	itemUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NzPostLocationKeySpecifier = ('address' | 'address_id' | 'city' | 'country' | 'createdAt' | 'dpid' | 'email' | 'extraDetails' | 'isActive' | 'phoneNumber' | 'postalCode' | 'postcodePrefix' | 'street' | 'streetType' | 'street_number' | 'suburb' | 'updatedAt' | NzPostLocationKeySpecifier)[];
export type NzPostLocationFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	address_id?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	dpid?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	extraDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	postcodePrefix?: FieldPolicy<any> | FieldReadFunction<any>,
	street?: FieldPolicy<any> | FieldReadFunction<any>,
	streetType?: FieldPolicy<any> | FieldReadFunction<any>,
	street_number?: FieldPolicy<any> | FieldReadFunction<any>,
	suburb?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OfferKeySpecifier = ('accountNumber' | 'offers' | 'subscriberKey' | 'tenure' | OfferKeySpecifier)[];
export type OfferFieldPolicy = {
	accountNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	offers?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriberKey?: FieldPolicy<any> | FieldReadFunction<any>,
	tenure?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OfferingKeySpecifier = ('bookableTime' | 'channel' | 'id' | 'price' | 'showingNumber' | 'showings' | 'time' | 'titleCode' | OfferingKeySpecifier)[];
export type OfferingFieldPolicy = {
	bookableTime?: FieldPolicy<any> | FieldReadFunction<any>,
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	showingNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	showings?: FieldPolicy<any> | FieldReadFunction<any>,
	time?: FieldPolicy<any> | FieldReadFunction<any>,
	titleCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderConfirmationKeySpecifier = ('appLogoLargeSrc' | 'appLogoSmallSrc' | 'buttonCtaName' | 'buttonLink' | 'category' | 'description' | 'header' | 'iconMobileSrc' | 'iconSrc' | 'title' | OrderConfirmationKeySpecifier)[];
export type OrderConfirmationFieldPolicy = {
	appLogoLargeSrc?: FieldPolicy<any> | FieldReadFunction<any>,
	appLogoSmallSrc?: FieldPolicy<any> | FieldReadFunction<any>,
	buttonCtaName?: FieldPolicy<any> | FieldReadFunction<any>,
	buttonLink?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	header?: FieldPolicy<any> | FieldReadFunction<any>,
	iconMobileSrc?: FieldPolicy<any> | FieldReadFunction<any>,
	iconSrc?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PPVKeySpecifier = ('arenas' | 'bought' | 'movies' | PPVKeySpecifier)[];
export type PPVFieldPolicy = {
	arenas?: FieldPolicy<any> | FieldReadFunction<any>,
	bought?: FieldPolicy<any> | FieldReadFunction<any>,
	movies?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PPVBoughtKeySpecifier = ('eventStatus' | 'eventStatusDescription' | 'showingNumber' | 'titleCode' | PPVBoughtKeySpecifier)[];
export type PPVBoughtFieldPolicy = {
	eventStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	eventStatusDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	showingNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	titleCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PPVItemKeySpecifier = ('description' | 'genre' | 'id' | 'imageUrl' | 'offerings' | 'rating' | 'title' | PPVItemKeySpecifier)[];
export type PPVItemFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	genre?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	offerings?: FieldPolicy<any> | FieldReadFunction<any>,
	rating?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ParcelLabelKeySpecifier = ('consignment_id' | 'consignment_status' | 'consignment_url' | 'dangerous_goods_declaration_urls' | 'errors' | 'expiry_date_utc' | 'labels' | 'message_id' | 'page_urls' | 'success' | ParcelLabelKeySpecifier)[];
export type ParcelLabelFieldPolicy = {
	consignment_id?: FieldPolicy<any> | FieldReadFunction<any>,
	consignment_status?: FieldPolicy<any> | FieldReadFunction<any>,
	consignment_url?: FieldPolicy<any> | FieldReadFunction<any>,
	dangerous_goods_declaration_urls?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	expiry_date_utc?: FieldPolicy<any> | FieldReadFunction<any>,
	labels?: FieldPolicy<any> | FieldReadFunction<any>,
	message_id?: FieldPolicy<any> | FieldReadFunction<any>,
	page_urls?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ParcelTrackingKeySpecifier = ('carrier' | 'message_datetime' | 'message_id' | 'service' | 'tracking_events' | 'tracking_reference' | ParcelTrackingKeySpecifier)[];
export type ParcelTrackingFieldPolicy = {
	carrier?: FieldPolicy<any> | FieldReadFunction<any>,
	message_datetime?: FieldPolicy<any> | FieldReadFunction<any>,
	message_id?: FieldPolicy<any> | FieldReadFunction<any>,
	service?: FieldPolicy<any> | FieldReadFunction<any>,
	tracking_events?: FieldPolicy<any> | FieldReadFunction<any>,
	tracking_reference?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PopupCardKeySpecifier = ('internalName' | 'popupCard' | 'popupCardDescription' | 'popupCardIconUrl' | 'popupCardImageUrl' | 'popupCardSubTitle' | 'popupCardTitle' | PopupCardKeySpecifier)[];
export type PopupCardFieldPolicy = {
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	popupCard?: FieldPolicy<any> | FieldReadFunction<any>,
	popupCardDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	popupCardIconUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	popupCardImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	popupCardSubTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	popupCardTitle?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PopupCardSectionKeySpecifier = ('internalName' | 'linkText' | 'linkUrl' | 'popupCard' | 'popupCardDescription' | 'popupCardIconURL' | 'popupCardImageLinkUrl' | 'popupCardImageURL' | 'popupCardSubTitle' | 'popupCardTitle' | PopupCardSectionKeySpecifier)[];
export type PopupCardSectionFieldPolicy = {
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	linkText?: FieldPolicy<any> | FieldReadFunction<any>,
	linkUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	popupCard?: FieldPolicy<any> | FieldReadFunction<any>,
	popupCardDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	popupCardIconURL?: FieldPolicy<any> | FieldReadFunction<any>,
	popupCardImageLinkUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	popupCardImageURL?: FieldPolicy<any> | FieldReadFunction<any>,
	popupCardSubTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	popupCardTitle?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PrequalKeySpecifier = ('addOns' | 'availableProductDetails' | 'broadbandFunnelType' | 'broadbandJourney' | 'broadbandReadyETA' | 'broadbandReadyStatus' | 'isConsentRequired' | 'isFibreAvailable' | 'locationId' | 'modemModel' | 'singleMeshDeviceModel' | 'staticIPProductKey' | PrequalKeySpecifier)[];
export type PrequalFieldPolicy = {
	addOns?: FieldPolicy<any> | FieldReadFunction<any>,
	availableProductDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	broadbandFunnelType?: FieldPolicy<any> | FieldReadFunction<any>,
	broadbandJourney?: FieldPolicy<any> | FieldReadFunction<any>,
	broadbandReadyETA?: FieldPolicy<any> | FieldReadFunction<any>,
	broadbandReadyStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	isConsentRequired?: FieldPolicy<any> | FieldReadFunction<any>,
	isFibreAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	locationId?: FieldPolicy<any> | FieldReadFunction<any>,
	modemModel?: FieldPolicy<any> | FieldReadFunction<any>,
	singleMeshDeviceModel?: FieldPolicy<any> | FieldReadFunction<any>,
	staticIPProductKey?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductKeySpecifier = ('billedPrice' | 'broadbandPriceHold' | 'broadbandStarterDiscount' | 'campaignPrice' | 'categoryId' | 'categoryName' | 'image' | 'name' | 'occurrenceNumber' | 'originalPrice' | 'phantomProduct' | 'productId' | 'quantity' | 'serviceStatus' | 'sku' | 'subscribed' | ProductKeySpecifier)[];
export type ProductFieldPolicy = {
	billedPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	broadbandPriceHold?: FieldPolicy<any> | FieldReadFunction<any>,
	broadbandStarterDiscount?: FieldPolicy<any> | FieldReadFunction<any>,
	campaignPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryId?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryName?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	occurrenceNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	originalPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	phantomProduct?: FieldPolicy<any> | FieldReadFunction<any>,
	productId?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	sku?: FieldPolicy<any> | FieldReadFunction<any>,
	subscribed?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCardDetailsKeySpecifier = ('fields' | 'sys' | ProductCardDetailsKeySpecifier)[];
export type ProductCardDetailsFieldPolicy = {
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCardItemKeySpecifier = ('broadbandSpeedDescription' | 'broadbandSpeedTitle' | 'bulletImage' | 'bulletInfoImage' | 'cardBgColor' | 'catalogId' | 'categories' | 'channelSet' | 'ctaButtonOneColorVariant' | 'ctaButtonOneLink' | 'ctaButtonOneText' | 'ctaButtonThreeColorVariant' | 'ctaButtonThreeLink' | 'ctaButtonThreeText' | 'ctaButtonTwoColorVariant' | 'ctaButtonTwoLink' | 'ctaButtonTwoText' | 'ctaMoreInfoColorVariant' | 'ctaMoreInfoImage' | 'ctaMoreInfoLink' | 'ctaMoreInfoText' | 'customSynopses' | 'description' | 'discountLozengeBackgroundImage' | 'discountLozengeText' | 'discountedPrice' | 'downloadDataSpeed' | 'image' | 'infoList' | 'internalName' | 'landscapeImage' | 'largeThumbnail' | 'legalLine' | 'legalLineForQuickCompare' | 'longDescription' | 'lozengeBackgroundImage' | 'lozengeText' | 'members' | 'moreDetails' | 'name' | 'price' | 'priceFrequencyType' | 'productFeatures' | 'productInfo' | 'productInfoDescription' | 'productKkInfo' | 'productSku' | 'recommendationImage' | 'recomonded' | 'shortDescription' | 'shortOfInformation' | 'shortTitle' | 'slugurl' | 'smallThumbnail' | 'subCategories' | 'synopses' | 'synopsesImages' | 'teamCondition' | 'termsAndConditionsCaption' | 'thumbnail' | 'tileImages' | 'title' | 'titleForBanner' | 'titleImageDesktop' | 'titleImageMobile' | 'tvSpeedImage' | 'type' | 'uploadDataSpeed' | 'wifiUnlimitedImage' | ProductCardItemKeySpecifier)[];
export type ProductCardItemFieldPolicy = {
	broadbandSpeedDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	broadbandSpeedTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	bulletImage?: FieldPolicy<any> | FieldReadFunction<any>,
	bulletInfoImage?: FieldPolicy<any> | FieldReadFunction<any>,
	cardBgColor?: FieldPolicy<any> | FieldReadFunction<any>,
	catalogId?: FieldPolicy<any> | FieldReadFunction<any>,
	categories?: FieldPolicy<any> | FieldReadFunction<any>,
	channelSet?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaButtonOneColorVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaButtonOneLink?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaButtonOneText?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaButtonThreeColorVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaButtonThreeLink?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaButtonThreeText?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaButtonTwoColorVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaButtonTwoLink?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaButtonTwoText?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaMoreInfoColorVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaMoreInfoImage?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaMoreInfoLink?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaMoreInfoText?: FieldPolicy<any> | FieldReadFunction<any>,
	customSynopses?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	discountLozengeBackgroundImage?: FieldPolicy<any> | FieldReadFunction<any>,
	discountLozengeText?: FieldPolicy<any> | FieldReadFunction<any>,
	discountedPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	downloadDataSpeed?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	infoList?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	landscapeImage?: FieldPolicy<any> | FieldReadFunction<any>,
	largeThumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	legalLine?: FieldPolicy<any> | FieldReadFunction<any>,
	legalLineForQuickCompare?: FieldPolicy<any> | FieldReadFunction<any>,
	longDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	lozengeBackgroundImage?: FieldPolicy<any> | FieldReadFunction<any>,
	lozengeText?: FieldPolicy<any> | FieldReadFunction<any>,
	members?: FieldPolicy<any> | FieldReadFunction<any>,
	moreDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	priceFrequencyType?: FieldPolicy<any> | FieldReadFunction<any>,
	productFeatures?: FieldPolicy<any> | FieldReadFunction<any>,
	productInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	productInfoDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	productKkInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	productSku?: FieldPolicy<any> | FieldReadFunction<any>,
	recommendationImage?: FieldPolicy<any> | FieldReadFunction<any>,
	recomonded?: FieldPolicy<any> | FieldReadFunction<any>,
	shortDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	shortOfInformation?: FieldPolicy<any> | FieldReadFunction<any>,
	shortTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	slugurl?: FieldPolicy<any> | FieldReadFunction<any>,
	smallThumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	subCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	synopses?: FieldPolicy<any> | FieldReadFunction<any>,
	synopsesImages?: FieldPolicy<any> | FieldReadFunction<any>,
	teamCondition?: FieldPolicy<any> | FieldReadFunction<any>,
	termsAndConditionsCaption?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	tileImages?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	titleForBanner?: FieldPolicy<any> | FieldReadFunction<any>,
	titleImageDesktop?: FieldPolicy<any> | FieldReadFunction<any>,
	titleImageMobile?: FieldPolicy<any> | FieldReadFunction<any>,
	tvSpeedImage?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadDataSpeed?: FieldPolicy<any> | FieldReadFunction<any>,
	wifiUnlimitedImage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCardsKeySpecifier = ('acquistionOfferPrice' | 'addLink' | 'bgColor' | 'copyrightText' | 'ctaName' | 'description' | 'detailsLink' | 'detailsList' | 'discountText' | 'iconList' | 'iconListCaption' | 'lozengeText' | 'occurrenceType' | 'price' | 'priceFrequencyType' | 'productSet' | 'promoted' | 'sku' | 'termsAndConditionsCaption' | 'thumbnail' | 'title' | 'titleLogo' | 'type' | 'upgradeOfferPrice' | ProductCardsKeySpecifier)[];
export type ProductCardsFieldPolicy = {
	acquistionOfferPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	addLink?: FieldPolicy<any> | FieldReadFunction<any>,
	bgColor?: FieldPolicy<any> | FieldReadFunction<any>,
	copyrightText?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaName?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	detailsLink?: FieldPolicy<any> | FieldReadFunction<any>,
	detailsList?: FieldPolicy<any> | FieldReadFunction<any>,
	discountText?: FieldPolicy<any> | FieldReadFunction<any>,
	iconList?: FieldPolicy<any> | FieldReadFunction<any>,
	iconListCaption?: FieldPolicy<any> | FieldReadFunction<any>,
	lozengeText?: FieldPolicy<any> | FieldReadFunction<any>,
	occurrenceType?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	priceFrequencyType?: FieldPolicy<any> | FieldReadFunction<any>,
	productSet?: FieldPolicy<any> | FieldReadFunction<any>,
	promoted?: FieldPolicy<any> | FieldReadFunction<any>,
	sku?: FieldPolicy<any> | FieldReadFunction<any>,
	termsAndConditionsCaption?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	titleLogo?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	upgradeOfferPrice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCardsDetailsKeySpecifier = ('acquistionOfferPrice' | 'activeSkyCustomerDetailsList' | 'addLink' | 'addLinkText' | 'bgColor' | 'copyrightText' | 'ctaName' | 'description' | 'detailsLink' | 'detailsList' | 'detailsText' | 'discountText' | 'iconList' | 'iconListCaption' | 'lozengeText' | 'occurrenceType' | 'price' | 'priceFrequencyType' | 'productSet' | 'promoted' | 'sku' | 'termsAndConditionsCaption' | 'thumbnail' | 'title' | 'titleLogo' | 'type' | 'upgradeOfferPrice' | ProductCardsDetailsKeySpecifier)[];
export type ProductCardsDetailsFieldPolicy = {
	acquistionOfferPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	activeSkyCustomerDetailsList?: FieldPolicy<any> | FieldReadFunction<any>,
	addLink?: FieldPolicy<any> | FieldReadFunction<any>,
	addLinkText?: FieldPolicy<any> | FieldReadFunction<any>,
	bgColor?: FieldPolicy<any> | FieldReadFunction<any>,
	copyrightText?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaName?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	detailsLink?: FieldPolicy<any> | FieldReadFunction<any>,
	detailsList?: FieldPolicy<any> | FieldReadFunction<any>,
	detailsText?: FieldPolicy<any> | FieldReadFunction<any>,
	discountText?: FieldPolicy<any> | FieldReadFunction<any>,
	iconList?: FieldPolicy<any> | FieldReadFunction<any>,
	iconListCaption?: FieldPolicy<any> | FieldReadFunction<any>,
	lozengeText?: FieldPolicy<any> | FieldReadFunction<any>,
	occurrenceType?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	priceFrequencyType?: FieldPolicy<any> | FieldReadFunction<any>,
	productSet?: FieldPolicy<any> | FieldReadFunction<any>,
	promoted?: FieldPolicy<any> | FieldReadFunction<any>,
	sku?: FieldPolicy<any> | FieldReadFunction<any>,
	termsAndConditionsCaption?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	titleLogo?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	upgradeOfferPrice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCarouselsKeySpecifier = ('bottomCallToActionLink' | 'bottomCallToActionText' | 'cardPanelHeading' | 'cardPanelHeadingGradient' | 'cardPanelName' | 'cardsToShow' | 'productCategory' | 'skyCustomerSwitch' | 'skyCustomerText' | 'termsAndConditions' | ProductCarouselsKeySpecifier)[];
export type ProductCarouselsFieldPolicy = {
	bottomCallToActionLink?: FieldPolicy<any> | FieldReadFunction<any>,
	bottomCallToActionText?: FieldPolicy<any> | FieldReadFunction<any>,
	cardPanelHeading?: FieldPolicy<any> | FieldReadFunction<any>,
	cardPanelHeadingGradient?: FieldPolicy<any> | FieldReadFunction<any>,
	cardPanelName?: FieldPolicy<any> | FieldReadFunction<any>,
	cardsToShow?: FieldPolicy<any> | FieldReadFunction<any>,
	productCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	skyCustomerSwitch?: FieldPolicy<any> | FieldReadFunction<any>,
	skyCustomerText?: FieldPolicy<any> | FieldReadFunction<any>,
	termsAndConditions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductDetailKeySpecifier = ('category' | 'description' | 'key' | 'service' | 'supplier' | 'voiceCategory' | ProductDetailKeySpecifier)[];
export type ProductDetailFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	service?: FieldPolicy<any> | FieldReadFunction<any>,
	supplier?: FieldPolicy<any> | FieldReadFunction<any>,
	voiceCategory?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductFeatureInfoKeySpecifier = ('fields' | 'sys' | ProductFeatureInfoKeySpecifier)[];
export type ProductFeatureInfoFieldPolicy = {
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductFeatureInfoSetFieldKeySpecifier = ('ctaButtonImage' | 'ctaLink' | 'desciption' | 'first_image' | 'smallDescription' | ProductFeatureInfoSetFieldKeySpecifier)[];
export type ProductFeatureInfoSetFieldFieldPolicy = {
	ctaButtonImage?: FieldPolicy<any> | FieldReadFunction<any>,
	ctaLink?: FieldPolicy<any> | FieldReadFunction<any>,
	desciption?: FieldPolicy<any> | FieldReadFunction<any>,
	first_image?: FieldPolicy<any> | FieldReadFunction<any>,
	smallDescription?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductFeatureSetFieldKeySpecifier = ('fields' | 'sys' | ProductFeatureSetFieldKeySpecifier)[];
export type ProductFeatureSetFieldFieldPolicy = {
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductFeatureSetItemKeySpecifier = ('members' | 'sys' | ProductFeatureSetItemKeySpecifier)[];
export type ProductFeatureSetItemFieldPolicy = {
	members?: FieldPolicy<any> | FieldReadFunction<any>,
	sys?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProfileKeySpecifier = ('accountNumber' | 'associated' | 'blockAdultContent' | 'displayName' | 'email' | 'firstName' | 'groups' | 'houseNumber' | 'lastName' | 'parentalControlEnabled' | 'parentalPin' | 'parentalRatingLevel' | 'profileId' | 'receiveMarketingEmail' | 'salesForceId' | 'subscriberKey' | 'type' | ProfileKeySpecifier)[];
export type ProfileFieldPolicy = {
	accountNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	associated?: FieldPolicy<any> | FieldReadFunction<any>,
	blockAdultContent?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	groups?: FieldPolicy<any> | FieldReadFunction<any>,
	houseNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	parentalControlEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	parentalPin?: FieldPolicy<any> | FieldReadFunction<any>,
	parentalRatingLevel?: FieldPolicy<any> | FieldReadFunction<any>,
	profileId?: FieldPolicy<any> | FieldReadFunction<any>,
	receiveMarketingEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	salesForceId?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriberKey?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromoCardKeySpecifier = ('CTAButtonLabel' | 'CTAButtonUrl' | 'bgColor' | 'billingFrequency' | 'campaign' | 'copyrightText' | 'coupon' | 'disclaimer' | 'discountText' | 'discountedPrice' | 'eligibilityExcludeCampaign' | 'eligibilityExcludeServiceCode' | 'eligibilityIncludeCampaign' | 'eligibilityIncludeServiceCode' | 'eligibleFor' | 'extraCampaign' | 'fromPrice' | 'imageSrc' | 'lozengeText' | 'offerType' | 'sku' | 'subDescription' | 'subscriberKey' | 'subtitle' | 'termsAndConditions' | 'title' | 'type' | PromoCardKeySpecifier)[];
export type PromoCardFieldPolicy = {
	CTAButtonLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	CTAButtonUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	bgColor?: FieldPolicy<any> | FieldReadFunction<any>,
	billingFrequency?: FieldPolicy<any> | FieldReadFunction<any>,
	campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	copyrightText?: FieldPolicy<any> | FieldReadFunction<any>,
	coupon?: FieldPolicy<any> | FieldReadFunction<any>,
	disclaimer?: FieldPolicy<any> | FieldReadFunction<any>,
	discountText?: FieldPolicy<any> | FieldReadFunction<any>,
	discountedPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	eligibilityExcludeCampaign?: FieldPolicy<any> | FieldReadFunction<any>,
	eligibilityExcludeServiceCode?: FieldPolicy<any> | FieldReadFunction<any>,
	eligibilityIncludeCampaign?: FieldPolicy<any> | FieldReadFunction<any>,
	eligibilityIncludeServiceCode?: FieldPolicy<any> | FieldReadFunction<any>,
	eligibleFor?: FieldPolicy<any> | FieldReadFunction<any>,
	extraCampaign?: FieldPolicy<any> | FieldReadFunction<any>,
	fromPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	imageSrc?: FieldPolicy<any> | FieldReadFunction<any>,
	lozengeText?: FieldPolicy<any> | FieldReadFunction<any>,
	offerType?: FieldPolicy<any> | FieldReadFunction<any>,
	sku?: FieldPolicy<any> | FieldReadFunction<any>,
	subDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriberKey?: FieldPolicy<any> | FieldReadFunction<any>,
	subtitle?: FieldPolicy<any> | FieldReadFunction<any>,
	termsAndConditions?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('BusinessComposePage' | 'BusinessMenuList' | 'BusinessResourceSet' | 'ComponentCardSection' | 'ComposeAdvertisingPage' | 'GlobalFooterList' | 'GlobalMenuList' | 'MenuItemSectionLists' | 'MenuList' | 'MenuListHeader' | 'MenuSectionList' | 'NBJChildEntityComponentDetails' | 'NBJComponentDetails' | 'NBJComposePages' | 'NBJEntityDetails' | 'NBJMenuList' | 'NBJProductItem' | 'NBJProductList' | 'NBJSampleComposePages' | 'SocialMedia' | 'articlePage' | 'billing' | 'cardContainer' | 'composePage' | 'contactUs' | 'customer' | 'downloadParcelLabel' | 'getAccount' | 'getAddressDetails' | 'getRecyclingCentreAddress' | 'offers' | 'orderConfirmation' | 'parcelLabelStatus' | 'parcelTracking' | 'ppv' | 'prequal' | 'products' | 'productsCards' | 'profile' | 'promoCards' | 'search' | 'searchAddress' | 'seo' | 'termsconditions' | 'workOrder' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	BusinessComposePage?: FieldPolicy<any> | FieldReadFunction<any>,
	BusinessMenuList?: FieldPolicy<any> | FieldReadFunction<any>,
	BusinessResourceSet?: FieldPolicy<any> | FieldReadFunction<any>,
	ComponentCardSection?: FieldPolicy<any> | FieldReadFunction<any>,
	ComposeAdvertisingPage?: FieldPolicy<any> | FieldReadFunction<any>,
	GlobalFooterList?: FieldPolicy<any> | FieldReadFunction<any>,
	GlobalMenuList?: FieldPolicy<any> | FieldReadFunction<any>,
	MenuItemSectionLists?: FieldPolicy<any> | FieldReadFunction<any>,
	MenuList?: FieldPolicy<any> | FieldReadFunction<any>,
	MenuListHeader?: FieldPolicy<any> | FieldReadFunction<any>,
	MenuSectionList?: FieldPolicy<any> | FieldReadFunction<any>,
	NBJChildEntityComponentDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	NBJComponentDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	NBJComposePages?: FieldPolicy<any> | FieldReadFunction<any>,
	NBJEntityDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	NBJMenuList?: FieldPolicy<any> | FieldReadFunction<any>,
	NBJProductItem?: FieldPolicy<any> | FieldReadFunction<any>,
	NBJProductList?: FieldPolicy<any> | FieldReadFunction<any>,
	NBJSampleComposePages?: FieldPolicy<any> | FieldReadFunction<any>,
	SocialMedia?: FieldPolicy<any> | FieldReadFunction<any>,
	articlePage?: FieldPolicy<any> | FieldReadFunction<any>,
	billing?: FieldPolicy<any> | FieldReadFunction<any>,
	cardContainer?: FieldPolicy<any> | FieldReadFunction<any>,
	composePage?: FieldPolicy<any> | FieldReadFunction<any>,
	contactUs?: FieldPolicy<any> | FieldReadFunction<any>,
	customer?: FieldPolicy<any> | FieldReadFunction<any>,
	downloadParcelLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	getAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	getAddressDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	getRecyclingCentreAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	offers?: FieldPolicy<any> | FieldReadFunction<any>,
	orderConfirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	parcelLabelStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	parcelTracking?: FieldPolicy<any> | FieldReadFunction<any>,
	ppv?: FieldPolicy<any> | FieldReadFunction<any>,
	prequal?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>,
	productsCards?: FieldPolicy<any> | FieldReadFunction<any>,
	profile?: FieldPolicy<any> | FieldReadFunction<any>,
	promoCards?: FieldPolicy<any> | FieldReadFunction<any>,
	search?: FieldPolicy<any> | FieldReadFunction<any>,
	searchAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	seo?: FieldPolicy<any> | FieldReadFunction<any>,
	termsconditions?: FieldPolicy<any> | FieldReadFunction<any>,
	workOrder?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RecyclingCentreAddressKeySpecifier = ('address' | 'addressId' | 'contact' | 'name' | 'postcodePrefix' | RecyclingCentreAddressKeySpecifier)[];
export type RecyclingCentreAddressFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	addressId?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	postcodePrefix?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SEOEntityKeySpecifier = ('description' | 'keywords' | 'logoImageUrl' | 'name' | 'no_follow' | 'no_index' | 'seoTitle' | 'urlSlug' | SEOEntityKeySpecifier)[];
export type SEOEntityFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	keywords?: FieldPolicy<any> | FieldReadFunction<any>,
	logoImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	no_follow?: FieldPolicy<any> | FieldReadFunction<any>,
	no_index?: FieldPolicy<any> | FieldReadFunction<any>,
	seoTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	urlSlug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SearchEntityKeySpecifier = ('description' | 'keywords' | 'name' | 'title' | 'urlSlug' | SearchEntityKeySpecifier)[];
export type SearchEntityFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	keywords?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	urlSlug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SecLinkCombinedMenuKeySpecifier = ('internalName' | 'itemIcon' | 'itemUrl' | 'name' | 'publicName' | 'sectionLinks' | 'sectionName' | 'slug' | SecLinkCombinedMenuKeySpecifier)[];
export type SecLinkCombinedMenuFieldPolicy = {
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	itemIcon?: FieldPolicy<any> | FieldReadFunction<any>,
	itemUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	publicName?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionName?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SeoMetaDataDetailsKeySpecifier = ('description' | 'image' | 'keywords' | 'name' | 'no_follow' | 'no_index' | 'seoTitle' | 'urlSlug' | SeoMetaDataDetailsKeySpecifier)[];
export type SeoMetaDataDetailsFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	keywords?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	no_follow?: FieldPolicy<any> | FieldReadFunction<any>,
	no_index?: FieldPolicy<any> | FieldReadFunction<any>,
	seoTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	urlSlug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SeoMetaDataFieldKeySpecifier = ('fields' | SeoMetaDataFieldKeySpecifier)[];
export type SeoMetaDataFieldFieldPolicy = {
	fields?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShowingKeySpecifier = ('bookableTime' | 'channel' | 'duration' | 'id' | 'offeringId' | 'price' | 'time' | ShowingKeySpecifier)[];
export type ShowingFieldPolicy = {
	bookableTime?: FieldPolicy<any> | FieldReadFunction<any>,
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	offeringId?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	time?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SitemapCombinedMenuKeySpecifier = ('itemUrl' | 'name' | 'sectionLinks' | 'sectionName' | 'slug' | SitemapCombinedMenuKeySpecifier)[];
export type SitemapCombinedMenuFieldPolicy = {
	itemUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionName?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SitemapSecListKeySpecifier = ('itemUrl' | 'name' | 'sectionLinks' | 'sectionName' | 'slug' | SitemapSecListKeySpecifier)[];
export type SitemapSecListFieldPolicy = {
	itemUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionName?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SitemapsKeySpecifier = ('menuSections' | 'navigationItem' | SitemapsKeySpecifier)[];
export type SitemapsFieldPolicy = {
	menuSections?: FieldPolicy<any> | FieldReadFunction<any>,
	navigationItem?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubMenuFieldKeySpecifier = ('fields' | SubMenuFieldKeySpecifier)[];
export type SubMenuFieldFieldPolicy = {
	fields?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubMenuFieldListsKeySpecifier = ('internalName' | 'menuSections' | 'navigationItem' | SubMenuFieldListsKeySpecifier)[];
export type SubMenuFieldListsFieldPolicy = {
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	menuSections?: FieldPolicy<any> | FieldReadFunction<any>,
	navigationItem?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubMenuItemListKeySpecifier = ('internalName' | 'itemIcon' | 'itemUrl' | 'name' | SubMenuItemListKeySpecifier)[];
export type SubMenuItemListFieldPolicy = {
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	itemIcon?: FieldPolicy<any> | FieldReadFunction<any>,
	itemUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubMenuSectionsKeySpecifier = ('fields' | SubMenuSectionsKeySpecifier)[];
export type SubMenuSectionsFieldPolicy = {
	fields?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TermsAndConditionsKeySpecifier = ('bgTitle' | 'internalName' | 'isExpandable' | 'slug' | 'subTitle' | 'terms' | 'title' | TermsAndConditionsKeySpecifier)[];
export type TermsAndConditionsFieldPolicy = {
	bgTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	internalName?: FieldPolicy<any> | FieldReadFunction<any>,
	isExpandable?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	subTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	terms?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TimeKeySpecifier = ('end' | 'start' | TimeKeySpecifier)[];
export type TimeFieldPolicy = {
	end?: FieldPolicy<any> | FieldReadFunction<any>,
	start?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TrackingEventKeySpecifier = ('event_datetime' | 'event_description' | 'event_edifact_code' | 'seqref' | 'source' | 'status_description' | 'tracking_reference' | TrackingEventKeySpecifier)[];
export type TrackingEventFieldPolicy = {
	event_datetime?: FieldPolicy<any> | FieldReadFunction<any>,
	event_description?: FieldPolicy<any> | FieldReadFunction<any>,
	event_edifact_code?: FieldPolicy<any> | FieldReadFunction<any>,
	seqref?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	status_description?: FieldPolicy<any> | FieldReadFunction<any>,
	tracking_reference?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateElabelResponseDtoKeySpecifier = ('statusCode' | UpdateElabelResponseDtoKeySpecifier)[];
export type UpdateElabelResponseDtoFieldPolicy = {
	statusCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherResponseKeySpecifier = ('Campaigns' | 'Description' | 'DeviceType' | 'ExpiryDate' | 'OfferDescription' | 'OfferId' | 'ProductType' | 'RequestStatus' | 'ServiceCodes' | 'VoucherStatus' | 'url' | VoucherResponseKeySpecifier)[];
export type VoucherResponseFieldPolicy = {
	Campaigns?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	DeviceType?: FieldPolicy<any> | FieldReadFunction<any>,
	ExpiryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	OfferDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	OfferId?: FieldPolicy<any> | FieldReadFunction<any>,
	ProductType?: FieldPolicy<any> | FieldReadFunction<any>,
	RequestStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	ServiceCodes?: FieldPolicy<any> | FieldReadFunction<any>,
	VoucherStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebContentsKeySpecifier = ('content' | 'name' | WebContentsKeySpecifier)[];
export type WebContentsFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WorkOrderKeySpecifier = ('isUserHasBroadbandWorkorderOrCompleted' | 'isUserHasCablePendingWorkorder' | 'isVTVHasMigratePendingWorkOrder' | WorkOrderKeySpecifier)[];
export type WorkOrderFieldPolicy = {
	isUserHasBroadbandWorkorderOrCompleted?: FieldPolicy<any> | FieldReadFunction<any>,
	isUserHasCablePendingWorkorder?: FieldPolicy<any> | FieldReadFunction<any>,
	isVTVHasMigratePendingWorkOrder?: FieldPolicy<any> | FieldReadFunction<any>
};
export type baseImageUrlKeySpecifier = ('text' | 'url' | baseImageUrlKeySpecifier)[];
export type baseImageUrlFieldPolicy = {
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type basePDFUrlKeySpecifier = ('description' | 'file' | 'title' | basePDFUrlKeySpecifier)[];
export type basePDFUrlFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type combinedMenuKeySpecifier = ('itemUrl' | 'publicName' | 'sectionLinks' | 'sectionName' | 'slug' | combinedMenuKeySpecifier)[];
export type combinedMenuFieldPolicy = {
	itemUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	publicName?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionName?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	Account?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountKeySpecifier | (() => undefined | AccountKeySpecifier),
		fields?: AccountFieldPolicy,
	},
	AdMenu?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdMenuKeySpecifier | (() => undefined | AdMenuKeySpecifier),
		fields?: AdMenuFieldPolicy,
	},
	AdMenuItemListItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdMenuItemListItemKeySpecifier | (() => undefined | AdMenuItemListItemKeySpecifier),
		fields?: AdMenuItemListItemFieldPolicy,
	},
	AdMenuItemLists?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdMenuItemListsKeySpecifier | (() => undefined | AdMenuItemListsKeySpecifier),
		fields?: AdMenuItemListsFieldPolicy,
	},
	AdMenuList?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdMenuListKeySpecifier | (() => undefined | AdMenuListKeySpecifier),
		fields?: AdMenuListFieldPolicy,
	},
	AdcombinedMenu?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdcombinedMenuKeySpecifier | (() => undefined | AdcombinedMenuKeySpecifier),
		fields?: AdcombinedMenuFieldPolicy,
	},
	AdvResourceSet?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdvResourceSetKeySpecifier | (() => undefined | AdvResourceSetKeySpecifier),
		fields?: AdvResourceSetFieldPolicy,
	},
	AdvResources?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdvResourcesKeySpecifier | (() => undefined | AdvResourcesKeySpecifier),
		fields?: AdvResourcesFieldPolicy,
	},
	AdvertisingComponentCardCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdvertisingComponentCardCollectionsKeySpecifier | (() => undefined | AdvertisingComponentCardCollectionsKeySpecifier),
		fields?: AdvertisingComponentCardCollectionsFieldPolicy,
	},
	AdvertisingComponentCardSections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdvertisingComponentCardSectionsKeySpecifier | (() => undefined | AdvertisingComponentCardSectionsKeySpecifier),
		fields?: AdvertisingComponentCardSectionsFieldPolicy,
	},
	AdvertisingComponentCards?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdvertisingComponentCardsKeySpecifier | (() => undefined | AdvertisingComponentCardsKeySpecifier),
		fields?: AdvertisingComponentCardsFieldPolicy,
	},
	AdvertisingComposePage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdvertisingComposePageKeySpecifier | (() => undefined | AdvertisingComposePageKeySpecifier),
		fields?: AdvertisingComposePageFieldPolicy,
	},
	AdvertisingContents?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdvertisingContentsKeySpecifier | (() => undefined | AdvertisingContentsKeySpecifier),
		fields?: AdvertisingContentsFieldPolicy,
	},
	AdvertisingFreeFormContents?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdvertisingFreeFormContentsKeySpecifier | (() => undefined | AdvertisingFreeFormContentsKeySpecifier),
		fields?: AdvertisingFreeFormContentsFieldPolicy,
	},
	AdvertisingHeroBannerContents?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdvertisingHeroBannerContentsKeySpecifier | (() => undefined | AdvertisingHeroBannerContentsKeySpecifier),
		fields?: AdvertisingHeroBannerContentsFieldPolicy,
	},
	AdvertisingImageClass?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdvertisingImageClassKeySpecifier | (() => undefined | AdvertisingImageClassKeySpecifier),
		fields?: AdvertisingImageClassFieldPolicy,
	},
	AdvertisingLinks?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdvertisingLinksKeySpecifier | (() => undefined | AdvertisingLinksKeySpecifier),
		fields?: AdvertisingLinksFieldPolicy,
	},
	AdvertisingPopupCardSection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdvertisingPopupCardSectionKeySpecifier | (() => undefined | AdvertisingPopupCardSectionKeySpecifier),
		fields?: AdvertisingPopupCardSectionFieldPolicy,
	},
	AdvertisingRailContentSetClass?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdvertisingRailContentSetClassKeySpecifier | (() => undefined | AdvertisingRailContentSetClassKeySpecifier),
		fields?: AdvertisingRailContentSetClassFieldPolicy,
	},
	AdvertisingSeos?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdvertisingSeosKeySpecifier | (() => undefined | AdvertisingSeosKeySpecifier),
		fields?: AdvertisingSeosFieldPolicy,
	},
	AdvertisingWebContents?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdvertisingWebContentsKeySpecifier | (() => undefined | AdvertisingWebContentsKeySpecifier),
		fields?: AdvertisingWebContentsFieldPolicy,
	},
	AdvertisingbaseImageUrl?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdvertisingbaseImageUrlKeySpecifier | (() => undefined | AdvertisingbaseImageUrlKeySpecifier),
		fields?: AdvertisingbaseImageUrlFieldPolicy,
	},
	ArticalCompose?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ArticalComposeKeySpecifier | (() => undefined | ArticalComposeKeySpecifier),
		fields?: ArticalComposeFieldPolicy,
	},
	ArticleCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ArticleCollectionsKeySpecifier | (() => undefined | ArticleCollectionsKeySpecifier),
		fields?: ArticleCollectionsFieldPolicy,
	},
	BMenuItemLists?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BMenuItemListsKeySpecifier | (() => undefined | BMenuItemListsKeySpecifier),
		fields?: BMenuItemListsFieldPolicy,
	},
	BMenuList?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BMenuListKeySpecifier | (() => undefined | BMenuListKeySpecifier),
		fields?: BMenuListFieldPolicy,
	},
	BannerContents?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BannerContentsKeySpecifier | (() => undefined | BannerContentsKeySpecifier),
		fields?: BannerContentsFieldPolicy,
	},
	Billing?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BillingKeySpecifier | (() => undefined | BillingKeySpecifier),
		fields?: BillingFieldPolicy,
	},
	BusinessCardFile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessCardFileKeySpecifier | (() => undefined | BusinessCardFileKeySpecifier),
		fields?: BusinessCardFileFieldPolicy,
	},
	BusinessCardImage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessCardImageKeySpecifier | (() => undefined | BusinessCardImageKeySpecifier),
		fields?: BusinessCardImageFieldPolicy,
	},
	BusinessCards?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessCardsKeySpecifier | (() => undefined | BusinessCardsKeySpecifier),
		fields?: BusinessCardsFieldPolicy,
	},
	BusinessCombinedMenu?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessCombinedMenuKeySpecifier | (() => undefined | BusinessCombinedMenuKeySpecifier),
		fields?: BusinessCombinedMenuFieldPolicy,
	},
	BusinessComposeContent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessComposeContentKeySpecifier | (() => undefined | BusinessComposeContentKeySpecifier),
		fields?: BusinessComposeContentFieldPolicy,
	},
	BusinessComposePage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessComposePageKeySpecifier | (() => undefined | BusinessComposePageKeySpecifier),
		fields?: BusinessComposePageFieldPolicy,
	},
	BusinessContent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessContentKeySpecifier | (() => undefined | BusinessContentKeySpecifier),
		fields?: BusinessContentFieldPolicy,
	},
	BusinessLinks?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessLinksKeySpecifier | (() => undefined | BusinessLinksKeySpecifier),
		fields?: BusinessLinksFieldPolicy,
	},
	BusinessResourceSet?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessResourceSetKeySpecifier | (() => undefined | BusinessResourceSetKeySpecifier),
		fields?: BusinessResourceSetFieldPolicy,
	},
	BusinessResources?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessResourcesKeySpecifier | (() => undefined | BusinessResourcesKeySpecifier),
		fields?: BusinessResourcesFieldPolicy,
	},
	Campaign?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CampaignKeySpecifier | (() => undefined | CampaignKeySpecifier),
		fields?: CampaignFieldPolicy,
	},
	CardContainer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CardContainerKeySpecifier | (() => undefined | CardContainerKeySpecifier),
		fields?: CardContainerFieldPolicy,
	},
	ChannelSetDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChannelSetDetailsKeySpecifier | (() => undefined | ChannelSetDetailsKeySpecifier),
		fields?: ChannelSetDetailsFieldPolicy,
	},
	ChannelSetItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChannelSetItemKeySpecifier | (() => undefined | ChannelSetItemKeySpecifier),
		fields?: ChannelSetItemFieldPolicy,
	},
	ComponentCardClass?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComponentCardClassKeySpecifier | (() => undefined | ComponentCardClassKeySpecifier),
		fields?: ComponentCardClassFieldPolicy,
	},
	ComponentCardCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComponentCardCollectionsKeySpecifier | (() => undefined | ComponentCardCollectionsKeySpecifier),
		fields?: ComponentCardCollectionsFieldPolicy,
	},
	ComponentCardSection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComponentCardSectionKeySpecifier | (() => undefined | ComponentCardSectionKeySpecifier),
		fields?: ComponentCardSectionFieldPolicy,
	},
	ComponentCardSections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComponentCardSectionsKeySpecifier | (() => undefined | ComponentCardSectionsKeySpecifier),
		fields?: ComponentCardSectionsFieldPolicy,
	},
	ComponentCards?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComponentCardsKeySpecifier | (() => undefined | ComponentCardsKeySpecifier),
		fields?: ComponentCardsFieldPolicy,
	},
	Components?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComponentsKeySpecifier | (() => undefined | ComponentsKeySpecifier),
		fields?: ComponentsFieldPolicy,
	},
	ComposePage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComposePageKeySpecifier | (() => undefined | ComposePageKeySpecifier),
		fields?: ComposePageFieldPolicy,
	},
	ContactInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactInfoKeySpecifier | (() => undefined | ContactInfoKeySpecifier),
		fields?: ContactInfoFieldPolicy,
	},
	ContentInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContentInfoKeySpecifier | (() => undefined | ContentInfoKeySpecifier),
		fields?: ContentInfoFieldPolicy,
	},
	ContentModelsFields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContentModelsFieldsKeySpecifier | (() => undefined | ContentModelsFieldsKeySpecifier),
		fields?: ContentModelsFieldsFieldPolicy,
	},
	ContentModelsList?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContentModelsListKeySpecifier | (() => undefined | ContentModelsListKeySpecifier),
		fields?: ContentModelsListFieldPolicy,
	},
	Contents?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContentsKeySpecifier | (() => undefined | ContentsKeySpecifier),
		fields?: ContentsFieldPolicy,
	},
	Coupon?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CouponKeySpecifier | (() => undefined | CouponKeySpecifier),
		fields?: CouponFieldPolicy,
	},
	CreateLabelResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateLabelResponseKeySpecifier | (() => undefined | CreateLabelResponseKeySpecifier),
		fields?: CreateLabelResponseFieldPolicy,
	},
	Customer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerKeySpecifier | (() => undefined | CustomerKeySpecifier),
		fields?: CustomerFieldPolicy,
	},
	DeviceInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeviceInfoKeySpecifier | (() => undefined | DeviceInfoKeySpecifier),
		fields?: DeviceInfoFieldPolicy,
	},
	DeviceInfoFields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeviceInfoFieldsKeySpecifier | (() => undefined | DeviceInfoFieldsKeySpecifier),
		fields?: DeviceInfoFieldsFieldPolicy,
	},
	EligibilityOffer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EligibilityOfferKeySpecifier | (() => undefined | EligibilityOfferKeySpecifier),
		fields?: EligibilityOfferFieldPolicy,
	},
	FaqsListDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FaqsListDetailsKeySpecifier | (() => undefined | FaqsListDetailsKeySpecifier),
		fields?: FaqsListDetailsFieldPolicy,
	},
	FaqsListItems?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FaqsListItemsKeySpecifier | (() => undefined | FaqsListItemsKeySpecifier),
		fields?: FaqsListItemsFieldPolicy,
	},
	FreeFormContent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FreeFormContentKeySpecifier | (() => undefined | FreeFormContentKeySpecifier),
		fields?: FreeFormContentFieldPolicy,
	},
	GlobalFooter?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GlobalFooterKeySpecifier | (() => undefined | GlobalFooterKeySpecifier),
		fields?: GlobalFooterFieldPolicy,
	},
	GlobalMenuItemLists?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GlobalMenuItemListsKeySpecifier | (() => undefined | GlobalMenuItemListsKeySpecifier),
		fields?: GlobalMenuItemListsFieldPolicy,
	},
	GlobalMenuList?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GlobalMenuListKeySpecifier | (() => undefined | GlobalMenuListKeySpecifier),
		fields?: GlobalMenuListFieldPolicy,
	},
	IconDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IconDetailsKeySpecifier | (() => undefined | IconDetailsKeySpecifier),
		fields?: IconDetailsFieldPolicy,
	},
	IconImage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IconImageKeySpecifier | (() => undefined | IconImageKeySpecifier),
		fields?: IconImageFieldPolicy,
	},
	IconTempleteDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IconTempleteDetailsKeySpecifier | (() => undefined | IconTempleteDetailsKeySpecifier),
		fields?: IconTempleteDetailsFieldPolicy,
	},
	IconTempleteItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IconTempleteItemKeySpecifier | (() => undefined | IconTempleteItemKeySpecifier),
		fields?: IconTempleteItemFieldPolicy,
	},
	ImageDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImageDetailsKeySpecifier | (() => undefined | ImageDetailsKeySpecifier),
		fields?: ImageDetailsFieldPolicy,
	},
	ImageUrl?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImageUrlKeySpecifier | (() => undefined | ImageUrlKeySpecifier),
		fields?: ImageUrlFieldPolicy,
	},
	Label?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LabelKeySpecifier | (() => undefined | LabelKeySpecifier),
		fields?: LabelFieldPolicy,
	},
	LeadsContent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LeadsContentKeySpecifier | (() => undefined | LeadsContentKeySpecifier),
		fields?: LeadsContentFieldPolicy,
	},
	LinkClass?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LinkClassKeySpecifier | (() => undefined | LinkClassKeySpecifier),
		fields?: LinkClassFieldPolicy,
	},
	Links?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LinksKeySpecifier | (() => undefined | LinksKeySpecifier),
		fields?: LinksFieldPolicy,
	},
	LinksCollections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LinksCollectionsKeySpecifier | (() => undefined | LinksCollectionsKeySpecifier),
		fields?: LinksCollectionsFieldPolicy,
	},
	LogoContentAccordions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LogoContentAccordionsKeySpecifier | (() => undefined | LogoContentAccordionsKeySpecifier),
		fields?: LogoContentAccordionsFieldPolicy,
	},
	MediaContentDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MediaContentDetailsKeySpecifier | (() => undefined | MediaContentDetailsKeySpecifier),
		fields?: MediaContentDetailsFieldPolicy,
	},
	MediaContentItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MediaContentItemKeySpecifier | (() => undefined | MediaContentItemKeySpecifier),
		fields?: MediaContentItemFieldPolicy,
	},
	MediaItems?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MediaItemsKeySpecifier | (() => undefined | MediaItemsKeySpecifier),
		fields?: MediaItemsFieldPolicy,
	},
	MediaSections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MediaSectionsKeySpecifier | (() => undefined | MediaSectionsKeySpecifier),
		fields?: MediaSectionsFieldPolicy,
	},
	Menu?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuKeySpecifier | (() => undefined | MenuKeySpecifier),
		fields?: MenuFieldPolicy,
	},
	MenuItemList?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemListKeySpecifier | (() => undefined | MenuItemListKeySpecifier),
		fields?: MenuItemListFieldPolicy,
	},
	MenuItemListItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemListItemKeySpecifier | (() => undefined | MenuItemListItemKeySpecifier),
		fields?: MenuItemListItemFieldPolicy,
	},
	MenuItemLists?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemListsKeySpecifier | (() => undefined | MenuItemListsKeySpecifier),
		fields?: MenuItemListsFieldPolicy,
	},
	MenuItemSectionLists?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemSectionListsKeySpecifier | (() => undefined | MenuItemSectionListsKeySpecifier),
		fields?: MenuItemSectionListsFieldPolicy,
	},
	MenuList?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuListKeySpecifier | (() => undefined | MenuListKeySpecifier),
		fields?: MenuListFieldPolicy,
	},
	MenuSectionList?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuSectionListKeySpecifier | (() => undefined | MenuSectionListKeySpecifier),
		fields?: MenuSectionListFieldPolicy,
	},
	MenuSectionListFields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuSectionListFieldsKeySpecifier | (() => undefined | MenuSectionListFieldsKeySpecifier),
		fields?: MenuSectionListFieldsFieldPolicy,
	},
	MenuSectionLists?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuSectionListsKeySpecifier | (() => undefined | MenuSectionListsKeySpecifier),
		fields?: MenuSectionListsFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	NBJCombinedMenu?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NBJCombinedMenuKeySpecifier | (() => undefined | NBJCombinedMenuKeySpecifier),
		fields?: NBJCombinedMenuFieldPolicy,
	},
	NBJComposeComponentItems?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NBJComposeComponentItemsKeySpecifier | (() => undefined | NBJComposeComponentItemsKeySpecifier),
		fields?: NBJComposeComponentItemsFieldPolicy,
	},
	NBJComposeComponentModelId?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NBJComposeComponentModelIdKeySpecifier | (() => undefined | NBJComposeComponentModelIdKeySpecifier),
		fields?: NBJComposeComponentModelIdFieldPolicy,
	},
	NBJComposeEntity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NBJComposeEntityKeySpecifier | (() => undefined | NBJComposeEntityKeySpecifier),
		fields?: NBJComposeEntityFieldPolicy,
	},
	NBJComposeEntityId?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NBJComposeEntityIdKeySpecifier | (() => undefined | NBJComposeEntityIdKeySpecifier),
		fields?: NBJComposeEntityIdFieldPolicy,
	},
	NBJComposePages?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NBJComposePagesKeySpecifier | (() => undefined | NBJComposePagesKeySpecifier),
		fields?: NBJComposePagesFieldPolicy,
	},
	NBJComposeTypeDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NBJComposeTypeDetailsKeySpecifier | (() => undefined | NBJComposeTypeDetailsKeySpecifier),
		fields?: NBJComposeTypeDetailsFieldPolicy,
	},
	NBJEntityDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NBJEntityDetailsKeySpecifier | (() => undefined | NBJEntityDetailsKeySpecifier),
		fields?: NBJEntityDetailsFieldPolicy,
	},
	NBJFieldMenuLists?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NBJFieldMenuListsKeySpecifier | (() => undefined | NBJFieldMenuListsKeySpecifier),
		fields?: NBJFieldMenuListsFieldPolicy,
	},
	NBJMenuItemLists?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NBJMenuItemListsKeySpecifier | (() => undefined | NBJMenuItemListsKeySpecifier),
		fields?: NBJMenuItemListsFieldPolicy,
	},
	NBJMenuList?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NBJMenuListKeySpecifier | (() => undefined | NBJMenuListKeySpecifier),
		fields?: NBJMenuListFieldPolicy,
	},
	NBJMenuSectionLists?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NBJMenuSectionListsKeySpecifier | (() => undefined | NBJMenuSectionListsKeySpecifier),
		fields?: NBJMenuSectionListsFieldPolicy,
	},
	NBJModels?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NBJModelsKeySpecifier | (() => undefined | NBJModelsKeySpecifier),
		fields?: NBJModelsFieldPolicy,
	},
	NBJNestedMenuSectionLists?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NBJNestedMenuSectionListsKeySpecifier | (() => undefined | NBJNestedMenuSectionListsKeySpecifier),
		fields?: NBJNestedMenuSectionListsFieldPolicy,
	},
	NBJProductAndTabFields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NBJProductAndTabFieldsKeySpecifier | (() => undefined | NBJProductAndTabFieldsKeySpecifier),
		fields?: NBJProductAndTabFieldsFieldPolicy,
	},
	NBJProductCardFields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NBJProductCardFieldsKeySpecifier | (() => undefined | NBJProductCardFieldsKeySpecifier),
		fields?: NBJProductCardFieldsFieldPolicy,
	},
	NBJSampleComposePages?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NBJSampleComposePagesKeySpecifier | (() => undefined | NBJSampleComposePagesKeySpecifier),
		fields?: NBJSampleComposePagesFieldPolicy,
	},
	NBJTermsAndConditions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NBJTermsAndConditionsKeySpecifier | (() => undefined | NBJTermsAndConditionsKeySpecifier),
		fields?: NBJTermsAndConditionsFieldPolicy,
	},
	NBJTermsAndConditionsFields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NBJTermsAndConditionsFieldsKeySpecifier | (() => undefined | NBJTermsAndConditionsFieldsKeySpecifier),
		fields?: NBJTermsAndConditionsFieldsFieldPolicy,
	},
	NavigationField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NavigationFieldKeySpecifier | (() => undefined | NavigationFieldKeySpecifier),
		fields?: NavigationFieldFieldPolicy,
	},
	NavigationFieldItems?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NavigationFieldItemsKeySpecifier | (() => undefined | NavigationFieldItemsKeySpecifier),
		fields?: NavigationFieldItemsFieldPolicy,
	},
	NavigationItems?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NavigationItemsKeySpecifier | (() => undefined | NavigationItemsKeySpecifier),
		fields?: NavigationItemsFieldPolicy,
	},
	NzPostLocation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NzPostLocationKeySpecifier | (() => undefined | NzPostLocationKeySpecifier),
		fields?: NzPostLocationFieldPolicy,
	},
	Offer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OfferKeySpecifier | (() => undefined | OfferKeySpecifier),
		fields?: OfferFieldPolicy,
	},
	Offering?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OfferingKeySpecifier | (() => undefined | OfferingKeySpecifier),
		fields?: OfferingFieldPolicy,
	},
	OrderConfirmation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderConfirmationKeySpecifier | (() => undefined | OrderConfirmationKeySpecifier),
		fields?: OrderConfirmationFieldPolicy,
	},
	PPV?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PPVKeySpecifier | (() => undefined | PPVKeySpecifier),
		fields?: PPVFieldPolicy,
	},
	PPVBought?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PPVBoughtKeySpecifier | (() => undefined | PPVBoughtKeySpecifier),
		fields?: PPVBoughtFieldPolicy,
	},
	PPVItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PPVItemKeySpecifier | (() => undefined | PPVItemKeySpecifier),
		fields?: PPVItemFieldPolicy,
	},
	ParcelLabel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ParcelLabelKeySpecifier | (() => undefined | ParcelLabelKeySpecifier),
		fields?: ParcelLabelFieldPolicy,
	},
	ParcelTracking?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ParcelTrackingKeySpecifier | (() => undefined | ParcelTrackingKeySpecifier),
		fields?: ParcelTrackingFieldPolicy,
	},
	PopupCard?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PopupCardKeySpecifier | (() => undefined | PopupCardKeySpecifier),
		fields?: PopupCardFieldPolicy,
	},
	PopupCardSection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PopupCardSectionKeySpecifier | (() => undefined | PopupCardSectionKeySpecifier),
		fields?: PopupCardSectionFieldPolicy,
	},
	Prequal?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PrequalKeySpecifier | (() => undefined | PrequalKeySpecifier),
		fields?: PrequalFieldPolicy,
	},
	Product?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductKeySpecifier | (() => undefined | ProductKeySpecifier),
		fields?: ProductFieldPolicy,
	},
	ProductCardDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCardDetailsKeySpecifier | (() => undefined | ProductCardDetailsKeySpecifier),
		fields?: ProductCardDetailsFieldPolicy,
	},
	ProductCardItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCardItemKeySpecifier | (() => undefined | ProductCardItemKeySpecifier),
		fields?: ProductCardItemFieldPolicy,
	},
	ProductCards?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCardsKeySpecifier | (() => undefined | ProductCardsKeySpecifier),
		fields?: ProductCardsFieldPolicy,
	},
	ProductCardsDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCardsDetailsKeySpecifier | (() => undefined | ProductCardsDetailsKeySpecifier),
		fields?: ProductCardsDetailsFieldPolicy,
	},
	ProductCarousels?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCarouselsKeySpecifier | (() => undefined | ProductCarouselsKeySpecifier),
		fields?: ProductCarouselsFieldPolicy,
	},
	ProductDetail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductDetailKeySpecifier | (() => undefined | ProductDetailKeySpecifier),
		fields?: ProductDetailFieldPolicy,
	},
	ProductFeatureInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductFeatureInfoKeySpecifier | (() => undefined | ProductFeatureInfoKeySpecifier),
		fields?: ProductFeatureInfoFieldPolicy,
	},
	ProductFeatureInfoSetField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductFeatureInfoSetFieldKeySpecifier | (() => undefined | ProductFeatureInfoSetFieldKeySpecifier),
		fields?: ProductFeatureInfoSetFieldFieldPolicy,
	},
	ProductFeatureSetField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductFeatureSetFieldKeySpecifier | (() => undefined | ProductFeatureSetFieldKeySpecifier),
		fields?: ProductFeatureSetFieldFieldPolicy,
	},
	ProductFeatureSetItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductFeatureSetItemKeySpecifier | (() => undefined | ProductFeatureSetItemKeySpecifier),
		fields?: ProductFeatureSetItemFieldPolicy,
	},
	Profile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProfileKeySpecifier | (() => undefined | ProfileKeySpecifier),
		fields?: ProfileFieldPolicy,
	},
	PromoCard?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromoCardKeySpecifier | (() => undefined | PromoCardKeySpecifier),
		fields?: PromoCardFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	RecyclingCentreAddress?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RecyclingCentreAddressKeySpecifier | (() => undefined | RecyclingCentreAddressKeySpecifier),
		fields?: RecyclingCentreAddressFieldPolicy,
	},
	SEOEntity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SEOEntityKeySpecifier | (() => undefined | SEOEntityKeySpecifier),
		fields?: SEOEntityFieldPolicy,
	},
	SearchEntity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SearchEntityKeySpecifier | (() => undefined | SearchEntityKeySpecifier),
		fields?: SearchEntityFieldPolicy,
	},
	SecLinkCombinedMenu?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SecLinkCombinedMenuKeySpecifier | (() => undefined | SecLinkCombinedMenuKeySpecifier),
		fields?: SecLinkCombinedMenuFieldPolicy,
	},
	SeoMetaDataDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SeoMetaDataDetailsKeySpecifier | (() => undefined | SeoMetaDataDetailsKeySpecifier),
		fields?: SeoMetaDataDetailsFieldPolicy,
	},
	SeoMetaDataField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SeoMetaDataFieldKeySpecifier | (() => undefined | SeoMetaDataFieldKeySpecifier),
		fields?: SeoMetaDataFieldFieldPolicy,
	},
	Showing?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShowingKeySpecifier | (() => undefined | ShowingKeySpecifier),
		fields?: ShowingFieldPolicy,
	},
	SitemapCombinedMenu?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SitemapCombinedMenuKeySpecifier | (() => undefined | SitemapCombinedMenuKeySpecifier),
		fields?: SitemapCombinedMenuFieldPolicy,
	},
	SitemapSecList?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SitemapSecListKeySpecifier | (() => undefined | SitemapSecListKeySpecifier),
		fields?: SitemapSecListFieldPolicy,
	},
	Sitemaps?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SitemapsKeySpecifier | (() => undefined | SitemapsKeySpecifier),
		fields?: SitemapsFieldPolicy,
	},
	SubMenuField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubMenuFieldKeySpecifier | (() => undefined | SubMenuFieldKeySpecifier),
		fields?: SubMenuFieldFieldPolicy,
	},
	SubMenuFieldLists?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubMenuFieldListsKeySpecifier | (() => undefined | SubMenuFieldListsKeySpecifier),
		fields?: SubMenuFieldListsFieldPolicy,
	},
	SubMenuItemList?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubMenuItemListKeySpecifier | (() => undefined | SubMenuItemListKeySpecifier),
		fields?: SubMenuItemListFieldPolicy,
	},
	SubMenuSections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubMenuSectionsKeySpecifier | (() => undefined | SubMenuSectionsKeySpecifier),
		fields?: SubMenuSectionsFieldPolicy,
	},
	TermsAndConditions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TermsAndConditionsKeySpecifier | (() => undefined | TermsAndConditionsKeySpecifier),
		fields?: TermsAndConditionsFieldPolicy,
	},
	Time?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TimeKeySpecifier | (() => undefined | TimeKeySpecifier),
		fields?: TimeFieldPolicy,
	},
	TrackingEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TrackingEventKeySpecifier | (() => undefined | TrackingEventKeySpecifier),
		fields?: TrackingEventFieldPolicy,
	},
	UpdateElabelResponseDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateElabelResponseDtoKeySpecifier | (() => undefined | UpdateElabelResponseDtoKeySpecifier),
		fields?: UpdateElabelResponseDtoFieldPolicy,
	},
	VoucherResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherResponseKeySpecifier | (() => undefined | VoucherResponseKeySpecifier),
		fields?: VoucherResponseFieldPolicy,
	},
	WebContents?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebContentsKeySpecifier | (() => undefined | WebContentsKeySpecifier),
		fields?: WebContentsFieldPolicy,
	},
	WorkOrder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WorkOrderKeySpecifier | (() => undefined | WorkOrderKeySpecifier),
		fields?: WorkOrderFieldPolicy,
	},
	baseImageUrl?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | baseImageUrlKeySpecifier | (() => undefined | baseImageUrlKeySpecifier),
		fields?: baseImageUrlFieldPolicy,
	},
	basePDFUrl?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | basePDFUrlKeySpecifier | (() => undefined | basePDFUrlKeySpecifier),
		fields?: basePDFUrlFieldPolicy,
	},
	combinedMenu?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | combinedMenuKeySpecifier | (() => undefined | combinedMenuKeySpecifier),
		fields?: combinedMenuFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  JSON: any;
};

export type Account = {
  __typename?: 'Account';
  accountNumber: Maybe<Scalars['String']>;
  consignmentId: Maybe<Scalars['String']>;
  customerName: Maybe<Scalars['String']>;
  elabelTokenGeneratedOn: Maybe<Scalars['String']>;
  elabelTokenNumber: Maybe<Scalars['String']>;
  elableReferenceNumber: Maybe<Scalars['String']>;
  elableReferenceNumberUpdatedOn: Maybe<Scalars['String']>;
  emailId: Maybe<Scalars['String']>;
  fromAddress: Maybe<Scalars['String']>;
  fromDpid: Scalars['Float'];
  houseNumber: Maybe<Scalars['String']>;
  phoneNumber: Maybe<Scalars['String']>;
  recycle: Maybe<Scalars['Boolean']>;
  return: Maybe<Scalars['Boolean']>;
  returnBoxesCount: Maybe<Scalars['Float']>;
  siteCode: Maybe<Scalars['String']>;
  toAddress: Maybe<Scalars['String']>;
  toAddressId: Maybe<Scalars['String']>;
  toContactName: Maybe<Scalars['String']>;
  toContactNumber: Maybe<Scalars['String']>;
  toDpid: Scalars['Float'];
  trackingID: Maybe<Scalars['String']>;
  trackingIDUpdatedOn: Maybe<Scalars['String']>;
  workOrderNumber: Maybe<Scalars['String']>;
};

export type AdMenu = {
  __typename?: 'AdMenu';
  footerCopyRight: Maybe<Scalars['JSON']>;
  internalName: Maybe<Scalars['String']>;
  menuItems: Maybe<Array<AdMenuItemListItem>>;
  menuSections: Maybe<Array<AdMenuItemListItem>>;
  tags: Maybe<Scalars['String']>;
};

export type AdMenuItemListItem = {
  __typename?: 'AdMenuItemListItem';
  internalName: Maybe<Scalars['String']>;
  itemIcon: Maybe<Scalars['String']>;
  itemUrl: Maybe<Scalars['String']>;
  publicName: Maybe<Scalars['String']>;
  sectionName: Maybe<Scalars['String']>;
};

export type AdMenuItemLists = {
  __typename?: 'AdMenuItemLists';
  internalName: Maybe<Scalars['String']>;
  itemIcon: Maybe<Scalars['String']>;
  itemUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  publicName: Maybe<Scalars['String']>;
};

export type AdMenuList = {
  __typename?: 'AdMenuList';
  footerCopyright: Maybe<Scalars['JSON']>;
  internalName: Maybe<Scalars['String']>;
  menuSections: Maybe<Array<AdcombinedMenu>>;
  slug: Maybe<Scalars['String']>;
};

export type AdcombinedMenu = {
  __typename?: 'AdcombinedMenu';
  itemUrl: Maybe<Scalars['String']>;
  publicName: Maybe<Scalars['String']>;
  sectionLinks: Maybe<Array<AdMenuItemLists>>;
  sectionName: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
};

export type AddressInput = {
  address_id: Scalars['Float'];
  company_name: InputMaybe<Scalars['String']>;
  country_code: InputMaybe<Scalars['String']>;
};

export type AdvResourceSet = {
  __typename?: 'AdvResourceSet';
  formSubTitle: Maybe<Scalars['String']>;
  formTitle: Maybe<Scalars['String']>;
  internalName: Maybe<Scalars['String']>;
  resources: Maybe<Array<AdvResources>>;
};

export type AdvResources = {
  __typename?: 'AdvResources';
  key: Maybe<Scalars['String']>;
  required: Maybe<Scalars['Boolean']>;
  value: Maybe<Scalars['String']>;
};

export type AdvertisingComponentCardCollections = {
  __typename?: 'AdvertisingComponentCardCollections';
  componentCards: Maybe<Array<AdvertisingComponentCardSections>>;
  internalName: Maybe<Scalars['String']>;
};

export type AdvertisingComponentCardSections = {
  __typename?: 'AdvertisingComponentCardSections';
  brightCoveVideoExperienceId: Maybe<Scalars['String']>;
  brightCoveVideoId: Maybe<Scalars['String']>;
  cardDescription: Maybe<Scalars['JSON']>;
  cardDescriptionTextAlignment: Maybe<Scalars['String']>;
  cardDetailedDescription: Maybe<Scalars['JSON']>;
  cardDetailedDescriptionAlignment: Maybe<Scalars['String']>;
  cardImageLinkUrl: Maybe<Scalars['String']>;
  cardImagePosition: Maybe<Scalars['String']>;
  cardImageUrl: Maybe<AdvertisingbaseImageUrl>;
  cardSubTitle: Maybe<Scalars['String']>;
  cardTitle: Maybe<Scalars['String']>;
  cardTitlePosition: Maybe<Scalars['String']>;
  heading: Maybe<Scalars['String']>;
  imageLinkFile: Maybe<Scalars['String']>;
  linkDocument: Maybe<AdvertisingbaseImageUrl>;
  linkText: Maybe<Scalars['String']>;
  linkUrl: Maybe<Scalars['String']>;
  links: Maybe<Array<AdvertisingLinks>>;
};

export type AdvertisingComponentCards = {
  __typename?: 'AdvertisingComponentCards';
  cardDescription: Maybe<Scalars['JSON']>;
  cardImageLinkUrl: Maybe<Scalars['String']>;
  cardImagePosition: Maybe<Scalars['String']>;
  cardImageUrl: Maybe<AdvertisingbaseImageUrl>;
  cardSubTitle: Maybe<Scalars['String']>;
  cardTitle: Maybe<Scalars['String']>;
  cardTitlePosition: Maybe<Scalars['String']>;
  componentCardCollection: Maybe<AdvertisingComponentCardCollections>;
  contentType: Maybe<Scalars['String']>;
  galleryImages: Maybe<Array<AdvertisingbaseImageUrl>>;
  iframeSrc: Maybe<Scalars['String']>;
  imageLinkFile: Maybe<Scalars['String']>;
  imgaeName: Maybe<Scalars['String']>;
  internalName: Maybe<Scalars['String']>;
  isSlider: Maybe<Scalars['Boolean']>;
  linkText: Maybe<Scalars['String']>;
  linkUrl: Maybe<Scalars['String']>;
  links: Maybe<Array<AdvertisingLinks>>;
  popupcards: Maybe<Array<AdvertisingPopupCardSection>>;
};

export type AdvertisingComposePage = {
  __typename?: 'AdvertisingComposePage';
  content: Maybe<AdvertisingWebContents>;
  heading: Maybe<Scalars['String']>;
  internalName: Maybe<Scalars['String']>;
  pageTitle: Maybe<Scalars['String']>;
  seo: Maybe<AdvertisingSeos>;
  slug: Maybe<Scalars['String']>;
  subMenu: Maybe<AdMenuList>;
};

export type AdvertisingContents = {
  __typename?: 'AdvertisingContents';
  bannerContent: Maybe<AdvertisingHeroBannerContents>;
  componentCardDisplayTile: Maybe<Scalars['String']>;
  componentCardSectionTitle: Maybe<Scalars['String']>;
  componentCards: Maybe<Array<AdvertisingComponentCards>>;
  contentType: Maybe<Scalars['String']>;
  freeFormContent: Maybe<Array<AdvertisingFreeFormContents>>;
  internalName: Maybe<Scalars['String']>;
  isSlider: Maybe<Scalars['Boolean']>;
  menu: Maybe<AdMenuList>;
  popupcards: Maybe<Array<AdvertisingPopupCardSection>>;
  railContent: Maybe<AdvertisingRailContentSetClass>;
  resourceSet: Maybe<AdvResourceSet>;
};

export type AdvertisingFreeFormContents = {
  __typename?: 'AdvertisingFreeFormContents';
  backgroundImage: Maybe<AdvertisingbaseImageUrl>;
  content: Maybe<Scalars['JSON']>;
  heading: Maybe<Scalars['String']>;
  headingBackgroundGradientColor: Maybe<Scalars['String']>;
  headingTextPosition: Maybe<Scalars['String']>;
  internalName: Maybe<Scalars['String']>;
  logoImage: Maybe<AdvertisingbaseImageUrl>;
  subHeading: Maybe<Scalars['String']>;
  videoUrl: Maybe<Scalars['String']>;
};

export type AdvertisingHeroBannerContents = {
  __typename?: 'AdvertisingHeroBannerContents';
  bannerDescription: Maybe<Scalars['String']>;
  bannerImage: Maybe<AdvertisingbaseImageUrl>;
  bannerTitle: Maybe<Scalars['String']>;
  internalName: Maybe<Scalars['String']>;
  linkText: Maybe<Scalars['String']>;
  linkUrl: Maybe<Scalars['String']>;
};

export type AdvertisingImageClass = {
  __typename?: 'AdvertisingImageClass';
  contentType: Maybe<Scalars['String']>;
  file: Maybe<Scalars['String']>;
  height: Maybe<Scalars['Float']>;
  text: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
  width: Maybe<Scalars['Float']>;
};

export type AdvertisingLinks = {
  __typename?: 'AdvertisingLinks';
  internalName: Maybe<Scalars['String']>;
  linkDocument: Maybe<AdvertisingbaseImageUrl>;
  linkText: Maybe<Scalars['String']>;
  linkUrl: Maybe<Scalars['String']>;
};

export type AdvertisingPopupCardSection = {
  __typename?: 'AdvertisingPopupCardSection';
  backgroundGradient: Maybe<Scalars['String']>;
  internalName: Maybe<Scalars['String']>;
  linkText: Maybe<Scalars['String']>;
  linkUrl: Maybe<Scalars['String']>;
  popupCard: Maybe<Scalars['String']>;
  popupCardDescription: Maybe<Scalars['JSON']>;
  popupCardIconURL: Maybe<Scalars['String']>;
  popupCardImageLinkURL: Maybe<Scalars['String']>;
  popupCardImageURL: Maybe<Scalars['String']>;
  popupCardSubTitle: Maybe<Scalars['String']>;
  popupCardTitle: Maybe<Scalars['String']>;
};

export type AdvertisingRailContentSetClass = {
  __typename?: 'AdvertisingRailContentSetClass';
  componentTitle: Maybe<Scalars['JSON']>;
  images: Maybe<Array<AdvertisingImageClass>>;
};

export type AdvertisingSeos = {
  __typename?: 'AdvertisingSeos';
  Image: Maybe<Scalars['String']>;
  description: Maybe<Scalars['JSON']>;
  excludeLinks: Maybe<Scalars['Boolean']>;
  hidePageFromSE: Maybe<Scalars['Boolean']>;
  internalName: Maybe<Scalars['String']>;
  seoTitle: Maybe<Scalars['String']>;
  urlSlug: Maybe<Scalars['String']>;
};

export type AdvertisingWebContents = {
  __typename?: 'AdvertisingWebContents';
  content: Maybe<Array<AdvertisingContents>>;
  internalName: Maybe<Scalars['String']>;
};

export type AdvertisingbaseImageUrl = {
  __typename?: 'AdvertisingbaseImageUrl';
  description: Maybe<Scalars['String']>;
  file: Maybe<Scalars['String']>;
  text: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type ArticalCompose = {
  __typename?: 'ArticalCompose';
  articleType: Maybe<Scalars['String']>;
  date: Maybe<Scalars['String']>;
  heading: Maybe<Scalars['String']>;
  internalName: Maybe<Scalars['String']>;
  linkDocument: Maybe<BasePdfUrl>;
  linkText: Maybe<Scalars['String']>;
  linkUrl: Maybe<Scalars['String']>;
  selectCategories: Maybe<Array<Scalars['String']>>;
};

export type ArticleCollections = {
  __typename?: 'ArticleCollections';
  articleType: Maybe<Scalars['String']>;
  articlesPerPage: Maybe<Scalars['Float']>;
  description: Maybe<Scalars['JSON']>;
  headingBackgroundColor: Maybe<Scalars['String']>;
  internalName: Maybe<Scalars['String']>;
  searchText: Maybe<Scalars['String']>;
  sectionTitle: Maybe<Scalars['String']>;
};

export type BMenuItemLists = {
  __typename?: 'BMenuItemLists';
  itemIcon: Maybe<Scalars['String']>;
  itemUrl: Maybe<Scalars['String']>;
  publicName: Maybe<Scalars['String']>;
};

export type BMenuList = {
  __typename?: 'BMenuList';
  footerCopyright: Maybe<Scalars['JSON']>;
  internalName: Maybe<Scalars['String']>;
  menuSections: Maybe<Array<BusinessCombinedMenu>>;
};

export type BannerContents = {
  __typename?: 'BannerContents';
  bannerName: Maybe<Scalars['String']>;
  bannerTitle: Maybe<Scalars['String']>;
  brightCoveVideoExperienceId: Maybe<Scalars['String']>;
  brightCoveVideoId: Maybe<Scalars['String']>;
  brightCoveVideoIdMobile: Maybe<Scalars['String']>;
  callToActionLink: Maybe<Scalars['String']>;
  callToActionLinkSecondary: Maybe<Scalars['String']>;
  callToActionSecondaryText: Maybe<Scalars['String']>;
  callToActionText: Maybe<Scalars['String']>;
  channelOrSponsorLogos: Maybe<BaseImageUrl>;
  copyrightParagraph: Maybe<Scalars['JSON']>;
  detailParagraph: Maybe<Scalars['JSON']>;
  detailParagraphColumn2: Maybe<Scalars['JSON']>;
  heading: Maybe<Scalars['JSON']>;
  heroBrandBackground: Maybe<Scalars['String']>;
  heroImage: Maybe<BaseImageUrl>;
  heroImageMobile: Maybe<BaseImageUrl>;
  iframeTitle: Maybe<Scalars['String']>;
  iframeUrl: Maybe<BaseImageUrl>;
  layoutOptions: Maybe<Scalars['String']>;
  lozengeText: Maybe<Scalars['String']>;
};

export type Billing = {
  __typename?: 'Billing';
  /** Maps directly to accountNumber field in billing */
  accountNumber: Scalars['String'];
  /** Has active broadband */
  activeBroadband: Scalars['Boolean'];
  /** Broadband only account */
  broadbandOnlyAccount: Scalars['Boolean'];
  campaigns: Maybe<Array<Campaign>>;
  currentTotalAmountDueCents: Scalars['Float'];
  /** Customer does not have an active starter but has boxes */
  digitalRental: Scalars['Boolean'];
  /** Customer in arrears of less than 30 days */
  isCustomerInArrears: Scalars['Boolean'];
  /** Customer in arrears of more than 30 days */
  isCustomerInArrearsThirtyDays: Scalars['Boolean'];
  monthlyCharge: Scalars['Float'];
  /** Customer has no active occurrence found in his billing details */
  occurrenceNotFound: Scalars['Boolean'];
  /** Maps directly to paperLessBilling field from MSL billing */
  paperLessBilling: Maybe<Scalars['Boolean']>;
  /** Primary box is pending upgrade to arrow */
  pendingArrowUpgrade: Scalars['Boolean'];
  /** Pending broadband order */
  pendingBroadband: Scalars['Boolean'];
  /** Customer products set i.e Front Book or Back Book */
  productSet: Maybe<Scalars['String']>;
  products: Array<Product>;
  /** Maps to statementDueDate in billing */
  statementDueDate: Maybe<Scalars['String']>;
  /** Is summerset account */
  summerset: Scalars['Boolean'];
};

export type BusinessCardFile = {
  __typename?: 'BusinessCardFile';
  contentType: Maybe<Scalars['String']>;
  fileName: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type BusinessCardImage = {
  __typename?: 'BusinessCardImage';
  description: Maybe<Scalars['String']>;
  file: Maybe<BusinessCardFile>;
  title: Maybe<Scalars['String']>;
};

export type BusinessCards = {
  __typename?: 'BusinessCards';
  description: Maybe<Scalars['String']>;
  gradientColor: Maybe<Scalars['String']>;
  imageUrl: Maybe<Scalars['String']>;
  internalName: Maybe<Scalars['String']>;
  linkText: Maybe<Scalars['String']>;
  linkUrl: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type BusinessCombinedMenu = {
  __typename?: 'BusinessCombinedMenu';
  itemIcon: Maybe<Scalars['String']>;
  itemUrl: Maybe<Scalars['String']>;
  publicName: Maybe<Scalars['String']>;
  sectionLinks: Maybe<Array<BMenuItemLists>>;
  sectionName: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
};

export type BusinessComposeContent = {
  __typename?: 'BusinessComposeContent';
  businessContent: Maybe<Array<BusinessContent>>;
  internalName: Maybe<Scalars['String']>;
  sitemap: Maybe<Array<BMenuList>>;
};

export type BusinessComposePage = {
  __typename?: 'BusinessComposePage';
  contactUsSectionRequired: Maybe<Scalars['Boolean']>;
  content: Maybe<BusinessComposeContent>;
  internalName: Maybe<Scalars['String']>;
  pageTitle: Maybe<Scalars['String']>;
  requestACallBackFormRequired: Maybe<Scalars['Boolean']>;
  seo: Maybe<Scalars['JSON']>;
  slug: Maybe<Scalars['String']>;
  subMenu: Maybe<Array<BMenuList>>;
};

export type BusinessContent = {
  __typename?: 'BusinessContent';
  accordionTitle: Maybe<Scalars['String']>;
  backgroundVideoId: Maybe<Scalars['String']>;
  bannerImage: Maybe<Scalars['String']>;
  bannerPhoneNumber: Maybe<Scalars['String']>;
  bannerSubTitle: Maybe<Scalars['String']>;
  bannerTitle: Maybe<Scalars['String']>;
  componentSectionTitle: Maybe<Scalars['String']>;
  components: Maybe<Array<Components>>;
  content: Maybe<Scalars['JSON']>;
  contentType: Maybe<Scalars['String']>;
  description: Maybe<Scalars['JSON']>;
  displayTile: Maybe<Scalars['String']>;
  exploreLinkText: Maybe<Scalars['String']>;
  exploreLinkUrl: Maybe<Scalars['String']>;
  exploreScrollContent: Maybe<Scalars['JSON']>;
  exploreScrollHeading: Maybe<Scalars['String']>;
  formSubTitle: Maybe<Scalars['String']>;
  formTitle: Maybe<Scalars['String']>;
  heading: Maybe<Scalars['String']>;
  headingPosition: Maybe<Scalars['String']>;
  iframeUrl: Maybe<Scalars['String']>;
  internalName: Maybe<Scalars['String']>;
  isAccordion: Maybe<Scalars['String']>;
  isCarousel: Maybe<Scalars['String']>;
  isProductBanner: Maybe<Scalars['String']>;
  isProductSection: Maybe<Scalars['String']>;
  isRelatedContentSection: Maybe<Scalars['Boolean']>;
  primaryLinkText: Maybe<Scalars['String']>;
  primaryLinkUrl: Maybe<Scalars['String']>;
  resources: Maybe<Array<BusinessResources>>;
  secondaryLinkText: Maybe<Scalars['String']>;
  secondaryLinkVideoId: Maybe<Scalars['String']>;
  sectionSubTitle: Maybe<Scalars['String']>;
};

export type BusinessLinks = {
  __typename?: 'BusinessLinks';
  linkDocument: Maybe<BusinessCardImage>;
  linkText: Maybe<Scalars['String']>;
  linkUrl: Maybe<Scalars['String']>;
};

export type BusinessResourceSet = {
  __typename?: 'BusinessResourceSet';
  formSubTitle: Maybe<Scalars['String']>;
  formTitle: Maybe<Scalars['String']>;
  internalName: Maybe<Scalars['String']>;
  resources: Maybe<Array<BusinessResources>>;
};

export type BusinessResources = {
  __typename?: 'BusinessResources';
  key: Maybe<Scalars['String']>;
  required: Maybe<Scalars['Boolean']>;
  value: Maybe<Scalars['String']>;
};

export type Campaign = {
  __typename?: 'Campaign';
  active: Scalars['Boolean'];
  beginDate: Maybe<Scalars['String']>;
  endDate: Maybe<Scalars['String']>;
  groupCode: Maybe<Scalars['String']>;
  isPromotionDescriptionDynamic: Maybe<Scalars['Boolean']>;
  promotionCode: Scalars['String'];
  promotionDescription: Maybe<Scalars['String']>;
};

export type CardContainer = {
  __typename?: 'CardContainer';
  contractDescription: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  detailDescription: Maybe<Scalars['JSON']>;
  explorePopupCopy: Maybe<Scalars['String']>;
  horizontalImageUrl: Maybe<ImageUrl>;
  horizontalVideoUrl: Maybe<Scalars['String']>;
  iconImageUrl: Maybe<Array<IconImage>>;
  internalName: Maybe<Scalars['String']>;
  linkLabel: Maybe<Scalars['String']>;
  linkUrl: Maybe<Scalars['String']>;
  logoImageUrl: Maybe<ImageUrl>;
  mainImageUrl: Maybe<ImageUrl>;
  name: Maybe<Scalars['String']>;
  popupCards: Maybe<Array<PopupCard>>;
  price: Maybe<Scalars['Float']>;
  showExplorePopup: Maybe<Scalars['Boolean']>;
  sku: Maybe<Scalars['String']>;
  videoUrl: Maybe<Scalars['String']>;
};

export type ChannelSetDetails = {
  __typename?: 'ChannelSetDetails';
  fields: Maybe<ChannelSetItem>;
  sys: Maybe<NbjComposeComponentModelId>;
};

export type ChannelSetItem = {
  __typename?: 'ChannelSetItem';
  detailInformation: Maybe<Scalars['JSON']>;
  images: Maybe<Array<MediaContentDetails>>;
  title: Maybe<Scalars['String']>;
};

export type ComponentCardClass = {
  __typename?: 'ComponentCardClass';
  cardDescription: Maybe<Scalars['String']>;
  cardDescriptionTextAlignment: Maybe<Scalars['String']>;
  cardDetailedDescription: Maybe<Scalars['JSON']>;
  cardDetailedDescriptionAlignment: Maybe<Scalars['String']>;
  cardImageLinkUrl: Maybe<Scalars['String']>;
  cardImagePosition: Maybe<Scalars['String']>;
  cardImageUrl: Maybe<BaseImageUrl>;
  cardSubTitle: Maybe<Scalars['String']>;
  cardTitle: Maybe<Scalars['String']>;
  contentType: Maybe<Scalars['String']>;
  heading: Maybe<Scalars['String']>;
  internalName: Maybe<Scalars['String']>;
  isSlider: Maybe<Scalars['Boolean']>;
  linkText: Maybe<Scalars['String']>;
  linkUrl: Maybe<Scalars['String']>;
  links: Maybe<Array<LinkClass>>;
};

export type ComponentCardCollections = {
  __typename?: 'ComponentCardCollections';
  componentCards: Maybe<Array<ComponentCardSections>>;
  internalName: Maybe<Scalars['String']>;
};

export type ComponentCardSection = {
  __typename?: 'ComponentCardSection';
  componentCardDisplayTile: Maybe<Scalars['String']>;
  componentCardSectionTitle: Maybe<Scalars['String']>;
  componentCards: Maybe<Array<ComponentCardClass>>;
  contentType: Maybe<Scalars['String']>;
  internalName: Maybe<Scalars['String']>;
  isCarousel: Maybe<Scalars['Boolean']>;
};

export type ComponentCardSections = {
  __typename?: 'ComponentCardSections';
  LinksCollection: Maybe<LinksCollections>;
  backgroundGradientColor: Maybe<Scalars['String']>;
  brightCoveVideoExperienceId: Maybe<Scalars['String']>;
  brightCoveVideoId: Maybe<Scalars['String']>;
  cardDescription: Maybe<Scalars['String']>;
  cardDescriptionTextAlignment: Maybe<Scalars['String']>;
  cardDetailedDescription: Maybe<Scalars['JSON']>;
  cardDetailedDescriptionAlignment: Maybe<Scalars['String']>;
  cardImageLinkUrl: Maybe<Scalars['String']>;
  cardImagePosition: Maybe<Scalars['String']>;
  cardImageUrl: Maybe<BaseImageUrl>;
  cardSubTitle: Maybe<Scalars['String']>;
  cardTitle: Maybe<Scalars['String']>;
  footnoteText: Maybe<Scalars['JSON']>;
  heading: Maybe<Scalars['String']>;
  iframeSourceUrl: Maybe<Scalars['String']>;
  iframeTitle: Maybe<Scalars['String']>;
  imageType: Maybe<Scalars['String']>;
  linkAlignmentPosition: Maybe<Scalars['String']>;
  linkDocument: Maybe<BaseImageUrl>;
  linkText: Maybe<Scalars['String']>;
  linkUrl: Maybe<Scalars['String']>;
  links: Maybe<Array<Links>>;
  subTitleAlignmentPosition: Maybe<Scalars['String']>;
  titleAlignmentPosition: Maybe<Scalars['String']>;
};

export type ComponentCards = {
  __typename?: 'ComponentCards';
  LinksCollection: Maybe<LinksCollections>;
  backgroundGradientColor: Maybe<Scalars['String']>;
  brightCoveVideoExperienceId: Maybe<Scalars['String']>;
  brightCoveVideoId: Maybe<Scalars['String']>;
  cardDescription: Maybe<Scalars['String']>;
  cardDescriptionTextAlignment: Maybe<Scalars['String']>;
  cardDetailedDescription: Maybe<Scalars['JSON']>;
  cardDetailedDescriptionAlignment: Maybe<Scalars['String']>;
  cardImageLinkUrl: Maybe<Scalars['String']>;
  cardImagePosition: Maybe<Scalars['String']>;
  cardImageUrl: Maybe<BaseImageUrl>;
  cardSubTitle: Maybe<Scalars['String']>;
  cardTitle: Maybe<Scalars['String']>;
  componentCardCollection: Maybe<ComponentCardCollections>;
  contentType: Maybe<Scalars['String']>;
  footnoteText: Maybe<Scalars['JSON']>;
  heading: Maybe<Scalars['String']>;
  imageType: Maybe<Scalars['String']>;
  internalName: Maybe<Scalars['String']>;
  isSlider: Maybe<Scalars['Boolean']>;
  linkAlignmentPosition: Maybe<Scalars['String']>;
  linkDocument: Maybe<BaseImageUrl>;
  linkText: Maybe<Scalars['String']>;
  linkUrl: Maybe<Scalars['String']>;
  links: Maybe<Array<Links>>;
  popupcards: Maybe<Array<PopupCardSection>>;
  subTitleAlignmentPosition: Maybe<Scalars['String']>;
  titleAlignmentPosition: Maybe<Scalars['String']>;
};

export type Components = {
  __typename?: 'Components';
  autoplay: Maybe<Scalars['String']>;
  backgroundGradientColor: Maybe<Scalars['String']>;
  brightcoveVideoId: Maybe<Scalars['String']>;
  cardDescription: Maybe<Scalars['JSON']>;
  cardTitle: Maybe<Scalars['String']>;
  cards: Maybe<Array<BusinessCards>>;
  contentOverImage: Maybe<Scalars['String']>;
  contentType: Maybe<Scalars['String']>;
  footNoteText: Maybe<Scalars['String']>;
  imageLinkDocument: Maybe<BusinessCardImage>;
  imageLinkUrl: Maybe<Scalars['String']>;
  imagePosition: Maybe<Scalars['String']>;
  imageType: Maybe<Scalars['String']>;
  imageUrl: Maybe<BusinessCardImage>;
  images: Maybe<Array<BusinessCardImage>>;
  internalName: Maybe<Scalars['String']>;
  isSlider: Maybe<Scalars['String']>;
  linkText: Maybe<Scalars['String']>;
  links: Maybe<Array<BusinessLinks>>;
  logoImage: Maybe<BusinessCardImage>;
};

export type ComposePage = {
  __typename?: 'ComposePage';
  content: Maybe<WebContents>;
  heading: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  seo: Maybe<Scalars['JSON']>;
  slug: Maybe<Scalars['String']>;
  subMenu: Maybe<Array<MenuSectionLists>>;
  title: Maybe<Scalars['String']>;
};

export type ContactInfo = {
  __typename?: 'ContactInfo';
  content: Maybe<Array<ContentInfo>>;
  heading: Maybe<Scalars['String']>;
  internalName: Maybe<Scalars['String']>;
  subHeading: Maybe<Scalars['String']>;
};

export type ContentInfo = {
  __typename?: 'ContentInfo';
  type: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

export type ContentModelsFields = {
  __typename?: 'ContentModelsFields';
  fields: Maybe<ContentModelsList>;
  sys: Maybe<NbjComposeComponentModelId>;
};

export type ContentModelsList = {
  __typename?: 'ContentModelsList';
  alignmentOfInfoContent: Maybe<Scalars['String']>;
  alignmentOfVideoImage: Maybe<Scalars['String']>;
  brightCoverVideoIdDesktop: Maybe<Scalars['String']>;
  brightCoverVideoIdMobile: Maybe<Scalars['String']>;
  catalogMembers: Maybe<Array<ProductCardDetails>>;
  classNameReference: Maybe<Scalars['String']>;
  contentModelType: Maybe<Scalars['String']>;
  contentRails: Maybe<Scalars['JSON']>;
  ctaButtonOneColorVariant: Maybe<Scalars['String']>;
  ctaButtonOneLink: Maybe<Scalars['String']>;
  ctaButtonOneText: Maybe<Scalars['String']>;
  ctaButtonTwoColorVariant: Maybe<Scalars['String']>;
  ctaButtonTwoLink: Maybe<Scalars['String']>;
  ctaButtonTwoText: Maybe<Scalars['String']>;
  ctaMoreInfoColorVariant: Maybe<Scalars['String']>;
  ctaMoreInfoImage: Maybe<MediaContentDetails>;
  ctaMoreInfoLink: Maybe<Scalars['String']>;
  ctaMoreInfoText: Maybe<Scalars['String']>;
  description: Maybe<Scalars['JSON']>;
  disableGradientOverlay: Maybe<Scalars['Boolean']>;
  firstName: Maybe<Scalars['String']>;
  headingH: Maybe<Scalars['JSON']>;
  image: Maybe<MediaContentDetails>;
  imageDesktop: Maybe<MediaContentDetails>;
  imageMobile: Maybe<MediaContentDetails>;
  imagePosition: Maybe<Scalars['String']>;
  imageTablet: Maybe<MediaContentDetails>;
  images: Maybe<Array<MediaContentDetails>>;
  internalName: Maybe<Scalars['String']>;
  landscapeImage: Maybe<MediaContentDetails>;
  lastName: Maybe<Scalars['String']>;
  layoutOption: Maybe<Scalars['String']>;
  link: Maybe<Scalars['String']>;
  moreInfo: Maybe<Scalars['JSON']>;
  productCards: Maybe<Array<ProductCardDetails>>;
  profileImage: Maybe<MediaContentDetails>;
  railType: Maybe<Scalars['String']>;
  rating: Maybe<Scalars['String']>;
  shortDetails: Maybe<Scalars['String']>;
  shortOfInformation: Maybe<Scalars['String']>;
  synopsesImages: Maybe<Array<MediaContentDetails>>;
  termsAndConditionsCaption: Maybe<Scalars['JSON']>;
  testHeaders: Maybe<Scalars['JSON']>;
  tileImages: Maybe<Array<MediaContentDetails>>;
  title: Maybe<Scalars['String']>;
  titleH: Maybe<Scalars['JSON']>;
  titleImage: Maybe<MediaContentDetails>;
};

export type Contents = {
  __typename?: 'Contents';
  articleCollection: Maybe<ArticleCollections>;
  bannerContent: Maybe<BannerContents>;
  bannerName: Maybe<Scalars['String']>;
  bgTitle: Maybe<Scalars['String']>;
  cardPanel: Maybe<ProductCarousels>;
  componentCardDisplayTile: Maybe<Scalars['String']>;
  componentCardSectionTitle: Maybe<Scalars['String']>;
  componentCards: Maybe<Array<ComponentCards>>;
  contentType: Maybe<Scalars['String']>;
  freeformContent: Maybe<FreeFormContent>;
  isCarousel: Maybe<Scalars['Boolean']>;
  isExpandable: Maybe<Scalars['Boolean']>;
  leadsContent: Maybe<LeadsContent>;
  logoContentAccordion: Maybe<LogoContentAccordions>;
  referenceId: Maybe<Scalars['String']>;
  rollingBanner: Maybe<Array<BannerContents>>;
  sitemap: Maybe<Sitemaps>;
  slug: Maybe<Scalars['String']>;
  subTitle: Maybe<Scalars['String']>;
  subTitleTextAlignment: Maybe<Scalars['String']>;
  terms: Maybe<Scalars['JSON']>;
  title: Maybe<Scalars['String']>;
  titleBackgroundGradientColor: Maybe<Scalars['String']>;
  titleTextAlignment: Maybe<Scalars['String']>;
  visibility: Maybe<Scalars['String']>;
};

export type Coupon = {
  __typename?: 'Coupon';
  couponCode: Scalars['String'];
  custom1: Scalars['String'];
  custom2: Scalars['String'];
  custom3: Scalars['String'];
  custom4: Scalars['String'];
  custom5: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['Float'];
  name: Scalars['String'];
};

export type CreateLabelInput = {
  account_number: Scalars['String'];
  carrier: Scalars['String'];
  delivery_address: AddressInput;
  fromAddress: Scalars['String'];
  parcel_details: Array<ParcelDetailInput>;
  pickup_address: InputMaybe<AddressInput>;
  receiver_details: ReceiverDetailsInput;
  sender_details: SenderDetailsInput;
  sender_reference1: Scalars['String'];
  sender_reference2: Scalars['String'];
  toAddress: Scalars['String'];
  tokenNumber: Scalars['String'];
};

export type CreateLabelResponse = {
  __typename?: 'CreateLabelResponse';
  consignment_id: Scalars['String'];
  consignment_status: Scalars['String'];
  fromAddress: Scalars['String'];
  message_id: Scalars['String'];
  success: Scalars['Boolean'];
  toAddress: Scalars['String'];
  tracking_id: Scalars['String'];
};

export type Customer = {
  __typename?: 'Customer';
  /** Account number */
  accountNumber: Scalars['String'];
  category: Maybe<Scalars['String']>;
  deliveryDetails: Maybe<Scalars['JSON']>;
  externalAccountId: Maybe<Scalars['String']>;
  fusionRegion: Maybe<Scalars['String']>;
  houseNumber: Scalars['String'];
  paperLessBilling: Scalars['Boolean'];
  /** Maps directly to Parties in MSL Customer response */
  parties: Scalars['JSON'];
  privacyList: Maybe<Scalars['JSON']>;
  secondaryLocatorCode: Maybe<Scalars['String']>;
  serviceAddress: Maybe<Scalars['JSON']>;
  serviceContactEmail: Maybe<Scalars['String']>;
  tuiAddressCode: Scalars['String'];
  type: Maybe<Scalars['String']>;
};

export type DeviceInfo = {
  __typename?: 'DeviceInfo';
  fields: Maybe<DeviceInfoFields>;
};

export type DeviceInfoFields = {
  __typename?: 'DeviceInfoFields';
  bottomTitle: Maybe<Scalars['JSON']>;
  infoTitle: Maybe<Scalars['String']>;
  members: Maybe<Array<ProductFeatureSetField>>;
  title: Maybe<Scalars['String']>;
  titleImage: Maybe<MediaContentDetails>;
};

export type DimensionsInput = {
  height_cm: Scalars['Float'];
  length_cm: Scalars['Float'];
  weight_kg: Scalars['Float'];
  width_cm: Scalars['Float'];
};

export type EligibilityOffer = {
  __typename?: 'EligibilityOffer';
  additionalPackages: Maybe<Scalars['String']>;
  applies: Maybe<Scalars['String']>;
  campaign: Scalars['String'];
  campaignDescription: Maybe<Scalars['String']>;
  category: Maybe<Scalars['String']>;
  client: Maybe<Scalars['String']>;
  discountServiceCode: Maybe<Scalars['String']>;
  displayPromptOffer: Maybe<Scalars['Boolean']>;
  eligibilityExcludeCampaign: Maybe<Scalars['String']>;
  eligibilityExcludeServiceCode: Maybe<Scalars['String']>;
  eligibilityID: Maybe<Scalars['String']>;
  eligibilityIncludeCampaign: Maybe<Scalars['String']>;
  eligibilityIncludeServiceCode: Maybe<Scalars['String']>;
  eligibleFor: Scalars['String'];
  offerPackages: Maybe<Scalars['String']>;
  overrideCurrentOffer: Maybe<Scalars['Boolean']>;
  priority: Scalars['Float'];
  production: Maybe<Scalars['Boolean']>;
  promotion: Maybe<Scalars['JSON']>;
  qualifies: Scalars['Boolean'];
  recordType: Maybe<Scalars['String']>;
  subscriberKey: Maybe<Scalars['String']>;
  validToDate: Maybe<Scalars['String']>;
};

export type FaqsListDetails = {
  __typename?: 'FaqsListDetails';
  fields: Maybe<FaqsListItems>;
  sys: Maybe<NbjComposeComponentModelId>;
};

export type FaqsListItems = {
  __typename?: 'FaqsListItems';
  answer: Maybe<Scalars['JSON']>;
  question: Maybe<Scalars['String']>;
};

export type FreeFormContent = {
  __typename?: 'FreeFormContent';
  alignmentPosition: Maybe<Scalars['String']>;
  backgroundGradientColor: Maybe<Scalars['String']>;
  content: Maybe<Scalars['JSON']>;
  heading: Maybe<Scalars['String']>;
  iframeTitle: Maybe<Scalars['String']>;
  iframeUrl: Maybe<Scalars['String']>;
  imageUrl: Maybe<BaseImageUrl>;
  subHeading: Maybe<Scalars['String']>;
  visibility: Maybe<Scalars['String']>;
};

export type GlobalFooter = {
  __typename?: 'GlobalFooter';
  footerCopyright: Maybe<Scalars['JSON']>;
  internalName: Maybe<Scalars['String']>;
  menuSections: Maybe<Array<GlobalMenuItemLists>>;
};

export type GlobalMenuItemLists = {
  __typename?: 'GlobalMenuItemLists';
  internalName: Maybe<Scalars['String']>;
  itemIcon: Maybe<Scalars['String']>;
  itemUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  publicName: Maybe<Scalars['String']>;
};

export type GlobalMenuList = {
  __typename?: 'GlobalMenuList';
  footerCopyright: Maybe<Scalars['JSON']>;
  internalName: Maybe<Scalars['String']>;
  menuSections: Maybe<Array<CombinedMenu>>;
  slug: Maybe<Scalars['String']>;
};

export type IconDetails = {
  __typename?: 'IconDetails';
  text: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type IconImage = {
  __typename?: 'IconImage';
  description: Maybe<Scalars['String']>;
  iconImageUrl: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type IconTempleteDetails = {
  __typename?: 'IconTempleteDetails';
  fields: Maybe<IconTempleteItem>;
  sys: Maybe<NbjComposeComponentModelId>;
};

export type IconTempleteItem = {
  __typename?: 'IconTempleteItem';
  icon: Maybe<MediaContentDetails>;
  sys: Maybe<NbjComposeComponentModelId>;
  title: Maybe<Scalars['String']>;
};

export type ImageDetails = {
  __typename?: 'ImageDetails';
  text: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type ImageUrl = {
  __typename?: 'ImageUrl';
  text: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type Label = {
  __typename?: 'Label';
  label_generation_status: Scalars['String'];
  label_id: Scalars['String'];
  tracking_reference: Maybe<Scalars['String']>;
};

export type LeadsContent = {
  __typename?: 'LeadsContent';
  alignment: Maybe<Scalars['String']>;
  htmlInput: Maybe<Scalars['String']>;
  internalName: Maybe<Scalars['String']>;
  pageTarget: Maybe<Array<Scalars['String']>>;
  scope: Maybe<Scalars['String']>;
  sessionExpireDays: Maybe<Scalars['Float']>;
  timeInSecond: Maybe<Scalars['Float']>;
};

export type LinkClass = {
  __typename?: 'LinkClass';
  internalName: Maybe<Scalars['String']>;
  linkDocument: Maybe<BaseImageUrl>;
  linkText: Maybe<Scalars['String']>;
  linkUrl: Maybe<Scalars['String']>;
};

export type Links = {
  __typename?: 'Links';
  alignmentPosition: Maybe<Scalars['String']>;
  backgroundGradientColor: Maybe<Scalars['String']>;
  internalName: Maybe<Scalars['String']>;
  linkDocument: Maybe<BaseImageUrl>;
  linkImage: Maybe<BaseImageUrl>;
  linkImageForLogin: Maybe<BaseImageUrl>;
  linkText: Maybe<Scalars['String']>;
  linkTextForLogin: Maybe<Scalars['String']>;
  linkUrl: Maybe<Scalars['String']>;
  linkUrlForLogin: Maybe<Scalars['String']>;
};

export type LinksCollections = {
  __typename?: 'LinksCollections';
  internalName: Maybe<Scalars['String']>;
  links: Maybe<Array<Links>>;
};

export type LogoContentAccordions = {
  __typename?: 'LogoContentAccordions';
  content: Maybe<Scalars['JSON']>;
  heading: Maybe<Scalars['String']>;
  headingBackgroundColor: Maybe<Scalars['String']>;
  internalName: Maybe<Scalars['String']>;
  logos: Maybe<Array<BaseImageUrl>>;
  subHeading: Maybe<Scalars['String']>;
};

export type MediaContentDetails = {
  __typename?: 'MediaContentDetails';
  fields: Maybe<MediaContentItem>;
  sys: Maybe<NbjComposeComponentModelId>;
};

export type MediaContentItem = {
  __typename?: 'MediaContentItem';
  description: Maybe<Scalars['String']>;
  file: Maybe<Scalars['JSON']>;
  title: Maybe<Scalars['String']>;
};

export type MediaItems = {
  __typename?: 'MediaItems';
  internalName: Maybe<Scalars['String']>;
  itemIcon: Maybe<Scalars['String']>;
  itemUrl: Maybe<Scalars['String']>;
  publicName: Maybe<Scalars['String']>;
};

export type MediaSections = {
  __typename?: 'MediaSections';
  internalName: Maybe<Scalars['String']>;
  sectionLinks: Maybe<Array<MediaItems>>;
  sectionName: Maybe<Scalars['String']>;
  tags: Maybe<Scalars['String']>;
};

export type Menu = {
  __typename?: 'Menu';
  internalName: Maybe<Scalars['String']>;
  menuSections: Maybe<Array<MenuItemSectionLists>>;
  tags: Maybe<Scalars['String']>;
};

export type MenuItemList = {
  __typename?: 'MenuItemList';
  internalName: Maybe<Scalars['String']>;
  itemIcon: Maybe<Scalars['String']>;
  itemUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

export type MenuItemListItem = {
  __typename?: 'MenuItemListItem';
  internalName: Maybe<Scalars['String']>;
  itemIcon: Maybe<Scalars['String']>;
  itemUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

export type MenuItemLists = {
  __typename?: 'MenuItemLists';
  internalName: Maybe<Scalars['String']>;
  itemIcon: Maybe<Scalars['String']>;
  itemUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

export type MenuItemSectionLists = {
  __typename?: 'MenuItemSectionLists';
  sectionLinks: Maybe<Array<MenuItemListItem>>;
  sectionName: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
};

export type MenuList = {
  __typename?: 'MenuList';
  internalName: Maybe<Scalars['String']>;
  menuSections: Maybe<Array<MenuItemLists>>;
  tags: Maybe<Scalars['String']>;
};

export type MenuSectionList = {
  __typename?: 'MenuSectionList';
  sectionLinks: Maybe<Array<MenuItemList>>;
  sectionName: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
};

export type MenuSectionListFields = {
  __typename?: 'MenuSectionListFields';
  fields: Maybe<NbjMenuItemLists>;
};

export type MenuSectionLists = {
  __typename?: 'MenuSectionLists';
  parentMenu: Maybe<Array<SubMenuItemList>>;
  sectionLinks: Maybe<Array<SubMenuItemList>>;
  sectionName: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Create a label for a parcel */
  createLabel: CreateLabelResponse;
  updateElabel: UpdateElabelResponseDto;
  validateVoucher: VoucherResponse;
};


export type MutationCreateLabelArgs = {
  input: CreateLabelInput;
};


export type MutationUpdateElabelArgs = {
  input: UpdateElabelDto;
};


export type MutationValidateVoucherArgs = {
  input: VoucherInput;
};

export type NbjCombinedMenu = {
  __typename?: 'NBJCombinedMenu';
  itemIcon: Maybe<Scalars['JSON']>;
  itemUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  sectionLinks: Maybe<Array<NbjNestedMenuSectionLists>>;
  sectionName: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  tooltip: Maybe<Scalars['String']>;
};

export type NbjComposeComponentItems = {
  __typename?: 'NBJComposeComponentItems';
  fields: Maybe<NbjComposeTypeDetails>;
  sys: Maybe<NbjComposeComponentModelId>;
};

export type NbjComposeComponentModelId = {
  __typename?: 'NBJComposeComponentModelId';
  contentType: Maybe<NbjComposeEntity>;
  id: Maybe<Scalars['String']>;
};

export type NbjComposeEntity = {
  __typename?: 'NBJComposeEntity';
  sys: Maybe<NbjComposeEntityId>;
};

export type NbjComposeEntityId = {
  __typename?: 'NBJComposeEntityId';
  id: Maybe<Scalars['String']>;
};

export type NbjComposePages = {
  __typename?: 'NBJComposePages';
  cartUrl: Maybe<Scalars['String']>;
  contentList: Maybe<Array<NbjComposeComponentItems>>;
  internalName: Maybe<Scalars['String']>;
  seoMetadata: Maybe<SeoMetaDataField>;
  slug: Maybe<Scalars['String']>;
  subMenu: Maybe<SubMenuField>;
  title: Maybe<Scalars['String']>;
};

export type NbjComposeTypeDetails = {
  __typename?: 'NBJComposeTypeDetails';
  classNameReference: Maybe<Scalars['String']>;
  contentModelType: Maybe<Scalars['String']>;
};

export type NbjEntityDetails = {
  __typename?: 'NBJEntityDetails';
  contentModelType: Maybe<Scalars['String']>;
  fields: Maybe<Scalars['JSON']>;
  internalName: Maybe<Scalars['String']>;
  sys: Maybe<Scalars['JSON']>;
  title: Maybe<Scalars['String']>;
};

export type NbjFieldMenuLists = {
  __typename?: 'NBJFieldMenuLists';
  fields: Maybe<NbjMenuItemLists>;
};

export type NbjMenuItemLists = {
  __typename?: 'NBJMenuItemLists';
  itemIcon: Maybe<Scalars['JSON']>;
  itemUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  tooltip: Maybe<Scalars['String']>;
};

export type NbjMenuList = {
  __typename?: 'NBJMenuList';
  footerCopyright: Maybe<Scalars['JSON']>;
  internalName: Maybe<Scalars['String']>;
  menuSections: Maybe<Array<NbjCombinedMenu>>;
  segmentSnippet: Maybe<Scalars['JSON']>;
};

export type NbjMenuSectionLists = {
  __typename?: 'NBJMenuSectionLists';
  sectionLinks: Maybe<Array<MenuSectionListFields>>;
  sectionName: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
};

export type NbjModels = {
  __typename?: 'NBJModels';
  alignmentOfVideoImage: Maybe<Scalars['String']>;
  autoPlay: Maybe<Scalars['Boolean']>;
  classNameReference: Maybe<Scalars['String']>;
  contentModelType: Maybe<Scalars['String']>;
  contentModels: Maybe<Array<ContentModelsFields>>;
  ctaButtonOneColorVariant: Maybe<Scalars['String']>;
  ctaButtonOneLink: Maybe<Scalars['String']>;
  ctaButtonOneText: Maybe<Scalars['String']>;
  ctaButtonTwoColorVariant: Maybe<Scalars['String']>;
  ctaButtonTwoLink: Maybe<Scalars['String']>;
  ctaButtonTwoText: Maybe<Scalars['String']>;
  ctaMoreInfoColorVariant: Maybe<Scalars['String']>;
  ctaMoreInfoImage: Maybe<MediaContentDetails>;
  ctaMoreInfoText: Maybe<Scalars['String']>;
  description: Maybe<Scalars['JSON']>;
  faqsList: Maybe<Array<FaqsListDetails>>;
  headingH: Maybe<Scalars['JSON']>;
  imageDesktop: Maybe<MediaContentDetails>;
  imageMobile: Maybe<MediaContentDetails>;
  internalName: Maybe<Scalars['String']>;
  isScrollBtnEnabled: Maybe<Scalars['Boolean']>;
  layoutOption: Maybe<Scalars['String']>;
  legalLine: Maybe<Scalars['JSON']>;
  members: Maybe<Array<NbjProductAndTabFields>>;
  playBackLoop: Maybe<Scalars['Boolean']>;
  sectionBottomPadding: Maybe<Scalars['String']>;
  sectionTopPadding: Maybe<Scalars['String']>;
  shortOfInformation: Maybe<Scalars['String']>;
  showCarouselView: Maybe<Scalars['Boolean']>;
  showCollapseView: Maybe<Scalars['Boolean']>;
  showLandscapeView: Maybe<Scalars['Boolean']>;
  synopsesImages: Maybe<Array<MediaContentDetails>>;
  tabsColorVariant: Maybe<Scalars['String']>;
  termsAndConditionsCaption: Maybe<Scalars['JSON']>;
  titleH: Maybe<Scalars['JSON']>;
};

export type NbjNestedMenuSectionLists = {
  __typename?: 'NBJNestedMenuSectionLists';
  itemIcon: Maybe<Scalars['JSON']>;
  itemUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  sectionLinks: Maybe<Array<NbjMenuItemLists>>;
  sectionName: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  tooltip: Maybe<Scalars['String']>;
};

export type NbjProductAndTabFields = {
  __typename?: 'NBJProductAndTabFields';
  fields: Maybe<NbjProductCardFields>;
  sys: Maybe<NbjComposeComponentModelId>;
};

export type NbjProductCardFields = {
  __typename?: 'NBJProductCardFields';
  catalogMembers: Maybe<Array<ProductCardDetails>>;
  contentRails: Maybe<Scalars['JSON']>;
  internalName: Maybe<Scalars['String']>;
  members: Maybe<Array<ProductCardDetails>>;
  moreInfo: Maybe<Scalars['JSON']>;
  name: Maybe<Scalars['String']>;
  railType: Maybe<Scalars['String']>;
};

export type NbjSampleComposePages = {
  __typename?: 'NBJSampleComposePages';
  contentList: Maybe<Scalars['JSON']>;
  internalName: Maybe<Scalars['String']>;
  seoMetadata: Maybe<SeoMetaDataField>;
  slug: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type NbjTermsAndConditions = {
  __typename?: 'NBJTermsAndConditions';
  fields: Maybe<NbjTermsAndConditionsFields>;
};

export type NbjTermsAndConditionsFields = {
  __typename?: 'NBJTermsAndConditionsFields';
  bgTitle: Maybe<Scalars['String']>;
  isExpandable: Maybe<Scalars['Boolean']>;
  terms: Maybe<Scalars['JSON']>;
};

export type NavigationField = {
  __typename?: 'NavigationField';
  fields: Maybe<NavigationFieldItems>;
};

export type NavigationFieldItems = {
  __typename?: 'NavigationFieldItems';
  internalName: Maybe<Scalars['String']>;
  itemUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

export type NavigationItems = {
  __typename?: 'NavigationItems';
  itemUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

export type NzPostLocation = {
  __typename?: 'NzPostLocation';
  address: Maybe<Scalars['String']>;
  address_id: Scalars['Int'];
  city: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  dpid: Scalars['Float'];
  email: Maybe<Scalars['String']>;
  extraDetails: Maybe<Scalars['JSON']>;
  isActive: Scalars['Boolean'];
  phoneNumber: Maybe<Scalars['String']>;
  postalCode: Maybe<Scalars['String']>;
  postcodePrefix: Maybe<Scalars['String']>;
  street: Maybe<Scalars['String']>;
  streetType: Maybe<Scalars['String']>;
  street_number: Maybe<Scalars['String']>;
  suburb: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type Offer = {
  __typename?: 'Offer';
  accountNumber: Maybe<Scalars['String']>;
  offers: Maybe<Array<EligibilityOffer>>;
  subscriberKey: Maybe<Scalars['String']>;
  tenure: Maybe<Scalars['Float']>;
};

export type Offering = {
  __typename?: 'Offering';
  bookableTime: Time;
  channel: Scalars['Float'];
  id: Scalars['String'];
  price: Scalars['Float'];
  showingNumber: Scalars['Float'];
  showings: Array<Showing>;
  time: Time;
  titleCode: Scalars['String'];
};

export type OrderConfirmation = {
  __typename?: 'OrderConfirmation';
  appLogoLargeSrc: Maybe<IconDetails>;
  appLogoSmallSrc: Maybe<IconDetails>;
  buttonCtaName: Maybe<Scalars['String']>;
  buttonLink: Maybe<Scalars['String']>;
  category: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  header: Maybe<Scalars['String']>;
  iconMobileSrc: Maybe<IconDetails>;
  iconSrc: Maybe<IconDetails>;
  title: Maybe<Scalars['String']>;
};

export type Ppv = {
  __typename?: 'PPV';
  /** Sky Arenas */
  arenas: Array<PpvItem>;
  /** bought */
  bought: Array<PpvBought>;
  /** Movies */
  movies: Array<PpvItem>;
};

export type PpvBought = {
  __typename?: 'PPVBought';
  eventStatus: Scalars['Float'];
  eventStatusDescription: Scalars['String'];
  showingNumber: Scalars['Float'];
  titleCode: Scalars['String'];
};

export type PpvItem = {
  __typename?: 'PPVItem';
  description: Scalars['String'];
  genre: Scalars['String'];
  id: Scalars['String'];
  imageUrl: Scalars['String'];
  offerings: Array<Offering>;
  rating: Scalars['String'];
  title: Scalars['String'];
};

export type ParcelDetailInput = {
  description: Scalars['String'];
  dimensions: DimensionsInput;
  return_indicator: Scalars['String'];
  service_code: Scalars['String'];
};

export type ParcelLabel = {
  __typename?: 'ParcelLabel';
  consignment_id: Scalars['String'];
  consignment_status: Scalars['String'];
  consignment_url: Maybe<Scalars['String']>;
  dangerous_goods_declaration_urls: Array<Scalars['String']>;
  errors: Array<Scalars['String']>;
  expiry_date_utc: Maybe<Scalars['String']>;
  labels: Array<Label>;
  message_id: Scalars['String'];
  page_urls: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ParcelTracking = {
  __typename?: 'ParcelTracking';
  carrier: Scalars['String'];
  message_datetime: Scalars['String'];
  message_id: Scalars['String'];
  service: Scalars['String'];
  tracking_events: Array<TrackingEvent>;
  tracking_reference: Scalars['String'];
};

export type PopupCard = {
  __typename?: 'PopupCard';
  internalName: Maybe<Scalars['String']>;
  popupCard: Maybe<Scalars['String']>;
  popupCardDescription: Maybe<Scalars['String']>;
  popupCardIconUrl: Maybe<ImageUrl>;
  popupCardImageUrl: Maybe<ImageUrl>;
  popupCardSubTitle: Maybe<Scalars['String']>;
  popupCardTitle: Maybe<Scalars['String']>;
};

export type PopupCardSection = {
  __typename?: 'PopupCardSection';
  internalName: Maybe<Scalars['String']>;
  linkText: Maybe<Scalars['String']>;
  linkUrl: Maybe<Scalars['String']>;
  popupCard: Maybe<Scalars['String']>;
  popupCardDescription: Maybe<Scalars['String']>;
  popupCardIconURL: Maybe<Scalars['String']>;
  popupCardImageLinkUrl: Maybe<Scalars['String']>;
  popupCardImageURL: Maybe<Scalars['String']>;
  popupCardSubTitle: Maybe<Scalars['String']>;
  popupCardTitle: Maybe<Scalars['String']>;
};

export type Prequal = {
  __typename?: 'Prequal';
  addOns: Scalars['JSON'];
  availableProductDetails: Array<ProductDetail>;
  broadbandFunnelType: Scalars['String'];
  broadbandJourney: Scalars['Float'];
  broadbandReadyETA: Scalars['String'];
  broadbandReadyStatus: Scalars['Float'];
  isConsentRequired: Scalars['Boolean'];
  isFibreAvailable: Scalars['Boolean'];
  locationId: Scalars['String'];
  modemModel: Scalars['String'];
  singleMeshDeviceModel: Scalars['String'];
  staticIPProductKey: Scalars['String'];
};

export type Product = {
  __typename?: 'Product';
  /** Price from billing service rate */
  billedPrice: Maybe<Scalars['Float']>;
  /** Billing has price hold campaign for broadband product */
  broadbandPriceHold: Maybe<Scalars['Boolean']>;
  /** Discount price if starter discount is present in billing */
  broadbandStarterDiscount: Maybe<Scalars['Float']>;
  /** Price from billing service campaign rate */
  campaignPrice: Maybe<Scalars['Float']>;
  categoryId: Scalars['Int'];
  categoryName: Maybe<Scalars['String']>;
  image: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** Number from billing service occurrence details */
  occurrenceNumber: Maybe<Scalars['Int']>;
  /** Price set in Konakart admin w/o discounts */
  originalPrice: Scalars['Float'];
  /** True if a phantom product */
  phantomProduct: Maybe<Scalars['Boolean']>;
  /** Product id generated by Konakart */
  productId: Scalars['Int'];
  quantity: Scalars['Int'];
  serviceStatus: Maybe<Scalars['Int']>;
  sku: Scalars['String'];
  subscribed: Scalars['Boolean'];
};

export type ProductCardDetails = {
  __typename?: 'ProductCardDetails';
  fields: Maybe<ProductCardItem>;
  sys: Maybe<NbjComposeComponentModelId>;
};

export type ProductCardItem = {
  __typename?: 'ProductCardItem';
  broadbandSpeedDescription: Maybe<Scalars['String']>;
  broadbandSpeedTitle: Maybe<Scalars['String']>;
  bulletImage: Maybe<MediaContentDetails>;
  bulletInfoImage: Maybe<MediaContentDetails>;
  cardBgColor: Maybe<Scalars['String']>;
  catalogId: Maybe<Scalars['String']>;
  categories: Maybe<Scalars['String']>;
  channelSet: Maybe<Array<ChannelSetDetails>>;
  ctaButtonOneColorVariant: Maybe<Scalars['String']>;
  ctaButtonOneLink: Maybe<Scalars['String']>;
  ctaButtonOneText: Maybe<Scalars['String']>;
  ctaButtonThreeColorVariant: Maybe<Scalars['String']>;
  ctaButtonThreeLink: Maybe<Scalars['String']>;
  ctaButtonThreeText: Maybe<Scalars['String']>;
  ctaButtonTwoColorVariant: Maybe<Scalars['String']>;
  ctaButtonTwoLink: Maybe<Scalars['String']>;
  ctaButtonTwoText: Maybe<Scalars['String']>;
  ctaMoreInfoColorVariant: Maybe<Scalars['String']>;
  ctaMoreInfoImage: Maybe<MediaContentDetails>;
  ctaMoreInfoLink: Maybe<Scalars['String']>;
  ctaMoreInfoText: Maybe<Scalars['String']>;
  customSynopses: Maybe<Scalars['String']>;
  description: Maybe<Scalars['JSON']>;
  discountLozengeBackgroundImage: Maybe<MediaContentDetails>;
  discountLozengeText: Maybe<Scalars['String']>;
  discountedPrice: Maybe<Scalars['Float']>;
  downloadDataSpeed: Maybe<Scalars['JSON']>;
  image: Maybe<MediaContentDetails>;
  infoList: Maybe<Array<Scalars['String']>>;
  internalName: Maybe<Scalars['String']>;
  landscapeImage: Maybe<MediaContentDetails>;
  largeThumbnail: Maybe<MediaContentDetails>;
  legalLine: Maybe<Scalars['JSON']>;
  legalLineForQuickCompare: Maybe<Scalars['JSON']>;
  longDescription: Maybe<Scalars['JSON']>;
  lozengeBackgroundImage: Maybe<MediaContentDetails>;
  lozengeText: Maybe<Scalars['String']>;
  members: Maybe<Array<ProductCardDetails>>;
  moreDetails: Maybe<Scalars['JSON']>;
  name: Maybe<Scalars['String']>;
  price: Maybe<Scalars['Float']>;
  priceFrequencyType: Maybe<Scalars['String']>;
  productFeatures: Maybe<ProductFeatureInfo>;
  productInfo: Maybe<DeviceInfo>;
  productInfoDescription: Maybe<Scalars['JSON']>;
  productKkInfo: Maybe<Scalars['JSON']>;
  productSku: Maybe<Array<Scalars['String']>>;
  recommendationImage: Maybe<MediaContentDetails>;
  recomonded: Maybe<Scalars['Boolean']>;
  shortDescription: Maybe<Scalars['JSON']>;
  shortOfInformation: Maybe<Scalars['String']>;
  shortTitle: Maybe<Scalars['String']>;
  slugurl: Maybe<Scalars['String']>;
  smallThumbnail: Maybe<MediaContentDetails>;
  subCategories: Maybe<Scalars['String']>;
  synopses: Maybe<MediaContentDetails>;
  synopsesImages: Maybe<Array<MediaContentDetails>>;
  teamCondition: Maybe<NbjTermsAndConditions>;
  termsAndConditionsCaption: Maybe<Scalars['JSON']>;
  thumbnail: Maybe<MediaContentDetails>;
  tileImages: Maybe<Array<MediaContentDetails>>;
  title: Maybe<Scalars['String']>;
  titleForBanner: Maybe<Scalars['String']>;
  titleImageDesktop: Maybe<MediaContentDetails>;
  titleImageMobile: Maybe<MediaContentDetails>;
  tvSpeedImage: Maybe<Scalars['JSON']>;
  type: Maybe<Scalars['String']>;
  uploadDataSpeed: Maybe<Scalars['JSON']>;
  wifiUnlimitedImage: Maybe<MediaContentDetails>;
};

export type ProductCards = {
  __typename?: 'ProductCards';
  acquistionOfferPrice: Maybe<Scalars['Float']>;
  addLink: Maybe<Scalars['String']>;
  bgColor: Maybe<Scalars['String']>;
  copyrightText: Maybe<Scalars['String']>;
  ctaName: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  detailsLink: Maybe<Scalars['String']>;
  detailsList: Maybe<Array<Scalars['String']>>;
  discountText: Maybe<Scalars['String']>;
  iconList: Maybe<Array<ImageDetails>>;
  iconListCaption: Maybe<Scalars['String']>;
  lozengeText: Maybe<Scalars['String']>;
  occurrenceType: Scalars['String'];
  price: Maybe<Scalars['Float']>;
  priceFrequencyType: Scalars['String'];
  productSet: Scalars['String'];
  promoted: Scalars['Boolean'];
  sku: Scalars['String'];
  termsAndConditionsCaption: Maybe<Scalars['JSON']>;
  thumbnail: Maybe<ImageDetails>;
  title: Scalars['String'];
  titleLogo: Maybe<ImageDetails>;
  type: Scalars['String'];
  upgradeOfferPrice: Maybe<Scalars['Float']>;
};

export type ProductCardsDetails = {
  __typename?: 'ProductCardsDetails';
  acquistionOfferPrice: Maybe<Scalars['String']>;
  activeSkyCustomerDetailsList: Maybe<Scalars['String']>;
  addLink: Maybe<Scalars['String']>;
  addLinkText: Maybe<Scalars['String']>;
  bgColor: Maybe<Scalars['String']>;
  copyrightText: Maybe<Scalars['String']>;
  ctaName: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  detailsLink: Maybe<Scalars['String']>;
  detailsList: Maybe<Array<Scalars['String']>>;
  detailsText: Maybe<Scalars['String']>;
  discountText: Maybe<Scalars['String']>;
  iconList: Maybe<BaseImageUrl>;
  iconListCaption: Maybe<Scalars['String']>;
  lozengeText: Maybe<Scalars['String']>;
  occurrenceType: Maybe<Scalars['String']>;
  price: Maybe<Scalars['String']>;
  priceFrequencyType: Maybe<Array<Scalars['String']>>;
  productSet: Maybe<Scalars['String']>;
  promoted: Maybe<Scalars['String']>;
  sku: Maybe<Scalars['String']>;
  termsAndConditionsCaption: Maybe<Scalars['JSON']>;
  thumbnail: Maybe<BaseImageUrl>;
  title: Maybe<Scalars['String']>;
  titleLogo: Maybe<Scalars['String']>;
  type: Maybe<Array<Scalars['String']>>;
  upgradeOfferPrice: Maybe<Scalars['String']>;
};

export type ProductCarousels = {
  __typename?: 'ProductCarousels';
  bottomCallToActionLink: Maybe<Scalars['String']>;
  bottomCallToActionText: Maybe<Scalars['String']>;
  cardPanelHeading: Maybe<Scalars['JSON']>;
  cardPanelHeadingGradient: Maybe<Scalars['String']>;
  cardPanelName: Maybe<Scalars['String']>;
  cardsToShow: Maybe<Array<ProductCardsDetails>>;
  productCategory: Maybe<Scalars['String']>;
  skyCustomerSwitch: Maybe<Scalars['String']>;
  skyCustomerText: Maybe<Scalars['String']>;
  termsAndConditions: Maybe<Scalars['String']>;
};

export type ProductDetail = {
  __typename?: 'ProductDetail';
  category: Scalars['String'];
  description: Scalars['String'];
  key: Scalars['String'];
  service: Scalars['String'];
  supplier: Scalars['String'];
  voiceCategory: Scalars['String'];
};

export type ProductFeatureInfo = {
  __typename?: 'ProductFeatureInfo';
  fields: Maybe<ProductFeatureSetItem>;
  sys: Maybe<NbjComposeComponentModelId>;
};

export type ProductFeatureInfoSetField = {
  __typename?: 'ProductFeatureInfoSetField';
  ctaButtonImage: Maybe<MediaContentDetails>;
  ctaLink: Maybe<Scalars['String']>;
  desciption: Maybe<Scalars['JSON']>;
  first_image: Maybe<IconTempleteDetails>;
  smallDescription: Maybe<Scalars['JSON']>;
};

export type ProductFeatureSetField = {
  __typename?: 'ProductFeatureSetField';
  fields: Maybe<ProductFeatureInfoSetField>;
  sys: Maybe<NbjComposeComponentModelId>;
};

export type ProductFeatureSetItem = {
  __typename?: 'ProductFeatureSetItem';
  members: Maybe<Array<ProductFeatureSetField>>;
  sys: Maybe<NbjComposeComponentModelId>;
};

export type Profile = {
  __typename?: 'Profile';
  /** Account number */
  accountNumber: Scalars['String'];
  associated: Scalars['Boolean'];
  blockAdultContent: Maybe<Scalars['Boolean']>;
  displayName: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  groups: Array<Scalars['String']>;
  houseNumber: Scalars['String'];
  lastName: Scalars['String'];
  parentalControlEnabled: Scalars['Boolean'];
  parentalPin: Maybe<Scalars['String']>;
  parentalRatingLevel: Scalars['String'];
  profileId: Scalars['String'];
  receiveMarketingEmail: Maybe<Scalars['Boolean']>;
  salesForceId: Maybe<Scalars['String']>;
  subscriberKey: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
};

export type PromoCard = {
  __typename?: 'PromoCard';
  CTAButtonLabel: Maybe<Scalars['String']>;
  CTAButtonUrl: Maybe<Scalars['String']>;
  bgColor: Maybe<Scalars['String']>;
  billingFrequency: Maybe<Scalars['String']>;
  campaign: Maybe<Scalars['String']>;
  copyrightText: Maybe<Scalars['String']>;
  coupon: Maybe<Coupon>;
  disclaimer: Maybe<Scalars['String']>;
  discountText: Maybe<Scalars['String']>;
  discountedPrice: Maybe<Scalars['Float']>;
  eligibilityExcludeCampaign: Maybe<Scalars['String']>;
  eligibilityExcludeServiceCode: Maybe<Scalars['String']>;
  eligibilityIncludeCampaign: Maybe<Scalars['String']>;
  eligibilityIncludeServiceCode: Maybe<Scalars['String']>;
  eligibleFor: Maybe<Scalars['String']>;
  extraCampaign: Maybe<Scalars['String']>;
  fromPrice: Maybe<Scalars['String']>;
  imageSrc: Maybe<ImageDetails>;
  lozengeText: Maybe<Scalars['String']>;
  offerType: Maybe<Scalars['String']>;
  sku: Maybe<Scalars['String']>;
  subDescription: Maybe<Scalars['JSON']>;
  subscriberKey: Maybe<Scalars['String']>;
  subtitle: Maybe<Scalars['String']>;
  termsAndConditions: Maybe<Scalars['JSON']>;
  title: Scalars['String'];
  type: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  BusinessComposePage: Array<BusinessComposePage>;
  BusinessMenuList: Array<BMenuList>;
  BusinessResourceSet: Array<BusinessResourceSet>;
  ComponentCardSection: Array<ComponentCardSection>;
  ComposeAdvertisingPage: Array<AdvertisingComposePage>;
  GlobalFooterList: Array<GlobalFooter>;
  GlobalMenuList: Array<GlobalMenuList>;
  MenuItemSectionLists: Array<MenuItemSectionLists>;
  MenuList: Array<MenuList>;
  MenuListHeader: Array<AdMenu>;
  MenuSectionList: Array<MenuSectionList>;
  NBJChildEntityComponentDetails: Array<NbjProductCardFields>;
  NBJComponentDetails: Array<NbjModels>;
  NBJComposePages: Array<NbjComposePages>;
  NBJEntityDetails: Array<NbjEntityDetails>;
  NBJMenuList: Array<NbjMenuList>;
  NBJProductItem: Array<ProductCardDetails>;
  NBJProductList: Array<ProductCardDetails>;
  NBJSampleComposePages: Array<NbjSampleComposePages>;
  SocialMedia: Array<MediaSections>;
  articlePage: Array<ArticalCompose>;
  billing: Billing;
  cardContainer: Array<CardContainer>;
  composePage: Array<ComposePage>;
  contactUs: Array<ContactInfo>;
  customer: Customer;
  /** Download parcel label and return a file URL */
  downloadParcelLabel: Scalars['String'];
  getAccount: Maybe<Account>;
  /** Get address details by ID */
  getAddressDetails: NzPostLocation;
  getRecyclingCentreAddress: Maybe<RecyclingCentreAddress>;
  offers: Offer;
  orderConfirmation: Array<OrderConfirmation>;
  parcelLabelStatus: ParcelLabel;
  parcelTracking: Maybe<ParcelTracking>;
  ppv: Ppv;
  prequal: Prequal;
  products: Array<Product>;
  productsCards: Array<ProductCards>;
  profile: Profile;
  promoCards: Array<PromoCard>;
  search: Array<SearchEntity>;
  /** Search for addresses based on query and count */
  searchAddress: Array<NzPostLocation>;
  seo: SeoEntity;
  termsconditions: Array<TermsAndConditions>;
  workOrder: WorkOrder;
};


export type QueryBusinessComposePageArgs = {
  slug: InputMaybe<Scalars['String']>;
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QueryBusinessMenuListArgs = {
  tags: InputMaybe<Scalars['String']>;
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QueryBusinessResourceSetArgs = {
  title: InputMaybe<Scalars['String']>;
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QueryComponentCardSectionArgs = {
  sectionName: InputMaybe<Scalars['String']>;
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QueryComposeAdvertisingPageArgs = {
  slug: InputMaybe<Scalars['String']>;
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QueryGlobalFooterListArgs = {
  tags: InputMaybe<Scalars['String']>;
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QueryGlobalMenuListArgs = {
  tags: InputMaybe<Scalars['String']>;
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QueryMenuItemSectionListsArgs = {
  tags: InputMaybe<Scalars['String']>;
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QueryMenuListArgs = {
  tags: InputMaybe<Scalars['String']>;
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QueryMenuListHeaderArgs = {
  tags: InputMaybe<Scalars['String']>;
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QueryMenuSectionListArgs = {
  slug: InputMaybe<Scalars['String']>;
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QueryNbjChildEntityComponentDetailsArgs = {
  id: Scalars['String'];
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QueryNbjComponentDetailsArgs = {
  id: Scalars['String'];
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QueryNbjComposePagesArgs = {
  slug: InputMaybe<Scalars['String']>;
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QueryNbjEntityDetailsArgs = {
  id: Scalars['String'];
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QueryNbjMenuListArgs = {
  menuType: InputMaybe<Scalars['String']>;
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QueryNbjProductItemArgs = {
  id: Scalars['String'];
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QueryNbjProductListArgs = {
  contentModalName: Scalars['String'];
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QueryNbjSampleComposePagesArgs = {
  slug: InputMaybe<Scalars['String']>;
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QuerySocialMediaArgs = {
  tags: InputMaybe<Scalars['String']>;
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QueryArticlePageArgs = {
  articleType: InputMaybe<Scalars['String']>;
  selectCategories: InputMaybe<Scalars['String']>;
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QueryBillingArgs = {
  version: InputMaybe<Scalars['String']>;
};


export type QueryCardContainerArgs = {
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QueryComposePageArgs = {
  slug: InputMaybe<Scalars['String']>;
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QueryContactUsArgs = {
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QueryDownloadParcelLabelArgs = {
  format?: InputMaybe<Scalars['String']>;
  labelId: Scalars['String'];
};


export type QueryGetAccountArgs = {
  accountNo: InputMaybe<Scalars['Float']>;
  email: InputMaybe<Scalars['String']>;
  orderNo: InputMaybe<Scalars['String']>;
  token: InputMaybe<Scalars['String']>;
};


export type QueryGetAddressDetailsArgs = {
  id: Scalars['String'];
};


export type QueryGetRecyclingCentreAddressArgs = {
  postcodePrefix: InputMaybe<Scalars['String']>;
};


export type QueryOffersArgs = {
  version: InputMaybe<Scalars['String']>;
};


export type QueryOrderConfirmationArgs = {
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QueryParcelLabelStatusArgs = {
  consignmentId: Scalars['String'];
};


export type QueryParcelTrackingArgs = {
  trackingReference: Scalars['String'];
};


export type QueryPrequalArgs = {
  addressId: Scalars['String'];
};


export type QueryProductsArgs = {
  category: InputMaybe<Scalars['String']>;
};


export type QueryProductsCardsArgs = {
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QueryPromoCardsArgs = {
  usePreview: InputMaybe<Scalars['Boolean']>;
  version: InputMaybe<Scalars['String']>;
};


export type QuerySearchArgs = {
  query: InputMaybe<Scalars['String']>;
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QuerySearchAddressArgs = {
  count: Scalars['Float'];
  query: Scalars['String'];
};


export type QuerySeoArgs = {
  slug: InputMaybe<Scalars['String']>;
  usePreview: InputMaybe<Scalars['Boolean']>;
};


export type QueryTermsconditionsArgs = {
  slug: InputMaybe<Scalars['String']>;
  usePreview: InputMaybe<Scalars['Boolean']>;
};

export type ReceiverDetailsInput = {
  email: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone: InputMaybe<Scalars['String']>;
};

export type RecyclingCentreAddress = {
  __typename?: 'RecyclingCentreAddress';
  address: Maybe<Scalars['String']>;
  addressId: Maybe<Scalars['String']>;
  contact: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  postcodePrefix: Maybe<Scalars['String']>;
};

export type SeoEntity = {
  __typename?: 'SEOEntity';
  description: Maybe<Scalars['String']>;
  keywords: Maybe<Array<Scalars['String']>>;
  logoImageUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  no_follow: Maybe<Scalars['Boolean']>;
  no_index: Maybe<Scalars['Boolean']>;
  seoTitle: Maybe<Scalars['String']>;
  urlSlug: Maybe<Scalars['String']>;
};

export type SearchEntity = {
  __typename?: 'SearchEntity';
  description: Maybe<Scalars['String']>;
  keywords: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  urlSlug: Maybe<Scalars['String']>;
};

export type SecLinkCombinedMenu = {
  __typename?: 'SecLinkCombinedMenu';
  internalName: Maybe<Scalars['String']>;
  itemIcon: Maybe<Scalars['String']>;
  itemUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  publicName: Maybe<Scalars['String']>;
  sectionLinks: Maybe<Array<GlobalMenuItemLists>>;
  sectionName: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
};

export type SenderDetailsInput = {
  company_name: InputMaybe<Scalars['String']>;
  email: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone: InputMaybe<Scalars['String']>;
  site_code: InputMaybe<Scalars['Float']>;
};

export type SeoMetaDataDetails = {
  __typename?: 'SeoMetaDataDetails';
  description: Maybe<Scalars['String']>;
  image: Maybe<Scalars['JSON']>;
  keywords: Maybe<Array<Scalars['String']>>;
  name: Maybe<Scalars['String']>;
  no_follow: Maybe<Scalars['Boolean']>;
  no_index: Maybe<Scalars['Boolean']>;
  seoTitle: Maybe<Scalars['String']>;
  urlSlug: Maybe<Scalars['String']>;
};

export type SeoMetaDataField = {
  __typename?: 'SeoMetaDataField';
  fields: Maybe<SeoMetaDataDetails>;
};

export type Showing = {
  __typename?: 'Showing';
  bookableTime: Time;
  channel: Scalars['Float'];
  duration: Scalars['Float'];
  id: Scalars['String'];
  offeringId: Scalars['String'];
  price: Scalars['Float'];
  time: Time;
};

export type SitemapCombinedMenu = {
  __typename?: 'SitemapCombinedMenu';
  itemUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  sectionLinks: Maybe<Array<SitemapCombinedMenu>>;
  sectionName: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
};

export type SitemapSecList = {
  __typename?: 'SitemapSecList';
  itemUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  sectionLinks: Maybe<Array<SitemapCombinedMenu>>;
  sectionName: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
};

export type Sitemaps = {
  __typename?: 'Sitemaps';
  menuSections: Maybe<Array<SitemapSecList>>;
  navigationItem: Maybe<NavigationItems>;
};

export type SubMenuField = {
  __typename?: 'SubMenuField';
  fields: Maybe<SubMenuFieldLists>;
};

export type SubMenuFieldLists = {
  __typename?: 'SubMenuFieldLists';
  internalName: Maybe<Scalars['String']>;
  menuSections: Maybe<Array<SubMenuSections>>;
  navigationItem: Maybe<Array<NavigationField>>;
};

export type SubMenuItemList = {
  __typename?: 'SubMenuItemList';
  internalName: Maybe<Scalars['String']>;
  itemIcon: Maybe<Scalars['String']>;
  itemUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

export type SubMenuSections = {
  __typename?: 'SubMenuSections';
  fields: Maybe<NbjMenuSectionLists>;
};

export type TermsAndConditions = {
  __typename?: 'TermsAndConditions';
  bgTitle: Maybe<Scalars['String']>;
  internalName: Maybe<Scalars['String']>;
  isExpandable: Maybe<Scalars['Boolean']>;
  slug: Maybe<Scalars['String']>;
  subTitle: Maybe<Scalars['String']>;
  terms: Maybe<Scalars['JSON']>;
  title: Maybe<Scalars['String']>;
};

export type Time = {
  __typename?: 'Time';
  end: Scalars['String'];
  start: Scalars['String'];
};

export type TrackingEvent = {
  __typename?: 'TrackingEvent';
  event_datetime: Scalars['String'];
  event_description: Scalars['String'];
  event_edifact_code: Scalars['String'];
  seqref: Scalars['String'];
  source: Scalars['String'];
  status_description: Scalars['String'];
  tracking_reference: Scalars['String'];
};

export type UpdateElabelDto = {
  consignmentId: InputMaybe<Scalars['String']>;
  eLabelTokenNumber: InputMaybe<Scalars['String']>;
  fromAddress: InputMaybe<Scalars['String']>;
  toAddress: InputMaybe<Scalars['String']>;
  trackingID: InputMaybe<Scalars['String']>;
};

export type UpdateElabelResponseDto = {
  __typename?: 'UpdateElabelResponseDto';
  statusCode: Scalars['Int'];
};

export type VoucherInput = {
  Account: InputMaybe<Scalars['String']>;
  Email: InputMaybe<Scalars['String']>;
  Status: InputMaybe<Scalars['String']>;
  VoucherCode: Scalars['String'];
  WorkOrder: InputMaybe<Scalars['String']>;
  deviceType: InputMaybe<Scalars['String']>;
  productType: Scalars['String'];
};

export type VoucherResponse = {
  __typename?: 'VoucherResponse';
  Campaigns: Maybe<Array<Scalars['String']>>;
  Description: Maybe<Scalars['String']>;
  DeviceType: Maybe<Scalars['String']>;
  ExpiryDate: Maybe<Scalars['String']>;
  OfferDescription: Scalars['String'];
  OfferId: Scalars['String'];
  ProductType: Maybe<Scalars['String']>;
  RequestStatus: Maybe<Scalars['String']>;
  ServiceCodes: Maybe<Array<Scalars['String']>>;
  VoucherStatus: VoucherStatusEnum;
  url: Scalars['String'];
};

/** Possible statuses of a voucher */
export enum VoucherStatusEnum {
  CANCELLED = 'CANCELLED',
  ISSUED = 'ISSUED',
  LOCKED = 'LOCKED',
  NEW = 'NEW',
  REDEEMED = 'REDEEMED',
  REDEEMED_CANCEL = 'REDEEMED_CANCEL',
  REDEEMED_IN_PROGRESS = 'REDEEMED_IN_PROGRESS'
}

export type WebContents = {
  __typename?: 'WebContents';
  content: Maybe<Array<Contents>>;
  name: Maybe<Scalars['String']>;
};

export type WorkOrder = {
  __typename?: 'WorkOrder';
  /** return true if user has any broadband orders which is pending or completed */
  isUserHasBroadbandWorkorderOrCompleted: Scalars['Boolean'];
  /** return true if user has any cable orders which is pending or completed */
  isUserHasCablePendingWorkorder: Scalars['Boolean'];
  /** return true if user has any cable orders which is pending or completed */
  isVTVHasMigratePendingWorkOrder: Scalars['Boolean'];
};

export type BaseImageUrl = {
  __typename?: 'baseImageUrl';
  text: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type BasePdfUrl = {
  __typename?: 'basePDFUrl';
  description: Maybe<Scalars['String']>;
  file: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type CombinedMenu = {
  __typename?: 'combinedMenu';
  itemUrl: Maybe<Scalars['String']>;
  publicName: Maybe<Scalars['String']>;
  sectionLinks: Maybe<Array<SecLinkCombinedMenu>>;
  sectionName: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
};

export type ComponentCardSectionFragment = { __typename?: 'ComponentCardSection', internalName: string | null, componentCardSectionTitle: string | null, componentCardDisplayTile: string | null, isCarousel: boolean | null, componentCards: Array<{ __typename?: 'ComponentCardClass', contentType: string | null, internalName: string | null, linkUrl: string | null, linkText: string | null, heading: string | null, cardImageLinkUrl: string | null, cardTitle: string | null, cardSubTitle: string | null, cardDescription: string | null, cardDetailedDescription: any | null, isSlider: boolean | null, cardImageUrl: { __typename?: 'baseImageUrl', url: string | null, text: string | null } | null, links: Array<{ __typename?: 'LinkClass', internalName: string | null, linkText: string | null, linkUrl: string | null, linkDocument: { __typename?: 'baseImageUrl', url: string | null, text: string | null } | null }> | null }> | null };

export type BillingFragment = { __typename?: 'Billing', monthlyCharge: number, paperLessBilling: boolean | null, accountNumber: string, statementDueDate: string | null, currentTotalAmountDueCents: number, isCustomerInArrears: boolean, isCustomerInArrearsThirtyDays: boolean, digitalRental: boolean, broadbandOnlyAccount: boolean, activeBroadband: boolean, pendingBroadband: boolean, summerset: boolean, campaigns: Array<{ __typename?: 'Campaign', active: boolean, promotionCode: string, promotionDescription: string | null, isPromotionDescriptionDynamic: boolean | null, beginDate: string | null, endDate: string | null, groupCode: string | null }> | null, products: Array<{ __typename?: 'Product', sku: string, name: string, productId: number, categoryId: number, billedPrice: number | null, campaignPrice: number | null, quantity: number, serviceStatus: number | null, occurrenceNumber: number | null, broadbandPriceHold: boolean | null, broadbandStarterDiscount: number | null, categoryName: string | null, image: string | null, originalPrice: number, subscribed: boolean, phantomProduct: boolean | null }> };

export type CampaignsFragment = { __typename?: 'Campaign', active: boolean, promotionCode: string, promotionDescription: string | null, isPromotionDescriptionDynamic: boolean | null, beginDate: string | null, endDate: string | null, groupCode: string | null };

export type CardContainerFragment = { __typename?: 'CardContainer', internalName: string | null, sku: string | null, name: string | null, description: string | null, detailDescription: any | null, explorePopupCopy: string | null, contractDescription: string | null, horizontalVideoUrl: string | null, price: number | null, showExplorePopup: boolean | null, videoUrl: string | null, linkLabel: string | null, linkUrl: string | null, iconImageUrl: Array<{ __typename?: 'IconImage', iconImageUrl: string | null }> | null, mainImageUrl: { __typename?: 'ImageUrl', url: string | null, text: string | null } | null, logoImageUrl: { __typename?: 'ImageUrl', url: string | null, text: string | null } | null, horizontalImageUrl: { __typename?: 'ImageUrl', url: string | null, text: string | null } | null, popupCards: Array<{ __typename?: 'PopupCard', internalName: string | null, popupCardSubTitle: string | null, popupCardTitle: string | null, popupCardDescription: string | null, popupCardImageUrl: { __typename?: 'ImageUrl', url: string | null, text: string | null } | null, popupCardIconUrl: { __typename?: 'ImageUrl', url: string | null, text: string | null } | null }> | null };

export type ComposePageFragment = { __typename?: 'ComposePage', name: string | null, title: string | null, slug: string | null, subMenu: Array<{ __typename?: 'MenuSectionLists', sectionName: string | null, slug: string | null, parentMenu: Array<{ __typename?: 'SubMenuItemList', name: string | null, itemUrl: string | null }> | null, sectionLinks: Array<{ __typename?: 'SubMenuItemList', name: string | null, itemUrl: string | null }> | null }> | null, content: { __typename?: 'WebContents', name: string | null, content: Array<{ __typename?: 'Contents', contentType: string | null, bannerName: string | null, bgTitle: string | null, title: string | null, slug: string | null, isExpandable: boolean | null, subTitle: string | null, terms: any | null, componentCardSectionTitle: string | null, componentCardDisplayTile: string | null, isCarousel: boolean | null, rollingBanner: Array<{ __typename?: 'BannerContents', bannerName: string | null, callToActionText: string | null, callToActionLink: string | null, heading: any | null, callToActionSecondaryText: string | null, callToActionLinkSecondary: string | null, detailParagraph: any | null, copyrightParagraph: any | null, brightCoveVideoId: string | null, brightCoveVideoIdMobile: string | null, channelOrSponsorLogos: { __typename?: 'baseImageUrl', url: string | null, text: string | null } | null, heroImageMobile: { __typename?: 'baseImageUrl', url: string | null, text: string | null } | null, heroImage: { __typename?: 'baseImageUrl', url: string | null, text: string | null } | null }> | null, bannerContent: { __typename?: 'BannerContents', bannerName: string | null, heading: any | null, detailParagraph: any | null, copyrightParagraph: any | null, callToActionText: string | null, callToActionLink: string | null, callToActionSecondaryText: string | null, callToActionLinkSecondary: string | null, brightCoveVideoId: string | null, brightCoveVideoIdMobile: string | null, channelOrSponsorLogos: { __typename?: 'baseImageUrl', url: string | null, text: string | null } | null, heroImage: { __typename?: 'baseImageUrl', url: string | null, text: string | null } | null, heroImageMobile: { __typename?: 'baseImageUrl', url: string | null, text: string | null } | null } | null, componentCards: Array<{ __typename?: 'ComponentCards', contentType: string | null, internalName: string | null, linkUrl: string | null, linkText: string | null, heading: string | null, cardImageLinkUrl: string | null, cardTitle: string | null, cardDescription: string | null, cardDetailedDescription: any | null, isSlider: boolean | null, cardImageUrl: { __typename?: 'baseImageUrl', url: string | null, text: string | null } | null, links: Array<{ __typename?: 'Links', internalName: string | null, linkText: string | null, linkUrl: string | null, linkDocument: { __typename?: 'baseImageUrl', url: string | null, text: string | null } | null }> | null, popupcards: Array<{ __typename?: 'PopupCardSection', internalName: string | null, popupCardImageURL: string | null, popupCardSubTitle: string | null, popupCardTitle: string | null, popupCardDescription: string | null, popupCardIconURL: string | null, linkUrl: string | null, linkText: string | null }> | null }> | null }> | null } | null };

export type CustomerFragment = { __typename?: 'Customer', accountNumber: string, type: string | null, category: string | null, tuiAddressCode: string, privacyList: any | null, serviceAddress: any | null, fusionRegion: string | null, houseNumber: string };

export type MenuListFragment = { __typename?: 'MenuList', internalName: string | null, menuSections: Array<{ __typename?: 'MenuItemLists', name: string | null, itemUrl: string | null }> | null };

export type OffersFragment = { __typename?: 'Offer', accountNumber: string | null, subscriberKey: string | null, tenure: number | null, offers: Array<{ __typename?: 'EligibilityOffer', eligibleFor: string, priority: number, qualifies: boolean, campaign: string, discountServiceCode: string | null, campaignDescription: string | null, additionalPackages: string | null, offerPackages: string | null, applies: string | null, overrideCurrentOffer: boolean | null, eligibilityID: string | null, displayPromptOffer: boolean | null, production: boolean | null, recordType: string | null, validToDate: string | null, client: string | null, category: string | null, promotion: any | null }> | null };

export type OrderConfirmationFragment = { __typename?: 'OrderConfirmation', title: string | null, header: string | null, category: string | null, buttonCtaName: string | null, buttonLink: string | null, description: string | null, iconSrc: { __typename?: 'IconDetails', url: string | null, text: string | null } | null, iconMobileSrc: { __typename?: 'IconDetails', url: string | null, text: string | null } | null, appLogoLargeSrc: { __typename?: 'IconDetails', url: string | null, text: string | null } | null, appLogoSmallSrc: { __typename?: 'IconDetails', url: string | null, text: string | null } | null };

export type ProductCardFragment = { __typename?: 'ProductCards', title: string, description: string | null, detailsList: Array<string> | null, iconListCaption: string | null, lozengeText: string | null, occurrenceType: string, price: number | null, acquistionOfferPrice: number | null, upgradeOfferPrice: number | null, priceFrequencyType: string, discountText: string | null, productSet: string, bgColor: string | null, promoted: boolean, sku: string, termsAndConditionsCaption: any | null, type: string, addLink: string | null, detailsLink: string | null, copyrightText: string | null, ctaName: string | null, titleLogo: { __typename?: 'ImageDetails', text: string | null, url: string | null } | null, iconList: Array<{ __typename?: 'ImageDetails', text: string | null, url: string | null }> | null, thumbnail: { __typename?: 'ImageDetails', text: string | null, url: string | null } | null };

export type ProductsFragment = { __typename?: 'Product', sku: string, name: string, productId: number, categoryId: number, billedPrice: number | null, campaignPrice: number | null, quantity: number, serviceStatus: number | null, occurrenceNumber: number | null, broadbandPriceHold: boolean | null, broadbandStarterDiscount: number | null, categoryName: string | null, image: string | null, originalPrice: number, subscribed: boolean, phantomProduct: boolean | null };

export type ProfileFragment = { __typename?: 'Profile', accountNumber: string, email: string, profileId: string, firstName: string, groups: Array<string>, displayName: string | null, lastName: string, parentalControlEnabled: boolean, parentalPin: string | null, associated: boolean };

export type PromoCardFragment = { __typename?: 'PromoCard', title: string, campaign: string | null, subtitle: string | null, subDescription: any | null, disclaimer: string | null, lozengeText: string | null, fromPrice: string | null, discountedPrice: number | null, discountText: string | null, billingFrequency: string | null, type: string | null, termsAndConditions: any | null, bgColor: string | null, sku: string | null, copyrightText: string | null, eligibleFor: string | null, eligibilityIncludeServiceCode: string | null, eligibilityExcludeServiceCode: string | null, eligibilityIncludeCampaign: string | null, eligibilityExcludeCampaign: string | null, subscriberKey: string | null, CTAButtonLabel: string | null, CTAButtonUrl: string | null, imageSrc: { __typename?: 'ImageDetails', url: string | null, text: string | null } | null, coupon: { __typename?: 'Coupon', id: number, name: string, couponCode: string, custom1: string, custom2: string, custom3: string, custom4: string, custom5: string, description: string } | null };

export type TermsAndConditionsFragment = { __typename?: 'TermsAndConditions', internalName: string | null, slug: string | null, bgTitle: string | null, subTitle: string | null, isExpandable: boolean | null, title: string | null, terms: any | null };

export type MenuSectionListFragment = { __typename?: 'MenuSectionList', sectionName: string | null, sectionLinks: Array<{ __typename?: 'MenuItemList', internalName: string | null, name: string | null, itemUrl: string | null }> | null };

export type WorkOrderFragment = { __typename?: 'WorkOrder', isUserHasCablePendingWorkorder: boolean, isVTVHasMigratePendingWorkOrder: boolean, isUserHasBroadbandWorkorderOrCompleted: boolean };

export type GetAddressDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetAddressDetailsQuery = { __typename?: 'Query', getAddressDetails: { __typename?: 'NzPostLocation', address_id: number, address: string | null, street_number: string | null, street: string | null, streetType: string | null, suburb: string | null, city: string | null, country: string | null, postalCode: string | null } };

export type GetCardContainerQueryVariables = Exact<{
  usePreview: InputMaybe<Scalars['Boolean']>;
}>;


export type GetCardContainerQuery = { __typename?: 'Query', cardContainer: Array<{ __typename?: 'CardContainer', internalName: string | null, sku: string | null, name: string | null, description: string | null, detailDescription: any | null, explorePopupCopy: string | null, contractDescription: string | null, horizontalVideoUrl: string | null, price: number | null, showExplorePopup: boolean | null, videoUrl: string | null, linkLabel: string | null, linkUrl: string | null, iconImageUrl: Array<{ __typename?: 'IconImage', iconImageUrl: string | null }> | null, mainImageUrl: { __typename?: 'ImageUrl', url: string | null, text: string | null } | null, logoImageUrl: { __typename?: 'ImageUrl', url: string | null, text: string | null } | null, horizontalImageUrl: { __typename?: 'ImageUrl', url: string | null, text: string | null } | null, popupCards: Array<{ __typename?: 'PopupCard', internalName: string | null, popupCardSubTitle: string | null, popupCardTitle: string | null, popupCardDescription: string | null, popupCardImageUrl: { __typename?: 'ImageUrl', url: string | null, text: string | null } | null, popupCardIconUrl: { __typename?: 'ImageUrl', url: string | null, text: string | null } | null }> | null }> };

export type ComponentCardSectionQueryVariables = Exact<{
  usePreview: InputMaybe<Scalars['Boolean']>;
  sectionName: InputMaybe<Scalars['String']>;
}>;


export type ComponentCardSectionQuery = { __typename?: 'Query', ComponentCardSection: Array<{ __typename?: 'ComponentCardSection', internalName: string | null, componentCardSectionTitle: string | null, componentCardDisplayTile: string | null, isCarousel: boolean | null, componentCards: Array<{ __typename?: 'ComponentCardClass', contentType: string | null, internalName: string | null, linkUrl: string | null, linkText: string | null, heading: string | null, cardImageLinkUrl: string | null, cardTitle: string | null, cardSubTitle: string | null, cardDescription: string | null, cardDetailedDescription: any | null, isSlider: boolean | null, cardImageUrl: { __typename?: 'baseImageUrl', url: string | null, text: string | null } | null, links: Array<{ __typename?: 'LinkClass', internalName: string | null, linkText: string | null, linkUrl: string | null, linkDocument: { __typename?: 'baseImageUrl', url: string | null, text: string | null } | null }> | null }> | null }> };

export type GetComposePageQueryVariables = Exact<{
  usePreview: InputMaybe<Scalars['Boolean']>;
  slug: InputMaybe<Scalars['String']>;
}>;


export type GetComposePageQuery = { __typename?: 'Query', composePage: Array<{ __typename?: 'ComposePage', name: string | null, title: string | null, slug: string | null, subMenu: Array<{ __typename?: 'MenuSectionLists', sectionName: string | null, slug: string | null, parentMenu: Array<{ __typename?: 'SubMenuItemList', name: string | null, itemUrl: string | null }> | null, sectionLinks: Array<{ __typename?: 'SubMenuItemList', name: string | null, itemUrl: string | null }> | null }> | null, content: { __typename?: 'WebContents', name: string | null, content: Array<{ __typename?: 'Contents', contentType: string | null, bannerName: string | null, bgTitle: string | null, title: string | null, slug: string | null, isExpandable: boolean | null, subTitle: string | null, terms: any | null, componentCardSectionTitle: string | null, componentCardDisplayTile: string | null, isCarousel: boolean | null, rollingBanner: Array<{ __typename?: 'BannerContents', bannerName: string | null, callToActionText: string | null, callToActionLink: string | null, heading: any | null, callToActionSecondaryText: string | null, callToActionLinkSecondary: string | null, detailParagraph: any | null, copyrightParagraph: any | null, brightCoveVideoId: string | null, brightCoveVideoIdMobile: string | null, channelOrSponsorLogos: { __typename?: 'baseImageUrl', url: string | null, text: string | null } | null, heroImageMobile: { __typename?: 'baseImageUrl', url: string | null, text: string | null } | null, heroImage: { __typename?: 'baseImageUrl', url: string | null, text: string | null } | null }> | null, bannerContent: { __typename?: 'BannerContents', bannerName: string | null, heading: any | null, detailParagraph: any | null, copyrightParagraph: any | null, callToActionText: string | null, callToActionLink: string | null, callToActionSecondaryText: string | null, callToActionLinkSecondary: string | null, brightCoveVideoId: string | null, brightCoveVideoIdMobile: string | null, channelOrSponsorLogos: { __typename?: 'baseImageUrl', url: string | null, text: string | null } | null, heroImage: { __typename?: 'baseImageUrl', url: string | null, text: string | null } | null, heroImageMobile: { __typename?: 'baseImageUrl', url: string | null, text: string | null } | null } | null, componentCards: Array<{ __typename?: 'ComponentCards', contentType: string | null, internalName: string | null, linkUrl: string | null, linkText: string | null, heading: string | null, cardImageLinkUrl: string | null, cardTitle: string | null, cardDescription: string | null, cardDetailedDescription: any | null, isSlider: boolean | null, cardImageUrl: { __typename?: 'baseImageUrl', url: string | null, text: string | null } | null, links: Array<{ __typename?: 'Links', internalName: string | null, linkText: string | null, linkUrl: string | null, linkDocument: { __typename?: 'baseImageUrl', url: string | null, text: string | null } | null }> | null, popupcards: Array<{ __typename?: 'PopupCardSection', internalName: string | null, popupCardImageURL: string | null, popupCardSubTitle: string | null, popupCardTitle: string | null, popupCardDescription: string | null, popupCardIconURL: string | null, linkUrl: string | null, linkText: string | null }> | null }> | null }> | null } | null }> };

export type GetEligibilityOffersQueryVariables = Exact<{
  version: InputMaybe<Scalars['String']>;
}>;


export type GetEligibilityOffersQuery = { __typename?: 'Query', offers: { __typename?: 'Offer', accountNumber: string | null, subscriberKey: string | null, tenure: number | null, offers: Array<{ __typename?: 'EligibilityOffer', eligibleFor: string, priority: number, qualifies: boolean, campaign: string, discountServiceCode: string | null, campaignDescription: string | null, additionalPackages: string | null, offerPackages: string | null, applies: string | null, overrideCurrentOffer: boolean | null, eligibilityID: string | null, displayPromptOffer: boolean | null, production: boolean | null, recordType: string | null, validToDate: string | null, client: string | null, category: string | null, promotion: any | null }> | null } };

export type GetMenuListItemQueryVariables = Exact<{
  usePreview: InputMaybe<Scalars['Boolean']>;
  tags: InputMaybe<Scalars['String']>;
}>;


export type GetMenuListItemQuery = { __typename?: 'Query', MenuList: Array<{ __typename?: 'MenuList', internalName: string | null, menuSections: Array<{ __typename?: 'MenuItemLists', name: string | null, itemUrl: string | null }> | null }> };

export type GetMoreChoicesForYouQueryVariables = Exact<{
  usePreview: InputMaybe<Scalars['Boolean']>;
  version: InputMaybe<Scalars['String']>;
}>;


export type GetMoreChoicesForYouQuery = { __typename?: 'Query', productsCards: Array<{ __typename?: 'ProductCards', title: string, description: string | null, detailsList: Array<string> | null, iconListCaption: string | null, lozengeText: string | null, occurrenceType: string, price: number | null, acquistionOfferPrice: number | null, upgradeOfferPrice: number | null, priceFrequencyType: string, discountText: string | null, productSet: string, bgColor: string | null, promoted: boolean, sku: string, termsAndConditionsCaption: any | null, type: string, addLink: string | null, detailsLink: string | null, copyrightText: string | null, ctaName: string | null, titleLogo: { __typename?: 'ImageDetails', text: string | null, url: string | null } | null, iconList: Array<{ __typename?: 'ImageDetails', text: string | null, url: string | null }> | null, thumbnail: { __typename?: 'ImageDetails', text: string | null, url: string | null } | null }>, promoCards: Array<{ __typename?: 'PromoCard', title: string, campaign: string | null, subtitle: string | null, subDescription: any | null, disclaimer: string | null, lozengeText: string | null, fromPrice: string | null, discountedPrice: number | null, discountText: string | null, billingFrequency: string | null, type: string | null, termsAndConditions: any | null, bgColor: string | null, sku: string | null, copyrightText: string | null, eligibleFor: string | null, eligibilityIncludeServiceCode: string | null, eligibilityExcludeServiceCode: string | null, eligibilityIncludeCampaign: string | null, eligibilityExcludeCampaign: string | null, subscriberKey: string | null, CTAButtonLabel: string | null, CTAButtonUrl: string | null, imageSrc: { __typename?: 'ImageDetails', url: string | null, text: string | null } | null, coupon: { __typename?: 'Coupon', id: number, name: string, couponCode: string, custom1: string, custom2: string, custom3: string, custom4: string, custom5: string, description: string } | null }> };

export type GetOrderConfirmationQueryVariables = Exact<{
  usePreview: InputMaybe<Scalars['Boolean']>;
}>;


export type GetOrderConfirmationQuery = { __typename?: 'Query', orderConfirmation: Array<{ __typename?: 'OrderConfirmation', title: string | null, header: string | null, category: string | null, buttonCtaName: string | null, buttonLink: string | null, description: string | null, iconSrc: { __typename?: 'IconDetails', url: string | null, text: string | null } | null, iconMobileSrc: { __typename?: 'IconDetails', url: string | null, text: string | null } | null, appLogoLargeSrc: { __typename?: 'IconDetails', url: string | null, text: string | null } | null, appLogoSmallSrc: { __typename?: 'IconDetails', url: string | null, text: string | null } | null }> };

export type GetProductCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductCardsQuery = { __typename?: 'Query', productsCards: Array<{ __typename?: 'ProductCards', title: string, description: string | null, detailsList: Array<string> | null, iconListCaption: string | null, lozengeText: string | null, occurrenceType: string, price: number | null, acquistionOfferPrice: number | null, upgradeOfferPrice: number | null, priceFrequencyType: string, discountText: string | null, productSet: string, bgColor: string | null, promoted: boolean, sku: string, termsAndConditionsCaption: any | null, type: string, addLink: string | null, detailsLink: string | null, copyrightText: string | null, ctaName: string | null, titleLogo: { __typename?: 'ImageDetails', text: string | null, url: string | null } | null, iconList: Array<{ __typename?: 'ImageDetails', text: string | null, url: string | null }> | null, thumbnail: { __typename?: 'ImageDetails', text: string | null, url: string | null } | null }> };

export type GetTermsConditionsQueryVariables = Exact<{
  usePreview: InputMaybe<Scalars['Boolean']>;
  slug: InputMaybe<Scalars['String']>;
}>;


export type GetTermsConditionsQuery = { __typename?: 'Query', termsconditions: Array<{ __typename?: 'TermsAndConditions', internalName: string | null, slug: string | null, bgTitle: string | null, subTitle: string | null, isExpandable: boolean | null, title: string | null, terms: any | null }> };

export type GetMenuSectionListQueryVariables = Exact<{
  usePreview: InputMaybe<Scalars['Boolean']>;
}>;


export type GetMenuSectionListQuery = { __typename?: 'Query', MenuSectionList: Array<{ __typename?: 'MenuSectionList', sectionName: string | null, sectionLinks: Array<{ __typename?: 'MenuItemList', internalName: string | null, name: string | null, itemUrl: string | null }> | null }> };

export type GetUserInformationQueryVariables = Exact<{
  version: InputMaybe<Scalars['String']>;
}>;


export type GetUserInformationQuery = { __typename?: 'Query', billing: { __typename?: 'Billing', monthlyCharge: number, paperLessBilling: boolean | null, accountNumber: string, statementDueDate: string | null, currentTotalAmountDueCents: number, isCustomerInArrears: boolean, isCustomerInArrearsThirtyDays: boolean, digitalRental: boolean, broadbandOnlyAccount: boolean, activeBroadband: boolean, pendingBroadband: boolean, summerset: boolean, campaigns: Array<{ __typename?: 'Campaign', active: boolean, promotionCode: string, promotionDescription: string | null, isPromotionDescriptionDynamic: boolean | null, beginDate: string | null, endDate: string | null, groupCode: string | null }> | null, products: Array<{ __typename?: 'Product', sku: string, name: string, productId: number, categoryId: number, billedPrice: number | null, campaignPrice: number | null, quantity: number, serviceStatus: number | null, occurrenceNumber: number | null, broadbandPriceHold: boolean | null, broadbandStarterDiscount: number | null, categoryName: string | null, image: string | null, originalPrice: number, subscribed: boolean, phantomProduct: boolean | null }> }, profile: { __typename?: 'Profile', accountNumber: string, email: string, profileId: string, firstName: string, groups: Array<string>, displayName: string | null, lastName: string, parentalControlEnabled: boolean, parentalPin: string | null, associated: boolean }, customer: { __typename?: 'Customer', accountNumber: string, type: string | null, category: string | null, tuiAddressCode: string, privacyList: any | null, serviceAddress: any | null, fusionRegion: string | null, houseNumber: string }, workOrder: { __typename?: 'WorkOrder', isUserHasCablePendingWorkorder: boolean, isVTVHasMigratePendingWorkOrder: boolean, isUserHasBroadbandWorkorderOrCompleted: boolean } };

export type SearchAddressQueryVariables = Exact<{
  query: Scalars['String'];
  count: Scalars['Float'];
}>;


export type SearchAddressQuery = { __typename?: 'Query', searchAddress: Array<{ __typename?: 'NzPostLocation', address_id: number, address: string | null }> };

export const ComponentCardSectionFragmentDoc = gql`
    fragment ComponentCardSection on ComponentCardSection {
  internalName
  componentCardSectionTitle
  componentCardDisplayTile
  isCarousel
  componentCards {
    contentType
    internalName
    linkUrl
    linkText
    heading
    cardImageLinkUrl
    cardTitle
    cardSubTitle
    cardDescription
    cardDetailedDescription
    cardImageUrl {
      url
      text
    }
    links {
      internalName
      linkText
      linkUrl
      linkDocument {
        url
        text
      }
    }
    isSlider
  }
}
    `;
export const CampaignsFragmentDoc = gql`
    fragment Campaigns on Campaign {
  active
  promotionCode
  promotionDescription
  isPromotionDescriptionDynamic
  beginDate
  endDate
  groupCode
}
    `;
export const ProductsFragmentDoc = gql`
    fragment Products on Product {
  sku
  name
  productId
  categoryId
  billedPrice
  campaignPrice
  quantity
  serviceStatus
  occurrenceNumber
  broadbandPriceHold
  broadbandStarterDiscount
  categoryName
  image
  originalPrice
  subscribed
  phantomProduct
}
    `;
export const BillingFragmentDoc = gql`
    fragment Billing on Billing {
  monthlyCharge
  paperLessBilling
  accountNumber
  statementDueDate
  currentTotalAmountDueCents
  isCustomerInArrears
  isCustomerInArrearsThirtyDays
  digitalRental
  broadbandOnlyAccount
  activeBroadband
  pendingBroadband
  summerset
  campaigns {
    ...Campaigns
  }
  products {
    ...Products
  }
}
    ${CampaignsFragmentDoc}
${ProductsFragmentDoc}`;
export const CardContainerFragmentDoc = gql`
    fragment CardContainer on CardContainer {
  internalName
  sku
  iconImageUrl {
    iconImageUrl
  }
  mainImageUrl {
    url
    text
  }
  logoImageUrl {
    url
    text
  }
  name
  description
  detailDescription
  explorePopupCopy
  contractDescription
  horizontalVideoUrl
  horizontalImageUrl {
    url
    text
  }
  price
  showExplorePopup
  videoUrl
  linkLabel
  linkUrl
  popupCards {
    internalName
    popupCardImageUrl {
      url
      text
    }
    popupCardSubTitle
    popupCardTitle
    popupCardDescription
    popupCardIconUrl {
      url
      text
    }
  }
}
    `;
export const ComposePageFragmentDoc = gql`
    fragment ComposePage on ComposePage {
  name
  title
  slug
  subMenu {
    sectionName
    slug
    parentMenu {
      name
      itemUrl
    }
    sectionLinks {
      name
      itemUrl
    }
  }
  content {
    name
    content {
      contentType
      bannerName
      bgTitle
      title
      slug
      isExpandable
      subTitle
      terms
      rollingBanner {
        bannerName
        callToActionText
        callToActionLink
        heading
        callToActionSecondaryText
        callToActionLinkSecondary
        channelOrSponsorLogos {
          url
          text
        }
        detailParagraph
        copyrightParagraph
        heroImageMobile {
          url
          text
        }
        heroImage {
          url
          text
        }
        brightCoveVideoId
        brightCoveVideoIdMobile
      }
      bannerContent {
        bannerName
        heading
        detailParagraph
        copyrightParagraph
        callToActionText
        callToActionLink
        callToActionSecondaryText
        callToActionLinkSecondary
        channelOrSponsorLogos {
          url
          text
        }
        detailParagraph
        copyrightParagraph
        heroImage {
          url
          text
        }
        heroImageMobile {
          url
          text
        }
        channelOrSponsorLogos {
          url
          text
        }
        brightCoveVideoId
        brightCoveVideoIdMobile
      }
      componentCardSectionTitle
      componentCardDisplayTile
      isCarousel
      componentCards {
        contentType
        internalName
        linkUrl
        linkText
        heading
        cardImageLinkUrl
        cardTitle
        cardDescription
        cardDetailedDescription
        cardImageUrl {
          url
          text
        }
        links {
          internalName
          linkText
          linkUrl
          linkDocument {
            url
            text
          }
        }
        isSlider
        popupcards {
          internalName
          popupCardImageURL
          popupCardSubTitle
          popupCardTitle
          popupCardDescription
          popupCardIconURL
          linkUrl
          linkText
        }
      }
    }
  }
}
    `;
export const CustomerFragmentDoc = gql`
    fragment Customer on Customer {
  accountNumber
  type
  category
  tuiAddressCode
  privacyList
  serviceAddress
  fusionRegion
  houseNumber
}
    `;
export const MenuListFragmentDoc = gql`
    fragment MenuList on MenuList {
  internalName
  menuSections {
    name
    itemUrl
  }
}
    `;
export const OffersFragmentDoc = gql`
    fragment Offers on Offer {
  accountNumber
  subscriberKey
  tenure
  offers {
    eligibleFor
    priority
    qualifies
    campaign
    discountServiceCode
    campaignDescription
    additionalPackages
    offerPackages
    applies
    overrideCurrentOffer
    eligibilityID
    displayPromptOffer
    production
    recordType
    validToDate
    client
    category
    promotion
  }
}
    `;
export const OrderConfirmationFragmentDoc = gql`
    fragment OrderConfirmation on OrderConfirmation {
  title
  header
  category
  buttonCtaName
  buttonLink
  description
  iconSrc {
    url
    text
  }
  iconMobileSrc {
    url
    text
  }
  appLogoLargeSrc {
    url
    text
  }
  appLogoSmallSrc {
    url
    text
  }
}
    `;
export const ProductCardFragmentDoc = gql`
    fragment ProductCard on ProductCards {
  title
  titleLogo {
    text
    url
  }
  description
  detailsList
  iconList {
    text
    url
  }
  iconListCaption
  lozengeText
  occurrenceType
  price
  acquistionOfferPrice
  upgradeOfferPrice
  priceFrequencyType
  discountText
  productSet
  bgColor
  promoted
  sku
  termsAndConditionsCaption
  thumbnail {
    text
    url
  }
  type
  addLink
  detailsLink
  copyrightText
  ctaName
}
    `;
export const ProfileFragmentDoc = gql`
    fragment Profile on Profile {
  accountNumber
  email
  profileId
  firstName
  groups
  displayName
  lastName
  parentalControlEnabled
  parentalPin
  associated
}
    `;
export const PromoCardFragmentDoc = gql`
    fragment PromoCard on PromoCard {
  title
  campaign
  imageSrc {
    url
    text
  }
  subtitle
  subDescription
  disclaimer
  lozengeText
  fromPrice
  discountedPrice
  discountText
  billingFrequency
  type
  termsAndConditions
  bgColor
  sku
  copyrightText
  eligibleFor
  eligibilityIncludeServiceCode
  eligibilityExcludeServiceCode
  eligibilityIncludeCampaign
  eligibilityExcludeCampaign
  subscriberKey
  coupon {
    id
    name
    couponCode
    custom1
    custom2
    custom3
    custom4
    custom5
    description
  }
  CTAButtonLabel
  CTAButtonUrl
}
    `;
export const TermsAndConditionsFragmentDoc = gql`
    fragment TermsAndConditions on TermsAndConditions {
  internalName
  internalName
  slug
  bgTitle
  subTitle
  isExpandable
  title
  terms
}
    `;
export const MenuSectionListFragmentDoc = gql`
    fragment MenuSectionList on MenuSectionList {
  sectionName
  sectionLinks {
    internalName
    name
    itemUrl
  }
}
    `;
export const WorkOrderFragmentDoc = gql`
    fragment WorkOrder on WorkOrder {
  isUserHasCablePendingWorkorder
  isVTVHasMigratePendingWorkOrder
  isUserHasBroadbandWorkorderOrCompleted
}
    `;
export const GetAddressDetailsDocument = gql`
    query GetAddressDetails($id: String!) {
  getAddressDetails(id: $id) {
    address_id
    address
    street_number
    street
    streetType
    suburb
    city
    country
    postalCode
  }
}
    `;

/**
 * __useGetAddressDetailsQuery__
 *
 * To run a query within a React component, call `useGetAddressDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAddressDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetAddressDetailsQuery, GetAddressDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddressDetailsQuery, GetAddressDetailsQueryVariables>(GetAddressDetailsDocument, options);
      }
export function useGetAddressDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddressDetailsQuery, GetAddressDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddressDetailsQuery, GetAddressDetailsQueryVariables>(GetAddressDetailsDocument, options);
        }
export type GetAddressDetailsQueryHookResult = ReturnType<typeof useGetAddressDetailsQuery>;
export type GetAddressDetailsLazyQueryHookResult = ReturnType<typeof useGetAddressDetailsLazyQuery>;
export type GetAddressDetailsQueryResult = Apollo.QueryResult<GetAddressDetailsQuery, GetAddressDetailsQueryVariables>;
export const GetCardContainerDocument = gql`
    query GetCardContainer($usePreview: Boolean) {
  cardContainer(usePreview: $usePreview) {
    ...CardContainer
  }
}
    ${CardContainerFragmentDoc}`;

/**
 * __useGetCardContainerQuery__
 *
 * To run a query within a React component, call `useGetCardContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardContainerQuery({
 *   variables: {
 *      usePreview: // value for 'usePreview'
 *   },
 * });
 */
export function useGetCardContainerQuery(baseOptions?: Apollo.QueryHookOptions<GetCardContainerQuery, GetCardContainerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCardContainerQuery, GetCardContainerQueryVariables>(GetCardContainerDocument, options);
      }
export function useGetCardContainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCardContainerQuery, GetCardContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCardContainerQuery, GetCardContainerQueryVariables>(GetCardContainerDocument, options);
        }
export type GetCardContainerQueryHookResult = ReturnType<typeof useGetCardContainerQuery>;
export type GetCardContainerLazyQueryHookResult = ReturnType<typeof useGetCardContainerLazyQuery>;
export type GetCardContainerQueryResult = Apollo.QueryResult<GetCardContainerQuery, GetCardContainerQueryVariables>;
export const ComponentCardSectionDocument = gql`
    query ComponentCardSection($usePreview: Boolean, $sectionName: String) {
  ComponentCardSection(usePreview: $usePreview, sectionName: $sectionName) {
    ...ComponentCardSection
  }
}
    ${ComponentCardSectionFragmentDoc}`;

/**
 * __useComponentCardSectionQuery__
 *
 * To run a query within a React component, call `useComponentCardSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useComponentCardSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComponentCardSectionQuery({
 *   variables: {
 *      usePreview: // value for 'usePreview'
 *      sectionName: // value for 'sectionName'
 *   },
 * });
 */
export function useComponentCardSectionQuery(baseOptions?: Apollo.QueryHookOptions<ComponentCardSectionQuery, ComponentCardSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComponentCardSectionQuery, ComponentCardSectionQueryVariables>(ComponentCardSectionDocument, options);
      }
export function useComponentCardSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComponentCardSectionQuery, ComponentCardSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComponentCardSectionQuery, ComponentCardSectionQueryVariables>(ComponentCardSectionDocument, options);
        }
export type ComponentCardSectionQueryHookResult = ReturnType<typeof useComponentCardSectionQuery>;
export type ComponentCardSectionLazyQueryHookResult = ReturnType<typeof useComponentCardSectionLazyQuery>;
export type ComponentCardSectionQueryResult = Apollo.QueryResult<ComponentCardSectionQuery, ComponentCardSectionQueryVariables>;
export const GetComposePageDocument = gql`
    query GetComposePage($usePreview: Boolean, $slug: String) {
  composePage(usePreview: $usePreview, slug: $slug) {
    ...ComposePage
  }
}
    ${ComposePageFragmentDoc}`;

/**
 * __useGetComposePageQuery__
 *
 * To run a query within a React component, call `useGetComposePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComposePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComposePageQuery({
 *   variables: {
 *      usePreview: // value for 'usePreview'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetComposePageQuery(baseOptions?: Apollo.QueryHookOptions<GetComposePageQuery, GetComposePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetComposePageQuery, GetComposePageQueryVariables>(GetComposePageDocument, options);
      }
export function useGetComposePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetComposePageQuery, GetComposePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetComposePageQuery, GetComposePageQueryVariables>(GetComposePageDocument, options);
        }
export type GetComposePageQueryHookResult = ReturnType<typeof useGetComposePageQuery>;
export type GetComposePageLazyQueryHookResult = ReturnType<typeof useGetComposePageLazyQuery>;
export type GetComposePageQueryResult = Apollo.QueryResult<GetComposePageQuery, GetComposePageQueryVariables>;
export const GetEligibilityOffersDocument = gql`
    query GetEligibilityOffers($version: String) {
  offers(version: $version) {
    ...Offers
  }
}
    ${OffersFragmentDoc}`;

/**
 * __useGetEligibilityOffersQuery__
 *
 * To run a query within a React component, call `useGetEligibilityOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEligibilityOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEligibilityOffersQuery({
 *   variables: {
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetEligibilityOffersQuery(baseOptions?: Apollo.QueryHookOptions<GetEligibilityOffersQuery, GetEligibilityOffersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEligibilityOffersQuery, GetEligibilityOffersQueryVariables>(GetEligibilityOffersDocument, options);
      }
export function useGetEligibilityOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEligibilityOffersQuery, GetEligibilityOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEligibilityOffersQuery, GetEligibilityOffersQueryVariables>(GetEligibilityOffersDocument, options);
        }
export type GetEligibilityOffersQueryHookResult = ReturnType<typeof useGetEligibilityOffersQuery>;
export type GetEligibilityOffersLazyQueryHookResult = ReturnType<typeof useGetEligibilityOffersLazyQuery>;
export type GetEligibilityOffersQueryResult = Apollo.QueryResult<GetEligibilityOffersQuery, GetEligibilityOffersQueryVariables>;
export const GetMenuListItemDocument = gql`
    query GetMenuListItem($usePreview: Boolean, $tags: String) {
  MenuList(usePreview: $usePreview, tags: $tags) {
    ...MenuList
  }
}
    ${MenuListFragmentDoc}`;

/**
 * __useGetMenuListItemQuery__
 *
 * To run a query within a React component, call `useGetMenuListItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuListItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuListItemQuery({
 *   variables: {
 *      usePreview: // value for 'usePreview'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useGetMenuListItemQuery(baseOptions?: Apollo.QueryHookOptions<GetMenuListItemQuery, GetMenuListItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuListItemQuery, GetMenuListItemQueryVariables>(GetMenuListItemDocument, options);
      }
export function useGetMenuListItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuListItemQuery, GetMenuListItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuListItemQuery, GetMenuListItemQueryVariables>(GetMenuListItemDocument, options);
        }
export type GetMenuListItemQueryHookResult = ReturnType<typeof useGetMenuListItemQuery>;
export type GetMenuListItemLazyQueryHookResult = ReturnType<typeof useGetMenuListItemLazyQuery>;
export type GetMenuListItemQueryResult = Apollo.QueryResult<GetMenuListItemQuery, GetMenuListItemQueryVariables>;
export const GetMoreChoicesForYouDocument = gql`
    query GetMoreChoicesForYou($usePreview: Boolean, $version: String) {
  productsCards(usePreview: $usePreview) {
    ...ProductCard
  }
  promoCards(usePreview: $usePreview, version: $version) {
    ...PromoCard
  }
}
    ${ProductCardFragmentDoc}
${PromoCardFragmentDoc}`;

/**
 * __useGetMoreChoicesForYouQuery__
 *
 * To run a query within a React component, call `useGetMoreChoicesForYouQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMoreChoicesForYouQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMoreChoicesForYouQuery({
 *   variables: {
 *      usePreview: // value for 'usePreview'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetMoreChoicesForYouQuery(baseOptions?: Apollo.QueryHookOptions<GetMoreChoicesForYouQuery, GetMoreChoicesForYouQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMoreChoicesForYouQuery, GetMoreChoicesForYouQueryVariables>(GetMoreChoicesForYouDocument, options);
      }
export function useGetMoreChoicesForYouLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMoreChoicesForYouQuery, GetMoreChoicesForYouQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMoreChoicesForYouQuery, GetMoreChoicesForYouQueryVariables>(GetMoreChoicesForYouDocument, options);
        }
export type GetMoreChoicesForYouQueryHookResult = ReturnType<typeof useGetMoreChoicesForYouQuery>;
export type GetMoreChoicesForYouLazyQueryHookResult = ReturnType<typeof useGetMoreChoicesForYouLazyQuery>;
export type GetMoreChoicesForYouQueryResult = Apollo.QueryResult<GetMoreChoicesForYouQuery, GetMoreChoicesForYouQueryVariables>;
export const GetOrderConfirmationDocument = gql`
    query GetOrderConfirmation($usePreview: Boolean) {
  orderConfirmation(usePreview: $usePreview) {
    ...OrderConfirmation
  }
}
    ${OrderConfirmationFragmentDoc}`;

/**
 * __useGetOrderConfirmationQuery__
 *
 * To run a query within a React component, call `useGetOrderConfirmationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderConfirmationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderConfirmationQuery({
 *   variables: {
 *      usePreview: // value for 'usePreview'
 *   },
 * });
 */
export function useGetOrderConfirmationQuery(baseOptions?: Apollo.QueryHookOptions<GetOrderConfirmationQuery, GetOrderConfirmationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderConfirmationQuery, GetOrderConfirmationQueryVariables>(GetOrderConfirmationDocument, options);
      }
export function useGetOrderConfirmationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderConfirmationQuery, GetOrderConfirmationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderConfirmationQuery, GetOrderConfirmationQueryVariables>(GetOrderConfirmationDocument, options);
        }
export type GetOrderConfirmationQueryHookResult = ReturnType<typeof useGetOrderConfirmationQuery>;
export type GetOrderConfirmationLazyQueryHookResult = ReturnType<typeof useGetOrderConfirmationLazyQuery>;
export type GetOrderConfirmationQueryResult = Apollo.QueryResult<GetOrderConfirmationQuery, GetOrderConfirmationQueryVariables>;
export const GetProductCardsDocument = gql`
    query GetProductCards {
  productsCards {
    ...ProductCard
  }
}
    ${ProductCardFragmentDoc}`;

/**
 * __useGetProductCardsQuery__
 *
 * To run a query within a React component, call `useGetProductCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductCardsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductCardsQuery, GetProductCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductCardsQuery, GetProductCardsQueryVariables>(GetProductCardsDocument, options);
      }
export function useGetProductCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductCardsQuery, GetProductCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductCardsQuery, GetProductCardsQueryVariables>(GetProductCardsDocument, options);
        }
export type GetProductCardsQueryHookResult = ReturnType<typeof useGetProductCardsQuery>;
export type GetProductCardsLazyQueryHookResult = ReturnType<typeof useGetProductCardsLazyQuery>;
export type GetProductCardsQueryResult = Apollo.QueryResult<GetProductCardsQuery, GetProductCardsQueryVariables>;
export const GetTermsConditionsDocument = gql`
    query GetTermsConditions($usePreview: Boolean, $slug: String) {
  termsconditions(usePreview: $usePreview, slug: $slug) {
    ...TermsAndConditions
  }
}
    ${TermsAndConditionsFragmentDoc}`;

/**
 * __useGetTermsConditionsQuery__
 *
 * To run a query within a React component, call `useGetTermsConditionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTermsConditionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTermsConditionsQuery({
 *   variables: {
 *      usePreview: // value for 'usePreview'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetTermsConditionsQuery(baseOptions?: Apollo.QueryHookOptions<GetTermsConditionsQuery, GetTermsConditionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTermsConditionsQuery, GetTermsConditionsQueryVariables>(GetTermsConditionsDocument, options);
      }
export function useGetTermsConditionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTermsConditionsQuery, GetTermsConditionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTermsConditionsQuery, GetTermsConditionsQueryVariables>(GetTermsConditionsDocument, options);
        }
export type GetTermsConditionsQueryHookResult = ReturnType<typeof useGetTermsConditionsQuery>;
export type GetTermsConditionsLazyQueryHookResult = ReturnType<typeof useGetTermsConditionsLazyQuery>;
export type GetTermsConditionsQueryResult = Apollo.QueryResult<GetTermsConditionsQuery, GetTermsConditionsQueryVariables>;
export const GetMenuSectionListDocument = gql`
    query GetMenuSectionList($usePreview: Boolean) {
  MenuSectionList(usePreview: $usePreview) {
    ...MenuSectionList
  }
}
    ${MenuSectionListFragmentDoc}`;

/**
 * __useGetMenuSectionListQuery__
 *
 * To run a query within a React component, call `useGetMenuSectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuSectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuSectionListQuery({
 *   variables: {
 *      usePreview: // value for 'usePreview'
 *   },
 * });
 */
export function useGetMenuSectionListQuery(baseOptions?: Apollo.QueryHookOptions<GetMenuSectionListQuery, GetMenuSectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuSectionListQuery, GetMenuSectionListQueryVariables>(GetMenuSectionListDocument, options);
      }
export function useGetMenuSectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuSectionListQuery, GetMenuSectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuSectionListQuery, GetMenuSectionListQueryVariables>(GetMenuSectionListDocument, options);
        }
export type GetMenuSectionListQueryHookResult = ReturnType<typeof useGetMenuSectionListQuery>;
export type GetMenuSectionListLazyQueryHookResult = ReturnType<typeof useGetMenuSectionListLazyQuery>;
export type GetMenuSectionListQueryResult = Apollo.QueryResult<GetMenuSectionListQuery, GetMenuSectionListQueryVariables>;
export const GetUserInformationDocument = gql`
    query GetUserInformation($version: String) {
  billing(version: $version) {
    ...Billing
  }
  profile {
    ...Profile
  }
  customer {
    ...Customer
  }
  workOrder {
    ...WorkOrder
  }
}
    ${BillingFragmentDoc}
${ProfileFragmentDoc}
${CustomerFragmentDoc}
${WorkOrderFragmentDoc}`;

/**
 * __useGetUserInformationQuery__
 *
 * To run a query within a React component, call `useGetUserInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInformationQuery({
 *   variables: {
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetUserInformationQuery(baseOptions?: Apollo.QueryHookOptions<GetUserInformationQuery, GetUserInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserInformationQuery, GetUserInformationQueryVariables>(GetUserInformationDocument, options);
      }
export function useGetUserInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserInformationQuery, GetUserInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserInformationQuery, GetUserInformationQueryVariables>(GetUserInformationDocument, options);
        }
export type GetUserInformationQueryHookResult = ReturnType<typeof useGetUserInformationQuery>;
export type GetUserInformationLazyQueryHookResult = ReturnType<typeof useGetUserInformationLazyQuery>;
export type GetUserInformationQueryResult = Apollo.QueryResult<GetUserInformationQuery, GetUserInformationQueryVariables>;
export const SearchAddressDocument = gql`
    query SearchAddress($query: String!, $count: Float!) {
  searchAddress(query: $query, count: $count) {
    address_id
    address
  }
}
    `;

/**
 * __useSearchAddressQuery__
 *
 * To run a query within a React component, call `useSearchAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAddressQuery({
 *   variables: {
 *      query: // value for 'query'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useSearchAddressQuery(baseOptions: Apollo.QueryHookOptions<SearchAddressQuery, SearchAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAddressQuery, SearchAddressQueryVariables>(SearchAddressDocument, options);
      }
export function useSearchAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAddressQuery, SearchAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAddressQuery, SearchAddressQueryVariables>(SearchAddressDocument, options);
        }
export type SearchAddressQueryHookResult = ReturnType<typeof useSearchAddressQuery>;
export type SearchAddressLazyQueryHookResult = ReturnType<typeof useSearchAddressLazyQuery>;
export type SearchAddressQueryResult = Apollo.QueryResult<SearchAddressQuery, SearchAddressQueryVariables>;